import * as React from 'react';
import React__default, { useState, useMemo, useEffect, useContext, useCallback, useRef, useLayoutEffect } from 'react';
import { DesignTokens, ParticleDesignVersions, DesignVersionProvider, pancakeTheme, SpacerHorizontal, Typography, SpacerVertical, TitlePrimary, TitleSecondary, ParagraphSecondary, IllustrationErrorExplodingBalloon, IllustrationSuccess, ButtonPrimary, Loader, Field as Field$2, ButtonRoundPrimary, IconClose, constants, Strong, ActionIconClose, IconWarning, IconError, IconEnvelope, IconSocialMedia, TouchableIcon, ButtonRoundQuaternary, DialogUnwrapped, AlertBannerError, ButtonTertiary, ButtonSecondary, ActionIconArrowLeft, ActionIconArrowRight, TitleTertiary, IconCheckmark, IconChevronRight, FieldSimple, ActionIconChevronBottom, SelectorActionsheet, Separator, Link, SelectorOptionsMulti, SelectorOptions, LinkSecondary, ButtonQuaternary, ParagraphTertiary, Avatar, ActionIconMinus, ActionIconCheckmark, InformationBlockLabelDefault, InformationBlockLabelWarning, InformationBlockLabelError, InformationBlockLabelSuccess, InformationBlockLabelAltOverlay, InformationBlockLabelAlt, IconInformation, ActionIconChevronTop } from '@klarna/bubble-ui';
import { splitEvery, mergeDeepRight, remove, isEmpty, repeat } from 'ramda';
import styled, { keyframes, css } from 'styled-components';
import * as ReactDOM from 'react-dom';
import FocusTrap from 'focus-trap-react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var sizeConst$1 = DesignTokens.sizeConst;
/**
 * Breakpoint tokens
 *
 * Desktop (XL):    1637 and above
 * Laptop  (L):     1201 - 1636
 * Tablet  (M):     741 - 1200
 * Mobile  (S):     420 - 740
 *
 */
var marbleBreakpointTokens = {
    "breakpoint/xl": sizeConst$1(1637),
    "breakpoint/l": sizeConst$1(1201),
    "breakpoint/m": sizeConst$1(741),
    "breakpoint/s": sizeConst$1(420)
};

/**
 * Marble Framework values
 *
 * Main margins
 *
 * xl-desktop (xl)        120px
 * desktop (l)             80px
 * tablet (m)              48px
 * mobile (s)              24px
 *
 */
var referenceForwardArgs$1 = DesignTokens.referenceForwardArgs;
var frameworkTokens = {
    "framework/main/margin/xl": referenceForwardArgs$1("space.1500"),
    "framework/main/margin/l": referenceForwardArgs$1("space.1000"),
    "framework/main/margin/m": referenceForwardArgs$1("space.600"),
    "framework/main/margin/s": referenceForwardArgs$1("space.300")
};

/**
 * Marble Layout Grid values
 *
 * Gutter
 *
 * xl-desktop (xl): 24 (space.300)
 * desktop (l):     16 (space.200)
 * tablet (m):      16 (space.200)
 * mobile (s):       8 (space.unit)
 *
 */
var referenceForwardArgs = DesignTokens.referenceForwardArgs;
var layoutTokens = {
    "layout/grid/gutter/xl": referenceForwardArgs("space.300"),
    "layout/grid/gutter/l": referenceForwardArgs("space.200"),
    "layout/grid/gutter/m": referenceForwardArgs("space.200"),
    "layout/grid/gutter/s": referenceForwardArgs("space.unit")
};

/**
 * Adds extra token in Marble for the framework
 * margins in XL Desktop (120px)
 */
var sizeConst = DesignTokens.sizeConst;
var spaceTokens = {
    "space.1500": sizeConst(120)
};

var Themes;
(function (Themes) {
    Themes["Marble"] = "marble";
    Themes["MarbleDark"] = "marbleDark";
})(Themes || (Themes = {}));
var DEFAULT_THEME = Themes.Marble;
var UIThemeContext = React__default.createContext({
    setTheme: function () { return undefined; }
});
UIThemeContext.displayName = "UIThemeContext";
var selectTheme = function (theme) {
    switch (theme) {
        case Themes.Marble: {
            return __assign(__assign(__assign(__assign(__assign({}, pancakeTheme()), spaceTokens), marbleBreakpointTokens), frameworkTokens), layoutTokens);
        }
        case Themes.MarbleDark: {
            return __assign(__assign(__assign(__assign(__assign({}, pancakeTheme(true)), spaceTokens), marbleBreakpointTokens), frameworkTokens), layoutTokens);
        }
    }
};
function UIThemeProvider(_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? DEFAULT_THEME : _b;
    var _c = useState(DEFAULT_THEME), themeValue = _c[0], setTheme = _c[1];
    var tokens = useMemo(function () { return selectTheme(themeValue); }, [themeValue]);
    var designVersion = themeValue === Themes.Marble
        ? ParticleDesignVersions.PANCAKE_LIGHT
        : ParticleDesignVersions.NEXT;
    useEffect(function () {
        if (themeValue !== theme) {
            setTheme(theme);
        }
    }, [theme]);
    return (React__default.createElement(UIThemeContext.Provider, { value: { theme: themeValue, setTheme: setTheme } },
        React__default.createElement(DesignVersionProvider, { value: designVersion },
            React__default.createElement(DesignTokens.DesignContextProvider, { tokens: tokens }, children))));
}
function useUIThemeContext() {
    return useContext(UIThemeContext);
}
// Returns bubble's design context objects
function useDesignContext() {
    var ctx = useContext(UIThemeContext);
    var designContext = DesignTokens.useDesignContext((ctx === null || ctx === void 0 ? void 0 : ctx.theme) ? undefined : selectTheme(DEFAULT_THEME));
    return designContext;
}
// Returns a token from the designContext object
function useGetToken(token, args) {
    return useDesignContext().get(token, args);
}

function useThemeBreakpoints() {
    var extraLarge = useGetToken("breakpoint/xl").value();
    var large = useGetToken("breakpoint/l").value();
    var medium = useGetToken("breakpoint/m").value();
    return useMemo(function () { return ({
        desktopXl: {
            min: extraLarge
        },
        desktop: {
            min: large,
            max: extraLarge - 1
        },
        tablet: {
            min: medium,
            max: large - 1
        },
        mobile: {
            max: medium - 1
        }
    }); }, [extraLarge, large, medium]);
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var propTypes$2 = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$2.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$2.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes$2.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

var ResponsiveContext = React__default.createContext({});

function ResponsiveContextConsumer(_a) {
    var children = _a.children;
    return (React__default.createElement(ResponsiveContext.Consumer, null, function (context) {
        if (context === undefined) {
            throw new Error("CountConsumer must be used within a CountProvider");
        }
        return children(context);
    }));
}
ResponsiveContextConsumer.propTypes = {
    children: PropTypes.func.isRequired
};

var getMatchMedia = function (_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, min = _c.min, max = _c.max;
    var query = "screen ";
    if (min) {
        query += "and (min-width: ".concat(min, "px) ");
    }
    if (max) {
        query += "and (max-width: ".concat(max, "px)");
    }
    return (_b = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _b === void 0 ? void 0 : _b.call(window, "".concat(query));
};
var addMediaEventListener = function (mediaQueryList, handler) {
    if (mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.addEventListener) {
        mediaQueryList.addEventListener("change", handler);
        return;
    }
    mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.addListener(handler);
};
var removeMediaEventListener = function (mediaQueryList, handler) {
    if (mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener("change", handler);
        return;
    }
    mediaQueryList === null || mediaQueryList === void 0 ? void 0 : mediaQueryList.removeListener(handler);
};
var useClientViewport = function (breakpoints) {
    var mobileMediaQuery = getMatchMedia(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.mobile);
    var tabletMediaQuery = getMatchMedia(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.tablet);
    var desktopQuery = getMatchMedia(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.desktop);
    var desktopXLQuery = getMatchMedia(breakpoints === null || breakpoints === void 0 ? void 0 : breakpoints.desktopXl);
    var _a = useState({
        isMobile: mobileMediaQuery === null || mobileMediaQuery === void 0 ? void 0 : mobileMediaQuery.matches,
        isTablet: tabletMediaQuery === null || tabletMediaQuery === void 0 ? void 0 : tabletMediaQuery.matches,
        isDesktop: (desktopQuery === null || desktopQuery === void 0 ? void 0 : desktopQuery.matches) || (desktopXLQuery === null || desktopXLQuery === void 0 ? void 0 : desktopXLQuery.matches),
        isXLDesktop: desktopXLQuery === null || desktopXLQuery === void 0 ? void 0 : desktopXLQuery.matches
    }), clientViewport = _a[0], setClientViewport = _a[1];
    var mediaQueryHandler = useCallback(function (screen) {
        return function (e) {
            var _a;
            var matches = e.matches;
            if (screen === "isXLDesktop" && matches) {
                return setClientViewport({
                    isMobile: false,
                    isTablet: false,
                    isDesktop: true,
                    isXLDesktop: true
                });
            }
            else if (matches) {
                return setClientViewport((_a = {
                        isMobile: false,
                        isTablet: false,
                        isDesktop: false,
                        isXLDesktop: false
                    },
                    _a[screen] = true,
                    _a));
            }
        };
    }, [setClientViewport]);
    var mobileMediaChange = useCallback(mediaQueryHandler("isMobile"), [
        mediaQueryHandler
    ]);
    var tabletMediaChange = useCallback(mediaQueryHandler("isTablet"), [
        mediaQueryHandler
    ]);
    var desktopMediaChange = useCallback(mediaQueryHandler("isDesktop"), [
        mediaQueryHandler
    ]);
    var desktopXlMediaChange = useCallback(mediaQueryHandler("isXLDesktop"), [
        mediaQueryHandler
    ]);
    useEffect(function () {
        addMediaEventListener(mobileMediaQuery, mobileMediaChange);
        addMediaEventListener(tabletMediaQuery, tabletMediaChange);
        addMediaEventListener(desktopQuery, desktopMediaChange);
        addMediaEventListener(desktopXLQuery, desktopXlMediaChange);
        return function () {
            removeMediaEventListener(mobileMediaQuery, mobileMediaChange);
            removeMediaEventListener(tabletMediaQuery, tabletMediaChange);
            removeMediaEventListener(desktopQuery, desktopMediaChange);
            removeMediaEventListener(desktopXLQuery, desktopXlMediaChange);
        };
    }, [
        addMediaEventListener,
        removeMediaEventListener,
        mobileMediaQuery,
        tabletMediaQuery,
        desktopQuery,
        desktopXLQuery
    ]);
    return useMemo(function () { return clientViewport; }, [clientViewport]);
};

var ResponsiveContextProvider = function (_a) {
    var breakpoints = _a.breakpoints, children = _a.children;
    var viewport = useClientViewport(breakpoints);
    return useMemo(function () { return (React__default.createElement(ResponsiveContext.Provider, { value: viewport }, children)); }, [children, viewport]);
};
var minMaxProp = PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
});
ResponsiveContextProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    breakpoints: PropTypes.shape({
        tablet: minMaxProp,
        desktop: minMaxProp,
        desktopXl: minMaxProp
    })
};

var ResponsiveContextProviderDemo = function (_a) {
    var children = _a.children;
    var breakpoints = useThemeBreakpoints();
    return (React__default.createElement(ResponsiveContextProvider, { breakpoints: breakpoints }, children));
};

var zIndex = {
    environmentId: { border: 110, tag: 111 },
    floatingContainer: 900,
    overlay: 107,
    sidebar: 108,
    tooltip: 1000,
    topBar: 100
};
var realBlack = "#000";
var realBlackRGBA = {
    alpha: 1,
    blue: 0,
    green: 0,
    red: 0
};

var index$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    zIndex: zIndex,
    realBlack: realBlack,
    realBlackRGBA: realBlackRGBA
});

/**
 * Replacement for elegir to simplify nested if/else statement
 */
var choose = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length % 2 !== 0) {
        throw new EvalError("Must have even number of arguments, got ".concat(args.length));
    }
    var chunks = splitEvery(2, args);
    var firstMatch = chunks.find(function (_a) {
        var condition = _a[0]; _a[1];
        return Boolean(condition);
    });
    return firstMatch ? firstMatch[1] : undefined;
};
/**
 * Return children after appending props to them.
 */
var appendPropsToChildren = function (children, props) {
    return React__default.Children.map(children, function (child) {
        return child && React__default.cloneElement(child, mergeDeepRight(child === null || child === void 0 ? void 0 : child.props, props));
    });
};
/**
 * Used to translate numbers into a valid CSS width string,
 * ie `{val}px` for numbers or the provided string as-is.
 */
var getCSSWidth = function (val) {
    if (typeof val === "number") {
        return "".concat(val, "px");
    }
    return val;
};
// Converts color object to rgba string
var toRgba = function (color, overrideAlpha) {
    var _a;
    var red = color.red, blue = color.blue, green = color.green, alpha = color.alpha;
    var alphaValue = (_a = overrideAlpha !== null && overrideAlpha !== void 0 ? overrideAlpha : alpha) !== null && _a !== void 0 ? _a : 1;
    return "rgba(".concat(red, ",").concat(green, ",").concat(blue, ",").concat(alphaValue, ")");
};
var useCornerRadius = function (size) {
    var token = "corner-radius/".concat(size);
    var value = useGetToken(token).value();
    return "".concat(value, "px");
};

var index$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    choose: choose,
    appendPropsToChildren: appendPropsToChildren,
    getCSSWidth: getCSSWidth,
    toRgba: toRgba,
    useCornerRadius: useCornerRadius
});

var pulsateAnimation = keyframes(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  0% { transform: scale(0.75); }\n  20% { transform: scale(0.9); }\n  40% { transform: scale(0.85); }\n  60% { transform: scale(1); }\n  100% { transform: scale(0.65); }"], ["\n  0% { transform: scale(0.75); }\n  20% { transform: scale(0.9); }\n  40% { transform: scale(0.85); }\n  60% { transform: scale(1); }\n  100% { transform: scale(0.65); }"])));
var PulseAnimationOutter = styled.div(function (_a) {
    var background = _a.background;
    return css(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n    animation-duration: 2s;\n    animation-name: ", ";\n    animation-iteration-count: infinite;\n    animation-timing-function: ease-out;\n    background: ", ";\n    border-radius: ", ";\n    height: 22px;\n    left: -1px;\n    position: absolute;\n    top: -1px;\n    width: 22px;\n  "], ["\n    animation-duration: 2s;\n    animation-name: ", ";\n    animation-iteration-count: infinite;\n    animation-timing-function: ease-out;\n    background: ", ";\n    border-radius: ", ";\n    height: 22px;\n    left: -1px;\n    position: absolute;\n    top: -1px;\n    width: 22px;\n  "])), pulsateAnimation, background, useCornerRadius("round"));
});
var PulseAnimationInner = styled.div(function (_a) {
    var background = _a.background, border = _a.border;
    return css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n    background: ", ";\n    border: solid 2px;\n    border-color: ", ";\n    border-radius: ", ";\n    box-sizing: content-box;\n    height: 8px;\n    left: 4px;\n    position: absolute;\n    top: 4px;\n    width: 8px;\n    z-index: 2;\n  "], ["\n    background: ", ";\n    border: solid 2px;\n    border-color: ", ";\n    border-radius: ", ";\n    box-sizing: content-box;\n    height: 8px;\n    left: 4px;\n    position: absolute;\n    top: 4px;\n    width: 8px;\n    z-index: 2;\n  "])), background, border, useCornerRadius("round"));
});
var PulseAnimationContainer = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  height: 20px;\n  min-width: 20px;\n  position: relative;\n  width: 20px;\n"], ["\n  height: 20px;\n  min-width: 20px;\n  position: relative;\n  width: 20px;\n"])));
var LabelContainer = styled.div(function (_a) {
    var border = _a.border;
    return css(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["xx\n    align-items: center;\n    border: solid 1px ", ";\n    border-radius: ", ";\n    box-sizing: border-box;\n    display: flex;\n    height: 30px;\n    padding: 5px;\n  "], ["xx\n    align-items: center;\n    border: solid 1px ", ";\n    border-radius: ", ";\n    box-sizing: border-box;\n    display: flex;\n    height: 30px;\n    padding: 5px;\n  "])), border, useCornerRadius("l"));
});
/** A tag with text with an animated activity indicator */
var ActivityIndicator = function (_a) {
    var label = _a.label;
    var designContext = useDesignContext();
    var colors = React__default.useMemo(function () {
        var subtleFloating = designContext
            .get("colors/borders/subtle-floating")
            .toString();
        var white = designContext.get("colors/borders/inverse").toString();
        var black = designContext.get("colors/backgrounds/inverse").toString();
        return {
            labelBorder: subtleFloating,
            pulseInnerBackground: black,
            pulseInnerBorder: white,
            pulseOutterBackground: subtleFloating
        };
    }, [designContext]);
    return (React__default.createElement(LabelContainer, { border: colors.labelBorder },
        React__default.createElement(PulseAnimationContainer, null,
            React__default.createElement(PulseAnimationInner, { background: colors.pulseInnerBackground, border: colors.pulseInnerBorder }),
            React__default.createElement(PulseAnimationOutter, { "data-testid": "activity-indicator__animation", background: colors.pulseOutterBackground })),
        React__default.createElement(SpacerHorizontal, { spaceToken: "space.unit" }),
        React__default.createElement("div", null,
            React__default.createElement(Typography, { accessibilityPreset: "paragraph", textToken: "text-style/text/labels/default/regular", numberOfLines: 1, colorToken: "colors/text/neutral" }, label)),
        React__default.createElement(SpacerHorizontal, { spaceToken: "space.unit" })));
};
ActivityIndicator.propTypes = {
    label: PropTypes.string.isRequired
};
var templateObject_1$e, templateObject_2$8, templateObject_3$6, templateObject_4$4, templateObject_5$4;

var getIllustration = function (illustration) {
    switch (illustration) {
        case "IllustrationSuccess":
            return React__default.createElement(IllustrationSuccess, null);
        case "IllustrationErrorExplodingBalloon":
            return React__default.createElement(IllustrationErrorExplodingBalloon, null);
        default:
            return null;
    }
};
/**
 * A layout container that handles the design requirements for spacing between title, description and illustration.
 * This removes the duplication of handling the conditional spacing required.
 */
var Article = function (_a) {
    var description = _a.description, id = _a.id, illustration = _a.illustration, title = _a.title, _b = _a.titleType, titleType = _b === void 0 ? "secondary" : _b;
    var Illustration = typeof illustration === "string"
        ? getIllustration(illustration)
        : illustration;
    return (React__default.createElement("div", { id: id },
        Illustration && React__default.createElement("div", { "data-testid": illustration }, Illustration),
        Illustration && (title || description) && (React__default.createElement(SpacerVertical, { spaceToken: "space.500" })),
        title && titleType === "primary" && (React__default.createElement(TitlePrimary, { correctFootprint: true }, title)),
        title && titleType === "secondary" && (React__default.createElement(TitlePrimary, { small: true, correctFootprint: true }, title)),
        title && titleType === "tertiary" && (React__default.createElement(TitleSecondary, { correctFootprint: true }, title)),
        title && description && (React__default.createElement(SpacerVertical, { spaceToken: titleType === "primary" ? "space.400" : "space.300" })),
        description && (React__default.createElement(ParagraphSecondary, { correctFootprint: true }, description))));
};
Article.propTypes = {
    description: PropTypes.string,
    illustration: PropTypes.oneOfType([
        PropTypes.oneOf([
            "IllustrationSuccess",
            "IllustrationErrorExplodingBalloon"
        ]),
        PropTypes.element
    ]),
    title: PropTypes.string,
    titleType: PropTypes.oneOf(["primary", "secondary", "tertiary"])
};
var Article$1 = React__default.memo(Article);

function isFunction(value) {
    return typeof value === 'function';
}

function createErrorClass(createImpl) {
    var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

var UnsubscriptionError = createErrorClass(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
            : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

var Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            var initialFinalizer = this.initialTeardown;
            if (isFunction(initialFinalizer)) {
                try {
                    initialFinalizer();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [e];
                }
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        }
                        catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof UnsubscriptionError) {
                                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    };
    Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            arrRemove(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    })();
    return Subscription;
}());
Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription ||
        (value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe)));
}
function execFinalizer(finalizer) {
    if (isFunction(finalizer)) {
        finalizer();
    }
    else {
        finalizer.unsubscribe();
    }
}

var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false,
};

var timeoutProvider = {
    setTimeout: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
            return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout], __read(args)));
        }
        return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearTimeout: function (handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined,
};

function reportUnhandledError(err) {
    timeoutProvider.setTimeout(function () {
        {
            throw err;
        }
    });
}

function noop() { }

function errorContext(cb) {
    {
        cb();
    }
}

var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if (isSubscription(destination)) {
                destination.add(_this);
            }
        }
        else {
            _this.destination = EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
        if (this.isStopped) ;
        else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function () {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    };
    return Subscriber;
}(Subscription));
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = (function () {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function (value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    ConsumerObserver.prototype.error = function (err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
        else {
            handleUnhandledError(err);
        }
    };
    ConsumerObserver.prototype.complete = function () {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    return ConsumerObserver;
}());
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined,
            };
        }
        else {
            var context_1;
            if (_this && config.useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function () { return _this.unsubscribe(); };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1),
                };
            }
            else {
                partialObserver = observerOrNext;
            }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber));
function handleUnhandledError(error) {
    {
        reportUnhandledError(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
var EMPTY_OBSERVER = {
    closed: true,
    next: noop,
    error: defaultErrorHandler,
    complete: noop,
};

var observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();

function identity(x) {
    return x;
}

function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}

var Observable = (function () {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
        errorContext(function () {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator
                ?
                    operator.call(subscriber, source)
                : source
                    ?
                        _this._subscribe(subscriber)
                    :
                        _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscriber = new SafeSubscriber({
                next: function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve,
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
}
function isSubscriber(value) {
    return (value && value instanceof Subscriber) || (isObserver(value) && isSubscription(value));
}

function hasLift(source) {
    return isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function (source) {
        if (hasLift(source)) {
            return source.lift(function (liftedSource) {
                try {
                    return init(liftedSource, this);
                }
                catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = (function (_super) {
    __extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext
            ? function (value) {
                try {
                    onNext(value);
                }
                catch (err) {
                    destination.error(err);
                }
            }
            : _super.prototype._next;
        _this._error = onError
            ? function (err) {
                try {
                    onError(err);
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._error;
        _this._complete = onComplete
            ? function () {
                try {
                    onComplete();
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
    };
    return OperatorSubscriber;
}(Subscriber));

var dateTimestampProvider = {
    now: function () {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined,
};

var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        return this;
    };
    return Action;
}(Subscription));

var intervalProvider = {
    setInterval: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
            return delegate.setInterval.apply(delegate, __spreadArray([handler, timeout], __read(args)));
        }
        return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearInterval: function (handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined,
};

var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
        if (delay === void 0) { delay = 0; }
        return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay != null && this.delay === delay && this.pending === false) {
            return id;
        }
        if (id != null) {
            intervalProvider.clearInterval(id);
        }
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function () {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            arrRemove(actions, this);
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}(Action));

var Scheduler = (function () {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = dateTimestampProvider.now;
    return Scheduler;
}());

var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions.shift()));
        this._active = false;
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler));

var asyncScheduler = new AsyncScheduler(AsyncAction);
var async = asyncScheduler;

function isScheduler(value) {
    return value && isFunction(value.schedule);
}

var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

function isPromise(value) {
    return isFunction(value === null || value === void 0 ? void 0 : value.then);
}

function isInteropObservable(input) {
    return isFunction(input[observable]);
}

function isAsyncIterable(obj) {
    return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

function isIterable(input) {
    return isFunction(input === null || input === void 0 ? void 0 : input[iterator]);
}

function readableStreamLikeToAsyncGenerator(readableStream) {
    return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 9, 10]);
                    _b.label = 2;
                case 2:
                    return [4, __await(reader.read())];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [3, 5];
                    return [4, __await(void 0)];
                case 4: return [2, _b.sent()];
                case 5: return [4, __await(value)];
                case 6: return [4, _b.sent()];
                case 7:
                    _b.sent();
                    return [3, 2];
                case 8: return [3, 10];
                case 9:
                    reader.releaseLock();
                    return [7];
                case 10: return [2];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

function innerFrom(input) {
    if (input instanceof Observable) {
        return input;
    }
    if (input != null) {
        if (isInteropObservable(input)) {
            return fromInteropObservable(input);
        }
        if (isArrayLike(input)) {
            return fromArrayLike(input);
        }
        if (isPromise(input)) {
            return fromPromise(input);
        }
        if (isAsyncIterable(input)) {
            return fromAsyncIterable(input);
        }
        if (isIterable(input)) {
            return fromIterable(input);
        }
        if (isReadableStreamLike(input)) {
            return fromReadableStreamLike(input);
        }
    }
    throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
    return new Observable(function (subscriber) {
        var obs = obj[observable]();
        if (isFunction(obs.subscribe)) {
            return obs.subscribe(subscriber);
        }
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new Observable(function (subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new Observable(function (subscriber) {
        promise
            .then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, reportUnhandledError);
    });
}
function fromIterable(iterable) {
    return new Observable(function (subscriber) {
        var e_1, _a;
        try {
            for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) {
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new Observable(function (subscriber) {
        process$1(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process$1(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return __awaiter(this, void 0, void 0, function () {
        var value, e_2_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 11]);
                    asyncIterable_1 = __asyncValues(asyncIterable);
                    _b.label = 1;
                case 1: return [4, asyncIterable_1.next()];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) {
                        return [2];
                    }
                    _b.label = 3;
                case 3: return [3, 1];
                case 4: return [3, 11];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 11];
                case 6:
                    _b.trys.push([6, , 9, 10]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
                    return [4, _a.call(asyncIterable_1)];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3, 10];
                case 9:
                    if (e_2) throw e_2.error;
                    return [7];
                case 10: return [7];
                case 11:
                    subscriber.complete();
                    return [2];
            }
        });
    });
}

function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) { delay = 0; }
    if (repeat === void 0) { repeat = false; }
    var scheduleSubscription = scheduler.schedule(function () {
        work();
        if (repeat) {
            parentSubscription.add(this.schedule(null, delay));
        }
        else {
            this.unsubscribe();
        }
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) {
        return scheduleSubscription;
    }
}

function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}

function map(project, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, __spreadArray([], __read(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return map(function (args) { return callOrApply(fn, args); });
}

function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function () {
        if (isComplete && !buffer.length && !active) {
            subscriber.complete();
        }
    };
    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
    var doInnerSub = function (value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        innerFrom(project(value, index++)).subscribe(createOperatorSubscriber(subscriber, function (innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
            if (expand) {
                outerNext(innerValue);
            }
            else {
                subscriber.next(innerValue);
            }
        }, function () {
            innerComplete = true;
        }, undefined, function () {
            if (innerComplete) {
                try {
                    active--;
                    var _loop_1 = function () {
                        var bufferedValue = buffer.shift();
                        if (innerSubScheduler) {
                            executeSchedule(subscriber, innerSubScheduler, function () { return doInnerSub(bufferedValue); });
                        }
                        else {
                            doInnerSub(bufferedValue);
                        }
                    };
                    while (buffer.length && active < concurrent) {
                        _loop_1();
                    }
                    checkComplete();
                }
                catch (err) {
                    subscriber.error(err);
                }
            }
        }));
    };
    source.subscribe(createOperatorSubscriber(subscriber, outerNext, function () {
        isComplete = true;
        checkComplete();
    }));
    return function () {
        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
    };
}

function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if (isFunction(resultSelector)) {
        return mergeMap(function (a, i) { return map(function (b, ii) { return resultSelector(a, b, i, ii); })(innerFrom(project(a, i))); }, concurrent);
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return operate(function (source, subscriber) { return mergeInternals(source, subscriber, project, concurrent); });
}

var nodeEventEmitterMethods = ['addListener', 'removeListener'];
var eventTargetMethods = ['addEventListener', 'removeEventListener'];
var jqueryMethods = ['on', 'off'];
function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs(resultSelector));
    }
    var _a = __read(isEventTarget(target)
        ? eventTargetMethods.map(function (methodName) { return function (handler) { return target[methodName](eventName, handler, options); }; })
        :
            isNodeStyleEventEmitter(target)
                ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName))
                : isJQueryStyleEventEmitter(target)
                    ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName))
                    : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if (isArrayLike(target)) {
            return mergeMap(function (subTarget) { return fromEvent(subTarget, eventName, options); })(innerFrom(target));
        }
    }
    if (!add) {
        throw new TypeError('Invalid event target');
    }
    return new Observable(function (subscriber) {
        var handler = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function () { return remove(handler); };
    });
}
function toCommonHandlerRegistry(target, eventName) {
    return function (methodName) { return function (handler) { return target[methodName](eventName, handler); }; };
}
function isNodeStyleEventEmitter(target) {
    return isFunction(target.addListener) && isFunction(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return isFunction(target.on) && isFunction(target.off);
}
function isEventTarget(target) {
    return isFunction(target.addEventListener) && isFunction(target.removeEventListener);
}

function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) { dueTime = 0; }
    if (scheduler === void 0) { scheduler = async; }
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if (isScheduler(intervalOrScheduler)) {
            scheduler = intervalOrScheduler;
        }
        else {
            intervalDuration = intervalOrScheduler;
        }
    }
    return new Observable(function (subscriber) {
        var due = isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) {
            due = 0;
        }
        var n = 0;
        return scheduler.schedule(function () {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) {
                    this.schedule(undefined, intervalDuration);
                }
                else {
                    subscriber.complete();
                }
            }
        }, due);
    });
}

function audit(durationSelector) {
    return operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function () {
            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
            isComplete && subscriber.complete();
        };
        var cleanupDuration = function () {
            durationSubscriber = null;
            isComplete && subscriber.complete();
        };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            lastValue = value;
            if (!durationSubscriber) {
                innerFrom(durationSelector(value)).subscribe((durationSubscriber = createOperatorSubscriber(subscriber, endDuration, cleanupDuration)));
            }
        }, function () {
            isComplete = true;
            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
    });
}

function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    return audit(function () { return timer(duration, scheduler); });
}

function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    return operate(function (source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function () {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function () {
            emit();
            subscriber.complete();
        }, undefined, function () {
            lastValue = activeTask = null;
        }));
    });
}

function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) { keySelector = identity; }
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return operate(function (source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function defaultCompare(a, b) {
    return a === b;
}

/**
 * A hook that simplifies adding a conditional event listener.
 *
 * If a `condition` is passed, the event listener will only be
 * added when that condition is true, and removed when its false.
 *
 * @param eventTarget The event target, like `document` or an element that triggers the event
 * @param eventListener Your event listener function
 * @param eventType The event type, like ´click´ or 'keydown
 * @param condition An optional condition to control adding/removing the listener
 */
var useConditionalEventListener = function (eventTarget, eventListener, eventType, condition) {
    if (condition === void 0) { condition = true; }
    useEffect(function () {
        if (condition) {
            eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.addEventListener(eventType, eventListener);
        }
        else {
            eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.removeEventListener(eventType, eventListener);
        }
        return function () { return eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.removeEventListener(eventType, eventListener); };
    }, [eventTarget, eventType, eventListener, condition]);
};

/** A hook that exposes the client view port so that you can respond to particular device types */
var useResponsiveContext = function () {
    var context = useContext(ResponsiveContext);
    if (context === undefined) {
        throw new Error("useResponsiveContext must be used within a ResponsiveContext Provider");
    }
    return context;
};

var overlayColors = function (designContext) { return ({
    bgColor: designContext.get("colors/backgrounds/default").toString(),
    shadowColor: toRgba(designContext.get("colors/backgrounds/inverse"), 0.2)
}); };
var getCSSValue = function (val) {
    if (typeof val === "number") {
        return "".concat(val, "px");
    }
    if (typeof val === "string") {
        return val;
    }
    return false;
};
var ContainerStyled$3 = styled.div(function (_a) {
    var isFullWidthTrigger = _a.isFullWidthTrigger, isMobile = _a.isMobile, loading = _a.loading, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth;
    return ({
        maxHeight: (!isMobile && getCSSValue(maxHeight)) || "none",
        maxWidth: getCSSValue(maxWidth) || "none",
        opacity: loading && 0.29,
        pointerEvents: loading ? "none" : "auto",
        position: "relative",
        width: (maxWidth || isFullWidthTrigger) && "100%"
    });
});
var OverlayStyled = styled.div(function (_a) {
    var colors = _a.colors, isMobile = _a.isMobile, isOpen = _a.isOpen, maxWidth = _a.maxWidth, isOutsideViewport = _a.isOutsideViewport;
    return ({
        backgroundColor: colors.bgColor,
        borderRadius: useCornerRadius("s"),
        bottom: isMobile && "10px",
        boxShadow: "".concat(colors.shadowColor, " 0px 3px 15px 0px"),
        boxSizing: "border-box",
        display: !isMobile && !isOpen ? "none" : "block",
        height: "auto",
        left: !isOutsideViewport && "0px",
        margin: isMobile && "0 15px",
        marginTop: !isMobile && "-5px",
        maxWidth: !isMobile && (getCSSValue(maxWidth) || "350px"),
        minHeight: isMobile && "120px",
        minWidth: !isMobile && "300px",
        position: isMobile ? "fixed" : "absolute",
        right: isOutsideViewport && "0px",
        transform: isMobile && "translateY(".concat(isOpen ? "0" : "calc(100% + 30px)", ")"),
        transition: isMobile && "transform 0.2s cubic-bezier(0, 1, 0.5, 1) 0.1s",
        visibility: !isMobile && !isOpen ? "hidden" : "visible",
        width: "calc(100% - ".concat(isMobile ? "30px" : "0px", ")"),
        zIndex: 20
    });
});
var ButtonSectionStyled = styled.div(function (_a) {
    var colors = _a.colors;
    return ({
        backgroundColor: colors.bgColor,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        position: "sticky"
    });
});
var ContentStyled = styled.div(function (_a) {
    var isOpen = _a.isOpen;
    return ({
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100vh - 30px)",
        opacity: isOpen ? 1 : 0,
        position: "relative",
        transition: "opacity 0.2s linear",
        userSelect: "none",
        width: "100%"
    });
});
var MainSectionStyled = styled.div(function (_a) {
    var isMobile = _a.isMobile, maxHeight = _a.maxHeight;
    return ({
        maxHeight: (!isMobile && maxHeight ? getCSSValue(maxHeight) : "455px") || "none",
        overflowX: "hidden",
        overflowY: "scroll",
        padding: "0 15px"
    });
});
var TriggerContainerStyled = styled.div(function (_a) {
    var disabled = _a.disabled, isFullWidthTrigger = _a.isFullWidthTrigger, isMobile = _a.isMobile, maxWidth = _a.maxWidth;
    var breakpointM = useGetToken("breakpoint/m").value();
    return {
        cursor: !disabled && "pointer",
        display: maxWidth || isFullWidthTrigger ? "grid" : "inline",
        maxWidth: (maxWidth && getCSSValue(maxWidth)) || (isMobile && "".concat(breakpointM, "px")),
        position: "relative",
        width: isFullWidthTrigger && "100%"
    };
});

/** A mobile friendly Overlay component, where you can set a trigger and the content */
var Overlay = React__default.forwardRef(function (overlayProps, ref) {
    var _a = overlayProps.closeLabel, closeLabel = _a === void 0 ? "Done" : _a, _b = overlayProps.children, children = _b === void 0 ? React__default.createElement("p", null, "Content") : _b, disabled = overlayProps.disabled, isFullWidthTrigger = overlayProps.isFullWidthTrigger, _c = overlayProps.id, id = _c === void 0 ? "mpui_overlay" : _c, isOpen = overlayProps.isOpen, hideCloseButton = overlayProps.hideCloseButton, maxHeight = overlayProps.maxHeight, maxWidth = overlayProps.maxWidth, _d = overlayProps.onClose, onClose = _d === void 0 ? function () { return null; } : _d, _e = overlayProps.onOpen, onOpen = _e === void 0 ? function () { return null; } : _e, disableCloseOnEscape = overlayProps.disableCloseOnEscape, disableOpenWithKeyboard = overlayProps.disableOpenWithKeyboard, disableOpenOverlayOnClick = overlayProps.disableOpenOverlayOnClick, _f = overlayProps.trigger, trigger = _f === void 0 ? React__default.createElement("p", null, "Trigger") : _f, restProps = __rest(overlayProps, ["closeLabel", "children", "disabled", "isFullWidthTrigger", "id", "isOpen", "hideCloseButton", "maxHeight", "maxWidth", "onClose", "onOpen", "disableCloseOnEscape", "disableOpenWithKeyboard", "disableOpenOverlayOnClick", "trigger"]);
    var isMobile = useResponsiveContext().isMobile;
    var _g = useState(isOpen), isOverlayOpen = _g[0], setIsOverlayOpen = _g[1];
    var _h = useState(false), isOutsideViewport = _h[0], setIsOutsideViewport = _h[1];
    var _j = useState(false), isTriggerFocused = _j[0], setIsTriggerFocused = _j[1];
    var handleTriggerFocus = useCallback(function () { return setIsTriggerFocused(true); }, []);
    var handleTriggerBlur = useCallback(function () { return setIsTriggerFocused(false); }, []);
    var designContext = useDesignContext();
    var colors = useMemo(function () { return overlayColors(designContext); }, [designContext]);
    var triggerRef = useRef(null);
    var overlayRef = useRef(null);
    var didMountIsOverlayOpen = useRef(false);
    useEffect(function () {
        var _a, _b;
        if (didMountIsOverlayOpen.current) {
            if (!disabled) {
                if (isOverlayOpen === false) {
                    onClose();
                    setIsOutsideViewport(false);
                }
                if (isOverlayOpen) {
                    onOpen();
                }
            }
        }
        else {
            didMountIsOverlayOpen.current = true;
        }
        if (isOverlayOpen) {
            // Detect if overlay is overflowing
            var overlayWidth = maxWidth || ((_a = overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width);
            if (((_b = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().left) + overlayWidth >=
                document.body.clientWidth) {
                setIsOutsideViewport(true);
            }
        }
    }, [isOverlayOpen]);
    useEffect(function () {
        setIsOverlayOpen(isOpen);
    }, [isOpen]);
    var dismissOverlay = useCallback(function () {
        var _a;
        setIsOverlayOpen(false);
        (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    }, []);
    var toggleOverlay = useCallback(function () {
        if (!disabled && !disableOpenOverlayOnClick) {
            setIsOverlayOpen(!isOverlayOpen);
        }
    }, [isOverlayOpen, disabled]);
    var handleClickOutside = function (e) {
        var _a, _b;
        e.stopPropagation();
        var eventOutsideParent = !((_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target));
        var eventOutsideChild = !((_b = overlayRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target));
        if (eventOutsideParent && eventOutsideChild) {
            dismissOverlay();
        }
    };
    var handleOpenWithKeyboard = useCallback(function (event) {
        switch (event.key) {
            case "Enter":
            case "Spacebar":
            case " ": // Alternative value to Spacebar key
                setIsOverlayOpen(true);
                break;
        }
    }, []);
    var handleCloseWithKeyboard = useCallback(function (event) {
        if (event.key === "Escape") {
            dismissOverlay();
        }
    }, []);
    useConditionalEventListener(window, handleCloseWithKeyboard, "keydown", !disableCloseOnEscape && isOverlayOpen);
    useConditionalEventListener(triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current, handleOpenWithKeyboard, "keydown", !disableOpenWithKeyboard && isTriggerFocused);
    useEffect(function () {
        document.addEventListener("click", handleClickOutside);
        return function () { return document.removeEventListener("click", handleClickOutside); };
    }, []);
    return (React__default.createElement(ContainerStyled$3, { isFullWidthTrigger: isFullWidthTrigger, id: id, "data-testid": "".concat(id), isMobile: isMobile, maxHeight: maxHeight, maxWidth: maxWidth, ref: ref },
        React__default.createElement(TriggerContainerStyled, __assign({ "data-testid": "".concat(id, "_button"), ref: triggerRef, onClick: toggleOverlay, onBlur: handleTriggerBlur, onFocus: handleTriggerFocus, isMobile: isMobile, isFullWidthTrigger: isFullWidthTrigger, maxWidth: maxWidth }, restProps), trigger),
        !disabled && (React__default.createElement(OverlayStyled, { "data-testid": "".concat(id, "_overlay"), id: id && "".concat(id, "_overlay"), ref: overlayRef, isMobile: isMobile, isOpen: isOverlayOpen, maxWidth: maxWidth, isOutsideViewport: isOutsideViewport, colors: colors },
            React__default.createElement(ContentStyled, { isOpen: isOverlayOpen },
                React__default.createElement(MainSectionStyled, { isMobile: isMobile, maxHeight: maxHeight, "data-testid": "".concat(id, "_overlay_content") }, children),
                isMobile && !hideCloseButton && (React__default.createElement(ButtonSectionStyled, { colors: colors },
                    React__default.createElement(ButtonPrimary, { "data-testid": "".concat(id, "_overlay_button"), id: id && "".concat(id, "_overlay_button"), onClick: dismissOverlay }, closeLabel))))))));
});
Overlay.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    closeLabel: PropTypes.string,
    disableOpenOverlayOnClick: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    isFullWidthTrigger: PropTypes.bool,
    isOpen: PropTypes.bool,
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    trigger: PropTypes.node
};

var OptionStyled = styled.div(function (_a) {
    var designContext = _a.designContext, disableHover = _a.disableHover;
    return ({
        ":before": {
            backgroundColor: designContext === null || designContext === void 0 ? void 0 : designContext.get("colors/borders/subtle-inline").toString(),
            bottom: 0,
            content: "' '",
            height: 1,
            left: 15,
            position: "absolute",
            right: 15
        },
        ":hover": {
            backgroundColor: disableHover
                ? undefined
                : designContext === null || designContext === void 0 ? void 0 : designContext.get("colors/backgrounds/default", { interactiveState: "pressed" }).toString()
        },
        boxSizing: "border-box",
        cursor: "pointer",
        padding: 15,
        position: "relative",
        transition: "background-color 0.12s ease-out"
    });
});
var AutoSuggestContainer = styled.div(function () {
    var _a;
    return (_a = {
            borderRadius: useCornerRadius("s"),
            margin: "0 -15px"
        },
        _a[OptionStyled] = {
            ":first-of-type": {
                borderRadius: useCornerRadius("s")
            },
            ":last-of-type": {
                borderRadius: useCornerRadius("s")
            },
            ":last-of-type:before": {
                height: 0
            }
        },
        _a);
});
var AutoSuggestOptions = React__default.forwardRef(function (_a, ref) {
    var disabled = _a.disabled, options = _a.options, onSelect = _a.onSelect, id = _a.id, loading = _a.loading, emptyOptionsLabel = _a.emptyOptionsLabel;
    var designContext = useDesignContext();
    var handleSelect = function (value) { return function () {
        if (!(disabled || loading)) {
            onSelect(value);
        }
    }; };
    var hasOptions = options.length !== 0;
    return (React__default.createElement(AutoSuggestContainer, { ref: ref, role: "listbox", id: id }, hasOptions ? (React__default.createElement(React__default.Fragment, null,
        options.map(function (_a, index) {
            var value = _a.value, label = _a.label, description = _a.description;
            return (React__default.createElement(OptionStyled, { designContext: designContext, "aria-disabled": disabled, "aria-label": value, role: "option", onMouseDown: handleSelect(value), onTouchStart: handleSelect(value), key: "".concat(id, "__options__").concat(index), id: "".concat(id, "__options__").concat(index) },
                React__default.createElement(Typography, { textToken: "text-style/text/labels/body/medium" }, label),
                description && (React__default.createElement(Typography, { textToken: "text-style/text/labels/body/regular", colorToken: "colors/text/neutral" }, description))));
        }),
        loading && (React__default.createElement(OptionStyled, { disableHover: true, designContext: designContext },
            React__default.createElement(Loader, null))))) : (React__default.createElement(OptionStyled, { designContext: designContext },
        React__default.createElement(Typography, { textToken: "text-style/text/labels/body/medium", colorToken: "colors/text/neutral", colorTokenArgs: {
                interactiveState: "disabled"
            } }, emptyOptionsLabel)))));
});

/**
 * TODOs
 * highlighting matching characters
 * allow up and down arrows to navigate through options when `isOpen`
 */
/** Input field with suggestions that show up automatically */
var AutoSuggest = function (_a) {
    var _b = _a.borderless, borderless = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.emptyOverlayMessage, emptyOverlayMessage = _d === void 0 ? "No suggestions found." : _d, _e = _a.hasError, hasError = _e === void 0 ? false : _e, _f = _a.hasWarning, hasWarning = _f === void 0 ? false : _f, _g = _a.id, id = _g === void 0 ? "mpui_auto-suggest" : _g, value = _a.value, _h = _a.loading, loading = _h === void 0 ? false : _h, _j = _a.label, label = _j === void 0 ? "" : _j, maxHeight = _a.maxHeight; _a.maxNumVisibleSuggestions; var _l = _a.onBlur, onBlur = _l === void 0 ? noop : _l, _m = _a.onChange, onChange = _m === void 0 ? noop : _m, _o = _a.onFocus, onFocus = _o === void 0 ? noop : _o, _p = _a.onSelect, onSelect = _p === void 0 ? noop : _p, _q = _a.onQueryChange, onQueryChange = _q === void 0 ? function () { return null; } : _q, _r = _a.openOverlayOnMount, openOverlayOnMount = _r === void 0 ? false : _r, _s = _a.debounceDelay, debounceDelay = _s === void 0 ? 200 : _s, _t = _a.showOptionsOnEmptyInput, showOptionsOnEmptyInput = _t === void 0 ? false : _t, _u = _a.showOptionsOnFocus, showOptionsOnFocus = _u === void 0 ? false : _u, _v = _a.options, options = _v === void 0 ? [] : _v, props = __rest(_a, ["borderless", "disabled", "emptyOverlayMessage", "hasError", "hasWarning", "id", "value", "loading", "label", "maxHeight", "maxNumVisibleSuggestions", "onBlur", "onChange", "onFocus", "onSelect", "onQueryChange", "openOverlayOnMount", "debounceDelay", "showOptionsOnEmptyInput", "showOptionsOnFocus", "options"]);
    var _w = useState(value || ""), inputValue = _w[0], setValue = _w[1];
    var _x = useState(openOverlayOnMount), isOpen = _x[0], setIsOpen = _x[1];
    var _y = useState(false), isFocused = _y[0], setFocused = _y[1];
    var _z = useState(false), searchTriggered = _z[0], setSearchTriggered = _z[1];
    var inputRef = useRef(null);
    var overlayRef = useRef(null);
    useEffect(function () {
        var _a;
        var inputField = (_a = overlayRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(".mpui_auto_suggest--input");
        if (inputField) {
            inputRef.current = inputField;
        }
    }, []);
    useEffect(function () {
        if (value !== undefined && value !== null) {
            setValue(value);
            onChange(value, false);
        }
    }, [value]);
    useEffect(function () {
        if (!isFocused) {
            return;
        }
        if (searchTriggered) {
            setSearchTriggered(false);
            triggerOpen();
        }
        var typingSubscription = fromEvent(inputRef.current, "input")
            .pipe(debounceTime(debounceDelay), map(function (e) { return e.target.value; }), distinctUntilChanged())
            .subscribe(triggerSearch);
        return function () { return typingSubscription.unsubscribe(); };
    }, [options, isFocused]);
    var triggerOpen = function () {
        if (!(options.length === 1 && inputValue === options[0].value)) {
            setIsOpen(true);
        }
    };
    var triggerSearch = function (query) {
        if (query.length) {
            onQueryChange(query);
            setSearchTriggered(true);
            triggerOpen();
        }
        else if (showOptionsOnEmptyInput) {
            triggerOpen();
        }
    };
    var focusOnInput = function () {
        var inputLength = inputRef.current.value.length;
        inputRef.current.focus();
        inputRef.current.setSelectionRange(inputLength, inputLength);
    };
    var onFocusInput = function () {
        if (showOptionsOnEmptyInput && !inputValue) {
            triggerSearch("");
        }
        if (showOptionsOnFocus) {
            triggerOpen();
        }
        setFocused(true);
        onFocus();
    };
    var onBlurInput = function () {
        setIsOpen(false);
        setFocused(false);
        onBlur();
    };
    var onChangeInput = function (v) {
        setValue(v);
        onChange(v, false);
    };
    var onSelectSuggestion = function (v) {
        setValue(v);
        onChange(v, true);
        onSelect(v);
        focusOnInput();
        setIsOpen(false);
    };
    return (React__default.createElement(Overlay, { id: id, trigger: React__default.createElement(Field$2, __assign({ "data-testid": "mpui_auto-suggest--input", error: hasError, disabled: disabled, warning: hasWarning, id: id, isUnderlined: borderless, label: label, onFocus: onFocusInput, onBlur: onBlurInput, onChange: onChangeInput, value: inputValue, UNSAFE_inputProps: {
                autoComplete: "off",
                className: "mpui_auto_suggest--input"
            } }, props)), isOpen: isOpen, disabled: disabled, hideCloseButton: true, disableOpenWithKeyboard: true, disableOpenOverlayOnClick: true, maxHeight: maxHeight, ref: overlayRef },
        React__default.createElement(AutoSuggestOptions, { id: "".concat(id, "_overlay-selector"), options: options, disabled: disabled, loading: loading, onSelect: onSelectSuggestion, emptyOptionsLabel: emptyOverlayMessage })));
};
AutoSuggest.propTypes = {
    borderless: PropTypes.bool,
    debounceDelay: PropTypes.number,
    disabled: PropTypes.bool,
    emptyOverlayMessage: PropTypes.string,
    hasError: PropTypes.bool,
    hasWarning: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    loading: PropTypes.bool,
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxNumVisibleSuggestions: PropTypes.number,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onQueryChange: PropTypes.func,
    onSelect: PropTypes.func,
    openOverlayOnMount: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.object),
    showOptionsOnEmptyInput: PropTypes.bool,
    showOptionsOnFocus: PropTypes.bool,
    value: PropTypes.string
};

var CloseButtonContainer = styled.div(function (_a) {
    var isOpen = _a.isOpen;
    return ({
        display: !isOpen && "none",
        opacity: isOpen ? 1 : 0,
        position: "absolute",
        right: "15px",
        top: "15px",
        transition: "opacity 0.2s cubic-bezier(0, 1, 0.5, 1) 0.6s",
        zIndex: 110
    });
});
var ContentContainer = styled.div(function (_a) {
    var isMobile = _a.isMobile;
    return ({
        margin: "0 auto",
        maxWidth: "1150px",
        padding: isMobile ? "0 15px" : "0 30px",
        width: isMobile ? "calc(100% - 30px)" : "calc(100% - 60px)"
    });
});
var ContentWrapper = styled.div(function (_a) {
    var isOpen = _a.isOpen;
    return ({
        display: !isOpen && "none",
        height: "100%",
        opacity: isOpen ? 1 : 0,
        overflowY: "scroll",
        position: "relative",
        transition: "opacity 0.2s cubic-bezier(0, 1, 0.5, 1) 0.2s",
        visibility: isOpen ? "visible" : "hidden",
        width: "100%",
        zIndex: 109
    });
});
var CurtainContainer = styled.div(function (_a) {
    var isOpen = _a.isOpen, bgColor = _a.bgColor;
    return ({
        backgroundColor: bgColor,
        height: "100%",
        left: 0,
        position: "absolute",
        top: isOpen ? 0 : "-140%",
        transition: "top 0.5s cubic-bezier(0, 1, 0.5, 1) 0.1s",
        width: "100%",
        zIndex: 108
    });
});

/**
 * A BlackCurtain component that shows a sliding black overlay
 */
var BlackCurtain = function (_a) {
    var _b = _a.id, id = _b === void 0 ? "mpui_curtain" : _b, isOpen = _a.isOpen, onCloseClick = _a.onCloseClick, children = _a.children;
    var isMobile = useResponsiveContext().isMobile;
    var designContext = useDesignContext();
    var black = designContext.get("colors/backgrounds/inverse").toString();
    return (React__default.createElement(CurtainContainer, { id: id, "data-testid": "mpui_curtain", isOpen: isOpen, bgColor: black },
        React__default.createElement(React__default.Fragment, null,
            onCloseClick && (React__default.createElement(CloseButtonContainer, { isOpen: isOpen },
                React__default.createElement(ButtonRoundPrimary, { "data-testid": "mpui_curtain-close_button", size: "medium", onPress: onCloseClick },
                    React__default.createElement(IconClose, null)))),
            React__default.createElement(ContentWrapper, { id: "".concat(id, "-content"), isOpen: isOpen, "data-testid": "mpui_curtain-content" },
                React__default.createElement(ContentContainer, { isMobile: isMobile }, children)))));
};
BlackCurtain.propTypes = {
    id: PropTypes.string,
    isOpen: PropTypes.bool
};
var index$5 = React__default.memo(BlackCurtain);

var CardStyled = styled.div(function (_a) {
    var backgroundColor = _a.backgroundColor, boxShadowColor = _a.boxShadowColor, textColor = _a.textColor;
    return ({
        alignItems: "center",
        backgroundColor: backgroundColor,
        borderRadius: useCornerRadius("l"),
        boxShadow: "0 2px 9px ".concat(boxShadowColor),
        display: "inline-block",
        justifyContent: "center",
        padding: "25px",
        color: textColor
    });
});
/** Displays a card view with padding, rounded corners and a shadow.
 * The contents of the card are passed in via children.
 */
var Card = function (_a) {
    var id = _a.id, style = _a.style, children = _a.children;
    var designContext = useDesignContext();
    var textColor = designContext.get("colors/text/default").toString();
    var backgroundColor = designContext
        .get("colors/backgrounds/default")
        .toString();
    var boxShadowColor = toRgba(designContext.get("colors/backgrounds/inverse"), 0.15);
    return (React__default.createElement(CardStyled, { id: id, backgroundColor: backgroundColor, boxShadowColor: boxShadowColor, textColor: textColor, style: style, "data-testid": "mpui--card" }, children));
};
Card.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    id: PropTypes.string,
    style: PropTypes.object
};

var chipColors = function (designContext) {
    var textInverseColor = designContext.get("colors/text/inverse").toString();
    var textDefaultColor = designContext.get("colors/text/default").toString();
    var textDefaultPressedColor = designContext
        .get("colors/text/default", { interactiveState: "pressed" })
        .toString();
    var textDefaultHoveredColor = designContext
        .get("colors/text/default", { interactiveState: "hovered" })
        .toString();
    var errorInlineColor = designContext
        .get("colors/backgrounds/error-inline")
        .toString();
    var errorInlinePressedColor = designContext
        .get("colors/backgrounds/error-inline", { interactiveState: "pressed" })
        .toString();
    var errorInlineHoveredColor = designContext
        .get("colors/backgrounds/error-inline", { interactiveState: "hovered" })
        .toString();
    var warningInlineColor = designContext
        .get("colors/backgrounds/warning-inline")
        .toString();
    var warningInlineHoveredColor = designContext
        .get("colors/backgrounds/warning-inline", { interactiveState: "pressed" })
        .toString();
    var warningInlinePressedColor = designContext
        .get("colors/backgrounds/warning-inline", { interactiveState: "hovered" })
        .toString();
    return {
        focus: {
            default: {
                backgroundColor: textDefaultPressedColor,
                color: textInverseColor
            },
            error: {
                backgroundColor: errorInlinePressedColor,
                color: textDefaultPressedColor
            },
            warning: {
                backgroundColor: warningInlinePressedColor,
                color: textDefaultPressedColor
            }
        },
        hover: {
            default: {
                backgroundColor: textDefaultHoveredColor,
                color: textInverseColor
            },
            error: {
                backgroundColor: errorInlineHoveredColor,
                color: textDefaultHoveredColor
            },
            warning: {
                backgroundColor: warningInlineHoveredColor,
                color: textDefaultHoveredColor
            }
        },
        initial: {
            default: {
                backgroundColor: textDefaultColor,
                color: textInverseColor
            },
            error: {
                backgroundColor: errorInlineColor,
                color: textDefaultColor
            },
            warning: {
                backgroundColor: warningInlineColor,
                color: textDefaultColor
            }
        }
    };
};
// in px
var CHIP_HEIGHT = 20;
var SPACING = 5;
var ChipStyled = styled.span(function (_a) {
    var _b, _c, _d;
    var hasError = _a.hasError, hasWarning = _a.hasWarning, maxWidth = _a.maxWidth, isSelected = _a.isSelected, colors = _a.colors;
    var color = (hasError && "error") || (hasWarning && "warning") || "default";
    return __assign(__assign({}, (_b = colors === null || colors === void 0 ? void 0 : colors[isSelected ? "focus" : "initial"]) === null || _b === void 0 ? void 0 : _b[color]), { "&:focus": (_c = colors.focus) === null || _c === void 0 ? void 0 : _c[color], "&:hover": (_d = colors.hover) === null || _d === void 0 ? void 0 : _d[color], alignItems: "center", borderRadius: useCornerRadius("s"), boxSizing: "border-box", display: "inline-flex", fontSize: "".concat(constants.Fonts.SIZE_DETAIL, "px"), gap: SPACING, height: CHIP_HEIGHT, maxWidth: maxWidth, opacity: isSelected ? 0.6 : 1, overflow: "hidden", padding: "0 ".concat(SPACING, "px") });
}, function (_a) {
    var color = _a.textColor, backgroundColor = _a.bgColor;
    return ({
        "&:hover": {
            backgroundColor: backgroundColor,
            opacity: 0.9
        },
        backgroundColor: backgroundColor,
        color: color
    });
});
var LabelStyled = styled(Strong).withConfig({
    shouldForwardProp: function (prop, defaultValidatorFn) {
        // @ts-ignore: for some reason
        return prop !== "maxWidth" && defaultValidatorFn(prop);
    }
})(function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth && {
        maxWidth: maxWidth,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    };
}, {
    boxSizing: "border-box",
    height: CHIP_HEIGHT,
    lineHeight: "".concat(CHIP_HEIGHT, "px")
});
var iconCss = css({
    height: CHIP_HEIGHT,
    width: "initial"
});
var iconWrapperCss = css({
    alignItems: "center",
    boxSizing: "border-box",
    cursor: "pointer",
    display: "flex",
    height: CHIP_HEIGHT,
    padding: "4px 0"
});
var IconWrapperStyled$1 = styled.span(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconWrapperCss);
var ActionIconStyled = styled.span(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  ", "\n  margin-left: 2px;\n"], ["\n  ", "\n  margin-left: 2px;\n"])), iconWrapperCss);
function withBubbleComponentClassName(Component) {
    return function (_a) {
        var className = _a.className, UNSAFE_svgProps = _a.UNSAFE_svgProps, otherProps = __rest(_a, ["className", "UNSAFE_svgProps"]);
        var unsafeProps = __assign({ className: className }, UNSAFE_svgProps);
        return React__default.createElement(Component, __assign({}, otherProps, { UNSAFE_svgProps: unsafeProps }));
    };
}
var IconCloseStyled = styled(withBubbleComponentClassName(ActionIconClose)).attrs({
    viewBox: "0 0 20 20"
})(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), iconCss);
var IconWarningStyled = styled(withBubbleComponentClassName(IconWarning)).attrs({
    viewBox: "0 0 20 20"
})(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  ", "\n  height: ", "px;\n"], ["\n  ", "\n  height: ", "px;\n"])), iconCss, CHIP_HEIGHT - SPACING);
var IconErrorStyled$1 = styled(withBubbleComponentClassName(IconError)).attrs({
    viewBox: "0 0 20 20"
})(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  ", "\n  height: ", "px\n"], ["\n  ", "\n  height: ", "px\n"])), iconCss, CHIP_HEIGHT - SPACING);
var templateObject_1$d, templateObject_2$7, templateObject_3$5, templateObject_4$3, templateObject_5$3;

var propTypes$1 = {
    actionIcon: PropTypes.element,
    bgColor: PropTypes.string,
    hasError: PropTypes.bool,
    hasWarning: PropTypes.bool,
    icon: PropTypes.element,
    isSelected: PropTypes.bool,
    label: PropTypes.node,
    maxWidth: PropTypes.string,
    onActionIconClick: PropTypes.func,
    onClick: PropTypes.func,
    textColor: PropTypes.string,
    value: PropTypes.string
};

var closeIconColor = function (hasError, hasWarning) {
    return choose(hasError, "colors/borders/error", hasWarning, "colors/borders/warning", hasError === undefined || hasWarning === undefined, "colors/borders/default", true, "colors/borders/inverse");
};
/** Chips are compact elements that represent an input, attribute, or action. */
var Chip = function (_a) {
    var actionIcon = _a.actionIcon, bgColor = _a.bgColor, _b = _a.hasError, hasError = _b === void 0 ? false : _b, _c = _a.hasWarning, hasWarning = _c === void 0 ? false : _c, icon = _a.icon, _d = _a.isSelected, isSelected = _d === void 0 ? false : _d, label = _a.label, _e = _a.maxWidth, maxWidth = _e === void 0 ? "25ch" : _e, onActionIconClick = _a.onActionIconClick, onClick = _a.onClick, textColor = _a.textColor, value = _a.value, restProps = __rest(_a, ["actionIcon", "bgColor", "hasError", "hasWarning", "icon", "isSelected", "label", "maxWidth", "onActionIconClick", "onClick", "textColor", "value"]);
    var $iconError = (React__default.createElement(IconErrorStyled$1, { "data-testid": "chip__icon_error", colorToken: "colors/borders/error", colorTokenArgs: {
            interactiveState: "hovered"
        } }));
    var $iconWarning = (React__default.createElement(IconWarningStyled, { "data-testid": "chip__icon_warning", colorToken: "colors/borders/warning" }));
    var leftIcon = hasError ? $iconError : hasWarning ? $iconWarning : icon;
    var displayLabel = label !== null && label !== void 0 ? label : value;
    var designContext = useDesignContext();
    var colors = React__default.useMemo(function () { return chipColors(designContext); }, [designContext]);
    return (React__default.createElement(ChipStyled, __assign({ colors: colors, hasError: hasError, hasWarning: hasWarning, isSelected: isSelected, bgColor: bgColor, textColor: textColor, "data-testid": "chip", "data-value": value }, restProps),
        !!leftIcon && React__default.createElement(IconWrapperStyled$1, null, leftIcon),
        React__default.createElement(LabelStyled, { maxWidth: maxWidth, onClick: onClick }, displayLabel),
        onActionIconClick && (React__default.createElement(ActionIconStyled, { role: "button", onClick: onActionIconClick, "aria-label": "delete ".concat(label) }, actionIcon ? (actionIcon) : (React__default.createElement(IconCloseStyled, { colorToken: closeIconColor(hasError, hasWarning), colorTokenArgs: {
                interactiveState: hasError ? "hovered" : "default"
            } }))))));
};
Chip.propTypes = propTypes$1;

var chipInputColors = function (designContext) { return ({
    errorBgColor: designContext.get("colors/backgrounds/error-inline").toString(),
    errorText: designContext.get("colors/text/error").toString(),
    fieldBackground: designContext.get("colors/text/inverse").toString(),
    fieldBorder: designContext.get("colors/backgrounds/neutral").toString(),
    iconError: designContext.get("colors/borders/error").toString(),
    labelText: designContext.get("colors/text/neutral").toString(),
    transparent: "transparent"
}); };
var IconWrapperStyled = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  display: flex;\n  min-height: 60px;\n  max-width: 40px;\n  box-sizing: border-box;\n  padding: 15px 0 15px 15px;\n  flex-shrink: 0;\n  align-items: center;\n"], ["\n  display: flex;\n  min-height: 60px;\n  max-width: 40px;\n  box-sizing: border-box;\n  padding: 15px 0 15px 15px;\n  flex-shrink: 0;\n  align-items: center;\n"])));
var ChipInputContainerStyled = styled.div(function (_a) {
    var colors = _a.colors;
    return ({
        alignItems: "flex-start",
        backgroundColor: colors.fieldBackground,
        border: "1px solid ".concat(colors.fieldBorder),
        borderRadius: useCornerRadius("s"),
        boxSizing: "border-box",
        display: "flex"
    });
});
var ChipInputWrapperStyled = styled.div(function (_a) {
    var hasLabel = _a.hasLabel;
    return ({
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        justifyContent: hasLabel ? "flex-start" : "center",
        minHeight: 60,
        padding: hasLabel ? "15px 15px 0 15px" : "25px 15px 0 15px"
    });
});
var ChipContainerStyled = styled.div(function (_a) {
    var hasLabel = _a.hasLabel;
    return ({
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 5,
        marginTop: -20,
        maxHeight: hasLabel ? "140px" : "149px",
        overflow: "auto",
        paddingBottom: 10,
        paddingTop: 5,
        position: "relative"
    });
});
var templateObject_1$c;

var generateLabel = function (_a) {
    var label = _a.label, maxChips = _a.maxChips, numberOfChips = _a.numberOfChips;
    var maxChipValid = maxChips && maxChips > 0 && maxChips < Number.MAX_VALUE;
    if (label && maxChipValid) {
        return "".concat(label, " (").concat(numberOfChips, "/").concat(maxChips, ")");
    }
    if (label) {
        return label;
    }
    if (maxChipValid) {
        return "".concat(numberOfChips, "/").concat(maxChips);
    }
    return "";
};
var generateTitle = function (_a) {
    var duplicateValueLabel = _a.duplicateValueLabel, errorLabel = _a.errorLabel, invalidValueLabel = _a.invalidValueLabel, isUniqueValue = _a.isUniqueValue, isValidValue = _a.isValidValue, value = _a.value;
    if (!errorLabel) {
        return value;
    }
    var errorMessages = [];
    if (duplicateValueLabel && !isUniqueValue) {
        errorMessages.push(duplicateValueLabel);
    }
    if (invalidValueLabel && !isValidValue) {
        errorMessages.push(invalidValueLabel);
    }
    return "".concat(value).concat(errorMessages.length > 0
        ? "\n".concat(errorLabel, ": ").concat(errorMessages.join(", "))
        : "");
};
var generateChipValues = function (inputValues, duplicateValueLabel, errorLabel, invalidValueLabel, validationFn) {
    return function (prevChipValues) {
        var chipValues = __spreadArray([], prevChipValues, true);
        inputValues.forEach(function (inputValue) {
            var _a;
            var isUniqueValue = chipValues.find(function (item) { return item.value === inputValue; }) === undefined;
            var isValidValue = (_a = validationFn === null || validationFn === void 0 ? void 0 : validationFn(inputValue)) !== null && _a !== void 0 ? _a : true;
            chipValues.push({
                isValid: isUniqueValue && isValidValue,
                label: generateTitle({
                    duplicateValueLabel: duplicateValueLabel,
                    errorLabel: errorLabel,
                    invalidValueLabel: invalidValueLabel,
                    isUniqueValue: isUniqueValue,
                    isValidValue: isValidValue,
                    value: inputValue
                }),
                value: inputValue
            });
        });
        return chipValues;
    };
};
var keyboardAction = function (event, inputValue, actions, separators) {
    if (separators === void 0) { separators = ["Enter", "Tab", " ", ",", ";"]; }
    var isEmpty = inputValue === "";
    var keyActions = {
        ArrowLeft: function () {
            if (isEmpty) {
                actions.select("left");
            }
        },
        ArrowRight: function () {
            if (isEmpty) {
                actions.select("right");
            }
        },
        Backspace: function () {
            if (isEmpty) {
                actions.remove();
            }
        },
        default: function () {
            if (!separators.includes(event.key)) {
                return;
            }
            if (event.key !== "Tab") {
                event.preventDefault();
            }
            if (!isEmpty) {
                actions.add(inputValue);
            }
        }
    };
    if (keyActions[event.key]) {
        return keyActions[event.key]();
    }
    return keyActions.default();
};
var validChips = function (values) {
    return values.filter(function (item) { return item.isValid; });
};
var invalidChips = function (values) {
    return values.filter(function (item) { return !item.isValid; });
};
var getSelectedIndex = function (direction, prevIndex, noOfChips) {
    var nextIndex = prevIndex < 0 ? noOfChips : prevIndex;
    switch (direction) {
        case "left":
            nextIndex = nextIndex - 1;
            return nextIndex <= 0 ? 0 : nextIndex;
        case "right":
            nextIndex = nextIndex + 1;
            return nextIndex >= noOfChips ? -1 : nextIndex;
    }
};
var errorMessage = function (errorTemplate, numberOfErrors) {
    return errorTemplate.replace("#", numberOfErrors.toString());
};
var useChipInputColors = function () {
    var designContext = useDesignContext();
    return React.useMemo(function () { return chipInputColors(designContext); }, [designContext]);
};

var slideOutFrame = keyframes(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  0% { transform: translate3d(0, -10px, 0) scale3d(1, 0, 1);  opacity: 0; }\n  100% { transform: translate3d(0, 0, 0) scale3d(1, 1, 1); opacity: 1; }\n"], ["\n  0% { transform: translate3d(0, -10px, 0) scale3d(1, 0, 1);  opacity: 0; }\n  100% { transform: translate3d(0, 0, 0) scale3d(1, 1, 1); opacity: 1; }\n"])));
var slideOut = function () { return css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  animation: 0.15s ", " ease-out forwards;\n"], ["\n  animation: 0.15s ", " ease-out forwards;\n"])), slideOutFrame); };
var ContainerStyled$2 = styled.div(function (_a) {
    var colors = _a.colors;
    return ({
        alignItems: "center",
        backgroundColor: colors.errorBgColor,
        borderRadius: useCornerRadius("s"),
        boxSizing: "border-box",
        display: "flex",
        gap: 5,
        marginTop: 5,
        padding: "5px 10px",
        transformOrigin: "top"
    });
}, slideOut);
var ErrorIconWrapperStyled = styled.div({
    alignItems: "center",
    display: "flex",
    marginRight: 8
});
var ButtonStyled = styled.button(function (_a) {
    var colors = _a.colors;
    return ({
        background: "none",
        border: "none",
        color: colors.errorText,
        cursor: "pointer",
        padding: 0,
        textDecoration: "underline"
    });
});
var IconErrorStyled = styled(IconError).attrs({
    focusable: "false",
    viewBox: "0 0 20 20"
})({
    height: "auto",
    width: 15
});
var ErrorWrapperStyled = styled.div({
    alignItems: "flex-start",
    display: "flex",
    flexWrap: "wrap",
    gap: 3,
    justifyContent: "space-between",
    width: "100%"
});
var ErrorTextStyled = styled.span(function (_a) {
    var colors = _a.colors;
    return (__assign(__assign({}, constants.Fonts.KLARNA_TEXT_REGULAR), { alignItems: " flex-start", color: colors.errorText, fontSize: constants.Fonts.SIZE_DETAIL, fontWeight: 500 }));
});
var ChipInputErrors = function (_a) {
    var error = _a.error, buttonLabel = _a.buttonLabel, onClick = _a.onClick;
    var colors = useChipInputColors();
    return (React__default.createElement(ContainerStyled$2, { "aria-label": "chip errors", colors: colors },
        React__default.createElement(ErrorIconWrapperStyled, { "aria-hidden": "true" },
            React__default.createElement(IconErrorStyled, { colorToken: "colors/borders/error", "data-testid": "icon__error" })),
        React__default.createElement(ErrorWrapperStyled, null,
            React__default.createElement(ErrorTextStyled, { colors: colors }, error),
            React__default.createElement(ButtonStyled, { colors: colors, "aria-label": "remove chip with errors", onClick: onClick },
                React__default.createElement(Typography, { textToken: "text-style/text/paragraphs/default/regular" }, buttonLabel)))));
};
var templateObject_1$b, templateObject_2$6;

var InputContainerStyled = styled.div({
    display: "inline-flex",
    flex: 1,
    height: 20,
    minWidth: 100,
    overflow: "hidden"
});
var InputStyled = styled.input(__assign(__assign({}, constants.Fonts.KLARNA_TEXT_MEDIUM), { backgroundColor: "transparent", border: "none", display: "inline-block", flex: 1, fontSize: constants.Fonts.SIZE_DEFAULT, fontWeight: 400, outline: "none", padding: 0, zIndex: 1 }));
var ChipInputField = React__default.forwardRef(function (_a, ref) {
    var onKeyDown = _a.onKeyDown, onChange = _a.onChange, onPaste = _a.onPaste, value = _a.value, restProps = __rest(_a, ["onKeyDown", "onChange", "onPaste", "value"]);
    return (React__default.createElement(InputContainerStyled, null,
        React__default.createElement(InputStyled, __assign({ value: value, autoComplete: "off", "data-testid": "chip-input__input-field", onChange: onChange, onKeyDown: onKeyDown, onPaste: onPaste, ref: ref }, restProps))));
});

var LabelContainerStyled = styled.div({
    alignItems: "center",
    display: "flex",
    minHeight: 30
});
var ChipInputLabelStyled = styled.label(function (_a) {
    var focused = _a.focused, colors = _a.colors;
    return ({
        alignItems: "center",
        color: colors.labelText,
        display: "inline-flex",
        textRendering: "geometricPrecision",
        transform: focused
            ? "translate(0, -10px) scale(0.88)"
            : "translate(0, 0) scale(1)",
        transformOrigin: "top left",
        transition: "transform 0.15s cubic-bezier(0, 1, 0.5, 1)"
    });
});
var ChipInputLabel = function (_a) {
    var children = _a.children, focused = _a.focused;
    var colors = useChipInputColors();
    return (React__default.createElement(LabelContainerStyled, null,
        React__default.createElement(Typography, { textToken: "text-style/text/paragraphs/default/regular" },
            React__default.createElement(ChipInputLabelStyled, { colors: colors, focused: focused }, children))));
};

var chipInputPropTypes = {
    duplicateValueText: propTypesExports.string,
    errorText: propTypesExports.string,
    icon: propTypesExports.func,
    invalidChipsLabel: propTypesExports.string,
    invalidValueLabel: propTypesExports.string,
    label: propTypesExports.string,
    maxChips: propTypesExports.number,
    onChange: propTypesExports.func,
    removeInvalidChipsButtonLabel: propTypesExports.string,
    validationFn: propTypesExports.func,
    values: propTypesExports.arrayOf(propTypesExports.shape({
        isValid: propTypesExports.bool.isRequired,
        label: propTypesExports.node,
        value: propTypesExports.string.isRequired
    })),
    withChipDeletion: propTypesExports.bool
};

/**
 * An input field that enables the user to input multiple values either by hand
 * or by pasting a piece of text. Each value is separated by predetermined keys
 * (`Enter`/`Tab`/`Space`/`Comma`/`Semicolon`) and then gets added to the
 * component as a chip that can be validated against a function, and deleted if
 * needed.
 *
 * A typical use-case for this component would be an input field for several
 * email addresses or tags.
 */
var ChipInput = function (_a) {
    var duplicateValueLabel = _a.duplicateValueLabel, errorLabel = _a.errorLabel, _b = _a.icon, Icon = _b === void 0 ? function () { return React__default.createElement(IconEnvelope, { colorToken: "colors/text/neutral" }); } : _b, invalidChipsLabel = _a.invalidChipsLabel, invalidValueLabel = _a.invalidValueLabel, _c = _a.label, label = _c === void 0 ? "" : _c, _d = _a.maxChips, maxChips = _d === void 0 ? Number.MAX_VALUE : _d, onChange = _a.onChange, removeInvalidChipsButtonLabel = _a.removeInvalidChipsButtonLabel, validationFn = _a.validationFn, values = _a.values, _e = _a.withChipDeletion, withChipDeletion = _e === void 0 ? false : _e, restProps = __rest(_a, ["duplicateValueLabel", "errorLabel", "icon", "invalidChipsLabel", "invalidValueLabel", "label", "maxChips", "onChange", "removeInvalidChipsButtonLabel", "validationFn", "values", "withChipDeletion"]);
    var didMount = useRef(false);
    var _f = useState(values !== null && values !== void 0 ? values : []), chipValues = _f[0], setChipValues = _f[1];
    var _g = useState(""), chipInputFieldValue = _g[0], setChipInputFieldValue = _g[1];
    var _h = useState(false), hasFocus = _h[0], setFocus = _h[1];
    // -1 implies no chip is selected
    var _j = useState(-1), selectedChipIndex = _j[0], setSelectedChipIndex = _j[1];
    var colors = useChipInputColors();
    var containerRef = useRef(null);
    var inputFieldRef = useRef(null);
    var labelText = generateLabel({
        label: label,
        maxChips: maxChips,
        numberOfChips: chipValues.length
    });
    useEffect(function () {
        if (didMount.current && values !== undefined) {
            setChipValues(values);
        }
    }, [values]);
    useEffect(function () {
        if (didMount.current && onChange) {
            onChange(chipValues);
        }
    }, [chipValues]);
    useEffect(function () {
        if (!didMount.current) {
            didMount.current = true;
        }
    }, []);
    var deselectChips = function () { return setSelectedChipIndex(-1); };
    var resetInput = function () {
        setChipInputFieldValue("");
        deselectChips();
    };
    var addChips = function (inputValues) {
        var currentValues = generateChipValues(inputValues, duplicateValueLabel, errorLabel, invalidValueLabel, validationFn)(chipValues);
        setChipValues(currentValues);
        resetInput();
    };
    var deleteChip = function (selectedIndex, withKeyboardNavigation) {
        if (withKeyboardNavigation === void 0) { withKeyboardNavigation = true; }
        return function () {
            // Delete only if chip is selected, otherwise select the last chip
            if (withKeyboardNavigation && selectedIndex <= -1) {
                return setSelectedChipIndex(chipValues.length - 1);
            }
            setChipValues(remove(selectedIndex, 1, chipValues));
            if (!withKeyboardNavigation) {
                return deselectChips();
            }
            var index = selectedIndex > 0 ? selectedIndex - 1 : chipValues.length - 2;
            setSelectedChipIndex(index);
        };
    };
    var deleteInvalidChips = function () {
        setChipValues(validChips(chipValues));
        deselectChips();
    };
    var handleFocus = function () {
        var _a;
        (_a = inputFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setFocus(true);
    };
    var handleBlur = function () {
        setFocus(false);
        if (chipInputFieldValue !== "") {
            addChips([chipInputFieldValue]);
        }
    };
    var handleKeyDown = function (event) {
        if (chipValues.length >= maxChips) {
            event.preventDefault();
        }
        keyboardAction(event, chipInputFieldValue, {
            add: function (inputValue) {
                addChips([inputValue]);
            },
            remove: function () {
                deleteChip(selectedChipIndex)();
            },
            select: function (direction) {
                setSelectedChipIndex(function (prevIndex) {
                    return getSelectedIndex(direction, prevIndex, chipValues.length);
                });
            }
        });
    };
    var handleChange = function (event) {
        var value = event.target.value;
        setChipInputFieldValue(value);
        deselectChips();
    };
    var handlePaste = function (event) {
        event.preventDefault();
        var remainingChips = maxChips - chipValues.length;
        if (remainingChips <= 0) {
            return resetInput();
        }
        var pastedValues = event.clipboardData.getData("text").split(/[\s,;]/);
        var cleanValues = pastedValues
            .map(function (value) { return value.trim(); })
            .filter(Boolean);
        addChips(cleanValues.slice(0, remainingChips));
    };
    var numberOfChipsWithErrors = invalidChips(chipValues).length;
    var showErrors = withChipDeletion &&
        !!invalidChipsLabel &&
        !!removeInvalidChipsButtonLabel &&
        numberOfChipsWithErrors > 0;
    var inputLabelFocus = chipValues.length > 0 || chipInputFieldValue.length > 0 || hasFocus;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Typography, { textToken: "text-style/text/paragraphs/body/regular" },
            React__default.createElement(ChipInputContainerStyled, __assign({ ref: containerRef, tabIndex: 0, onFocus: handleFocus, onBlur: handleBlur, colors: colors }, restProps),
                Icon && (React__default.createElement(IconWrapperStyled, null,
                    React__default.createElement(Icon, null))),
                React__default.createElement(ChipInputWrapperStyled, { hasLabel: labelText.length > 0 },
                    labelText.length > 0 && (React__default.createElement(ChipInputLabel, { focused: inputLabelFocus }, labelText)),
                    React__default.createElement(ChipContainerStyled, { hasLabel: labelText.length > 0 },
                        chipValues.map(function (_a, index) {
                            var isValid = _a.isValid, value = _a.value, chipLabel = _a.label;
                            return (React__default.createElement(Chip, { isSelected: index === selectedChipIndex, hasError: !isValid, key: "chip__".concat(index), onActionIconClick: deleteChip(index, false), label: chipLabel, value: value, "aria-label": chipLabel, "aria-selected": index === selectedChipIndex ? "true" : "false", "aria-invalid": isValid ? "false" : "true" }));
                        }),
                        React__default.createElement(ChipInputField, { value: chipInputFieldValue, ref: inputFieldRef, onChange: handleChange, onKeyDown: handleKeyDown, onPaste: handlePaste, "aria-label": labelText }))))),
        showErrors && (React__default.createElement(ChipInputErrors, { buttonLabel: removeInvalidChipsButtonLabel, error: errorMessage(invalidChipsLabel, numberOfChipsWithErrors), onClick: deleteInvalidChips }))));
};
ChipInput.propTypes = chipInputPropTypes;

function useInterval(callback, time) {
    var callbackRef = useRef(null);
    useEffect(function () {
        callbackRef.current = callback;
    }, [callback]);
    useEffect(function () {
        var interval = setInterval(function () { return callbackRef.current(); }, time);
        return function () { return clearInterval(interval); };
    }, [time]);
}

var calculateTimeLeft = function (toDate) {
    var difference = toDate - Date.now();
    if (difference > 0) {
        return {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60)
        };
    }
};
var normalizeDate = function (date) {
    if (typeof date === "number") {
        return date;
    }
    else {
        var parsedDate = new Date(date);
        if (date.includes("T")) {
            // keep the time when explicit or unix timestamp
            return parsedDate.valueOf();
        }
        else {
            // normalize to beginning of day
            return new Date(parsedDate.setUTCHours(0, 0, 0, 0)).valueOf();
        }
    }
};
/**
 * A countdown component that displays the days, hours, minutes and seconds left to the provided date
 */
var Countdown = function (_a) {
    var _b = _a.id, id = _b === void 0 ? "mpui_countdown" : _b, _c = _a.countdownText, countdownText = _c === void 0 ? "#dd #hh #mm #ss" : _c, toDate = _a.toDate, centered = _a.centered;
    var toTimestamp = useState(function () { return normalizeDate(toDate); })[0];
    var _d = useState(function () { return calculateTimeLeft(toTimestamp); }), timeLeft = _d[0], setTimeLeft = _d[1];
    useInterval(function () {
        setTimeLeft(calculateTimeLeft(toTimestamp));
    }, 900);
    return timeLeft ? (React__default.createElement("div", { id: id, "data-testid": "mpui_countdown" },
        React__default.createElement(TitleSecondary, { centered: centered }, "".concat(countdownText
            .replace("#d", String(timeLeft.days))
            .replace("#h", String(timeLeft.hours))
            .replace("#m", String(timeLeft.minutes))
            .replace("#s", String(timeLeft.seconds)))))) : null;
};
Countdown.propTypes = {
    centered: PropTypes.bool,
    countdownText: PropTypes.string,
    id: PropTypes.string,
    toDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
var index$4 = React__default.memo(Countdown);

var DividerStyled = styled.div(function (_a) {
    var color = _a.color;
    return ({
        borderBottom: "1px solid ".concat(color),
        boxSizing: "border-box",
        display: "block"
    });
});
/**
 * Displays a horizontal divider.  Can have a different color if desirable
 */
var Divider = function (_a) {
    var id = _a.id, color = _a.color;
    var designContext = useDesignContext();
    var defaultColor = designContext
        .get("colors/backgrounds/subtle-inline", {
        interactiveState: "pressed"
    })
        .toString();
    return (React__default.createElement(DividerStyled, { role: "separator", color: color !== null && color !== void 0 ? color : defaultColor, id: id }));
};
Divider.propTypes = {
    color: PropTypes.string,
    id: PropTypes.string
};

var alignItemsOptions = [
    "normal",
    "baseline",
    "center",
    "flex-start",
    "flex-end",
    "stretch"
];
var justifyContentOptions = [
    "normal",
    "center",
    "flex-start",
    "flex-end",
    "space-around",
    "space-between",
    "space-evenly"
];

var spaceTokensNames = [
    "space.0",
    "space.none",
    "space.50",
    "space.100",
    "space.unit",
    "space.150",
    "space.200",
    "space.300",
    "space.400",
    "space.500",
    "space.600",
    "space.800",
    "space.1000",
    "space.1200",
    "space.2000"
];

var FlexStyled = styled.div(function (_a) {
    var id = _a.id, gap = _a.gap, grow = _a.grow, isColumn = _a.isColumn, reverse = _a.reverse, style = _a.style, shouldWrap = _a.shouldWrap;
    return (__assign(__assign({}, style), { display: "flex", flexDirection: reverse
            ? isColumn
                ? "column-reverse"
                : "row-reverse"
            : isColumn
                ? "column"
                : "row", flexGrow: grow && 1, flexWrap: shouldWrap ? "wrap" : "nowrap", gap: gap, id: id }));
});
/**
 * Simplifies aligning multiple elements using flex.
 * Intended for cases with 2 or more children
 * Default behaviour is to render items horizontally,
 * but an optional column layout can be enabled
 */
var Flex = function (_a) {
    var _b = _a.alignItems, alignItems = _b === void 0 ? "stretch" : _b, children = _a.children, _c = _a.column, column = _c === void 0 ? false : _c, id = _a.id, _d = _a.grow, grow = _d === void 0 ? false : _d, _e = _a.justifyContent, justifyContent = _e === void 0 ? "flex-start" : _e, _f = _a.reverse, reverse = _f === void 0 ? false : _f, style = _a.style, _g = _a.spacing, spacing = _g === void 0 ? "space.none" : _g, _h = _a.noWrap, noWrap = _h === void 0 ? false : _h;
    style = __assign({ alignItems: alignItems, justifyContent: justifyContent }, style);
    // Set spacings
    var wrapOffset = null;
    if (typeof spacing === "string") {
        // For a single value, we use the same spacing, based on the horizontal hierarchy from bubble.
        wrapOffset = {
            horizontal: useGetToken(spacing).value(),
            vertical: useGetToken(spacing).value()
        };
    }
    else if (typeof spacing === "object") {
        wrapOffset = {
            horizontal: useGetToken(spacing.horizontal).value(),
            vertical: useGetToken(spacing.vertical).value()
        };
    }
    return (React__default.createElement(FlexStyled, { id: id, gap: "".concat(wrapOffset.vertical, "px ").concat(wrapOffset.horizontal, "px"), grow: grow, isColumn: column, reverse: reverse, shouldWrap: !noWrap, style: style }, children));
};
Flex.propTypes = {
    alignItems: PropTypes.oneOf(alignItemsOptions),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    column: PropTypes.bool,
    grow: PropTypes.bool,
    justifyContent: PropTypes.oneOf(justifyContentOptions),
    noWrap: PropTypes.bool,
    reverse: PropTypes.bool,
    spacing: PropTypes.oneOfType([
        PropTypes.oneOf(spaceTokensNames),
        PropTypes.shape({
            horizontal: PropTypes.oneOf(spaceTokensNames),
            vertical: PropTypes.oneOf(spaceTokensNames)
        })
    ]),
    style: PropTypes.object
};

var ALIGNMENTS = {
    center: "center",
    left: "flex-start",
    right: "flex-end"
};
var FloatingContainer = styled.div(function (_a) {
    var align = _a.align, additionalStyles = _a.additionalStyles;
    return (__assign({ alignItems: ALIGNMENTS[align], bottom: "0px", display: "flex", flexDirection: "column", justifyContent: "flex-end", left: "0px", overflow: "hidden", padding: "15px", pointerEvents: "none", position: "fixed", right: "0px", zIndex: zIndex.floatingContainer }, additionalStyles));
});

var _a;
// time is in seconds
var PAUSE_DURATION = 15;
var ANIMATION_DELAY = 30;
var CONTAINER_ANIMATION_DURATION = 0.3;
var TOTAL_TWEENING_DURATION = 0.6;
var TOTAL_ANIMATION_DURATION = TOTAL_TWEENING_DURATION + PAUSE_DURATION;
var containerEnterKeyframe = keyframes(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 70px, 0);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 70px, 0);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
var animateContainer = keyframes(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  ", "% {\n    transform: translateY(-3px);\n  }\n\n  ", "% {\n    transform: translateY(5px);\n  }\n\n  ", "% {\n    transform: translateY(-2px);\n  }\n\n  0%, ", "% {\n    transform: translateY(0);\n  }\n"], ["\n  ", "% {\n    transform: translateY(-3px);\n  }\n\n  ", "% {\n    transform: translateY(5px);\n  }\n\n  ", "% {\n    transform: translateY(-2px);\n  }\n\n  0%, ", "% {\n    transform: translateY(0);\n  }\n"])), 20 / TOTAL_ANIMATION_DURATION, 40 / TOTAL_ANIMATION_DURATION, 60 / TOTAL_ANIMATION_DURATION, 80 / TOTAL_ANIMATION_DURATION);
var containerEnterAnimation = css(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  animation:\n    ", "s ", "\n      cubic-bezier(0, 0, 0.3, 1.25),\n    ", "s ", "s ", "\n      ease-out infinite;\n"], ["\n  animation:\n    ", "s ", "\n      cubic-bezier(0, 0, 0.3, 1.25),\n    ", "s ", "s ", "\n      ease-out infinite;\n"])), CONTAINER_ANIMATION_DURATION, containerEnterKeyframe, TOTAL_ANIMATION_DURATION, ANIMATION_DELAY, animateContainer);
var animateFeedbackIcon = keyframes(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  ", "%  {\n    transform:  rotate(-15deg);\n  }\n\n  ", "% {\n    transform:  rotate(-30deg);\n  }\n\n  ", "%  {\n    transform:  rotate(-15deg);\n  }\n\n  0%, ", "% {\n    transform:  rotate(-0deg);\n  }\n"], ["\n  ", "%  {\n    transform:  rotate(-15deg);\n  }\n\n  ", "% {\n    transform:  rotate(-30deg);\n  }\n\n  ", "%  {\n    transform:  rotate(-15deg);\n  }\n\n  0%, ", "% {\n    transform:  rotate(-0deg);\n  }\n"])), 20 / TOTAL_ANIMATION_DURATION, 40 / TOTAL_ANIMATION_DURATION, 60 / TOTAL_ANIMATION_DURATION, 80 / TOTAL_ANIMATION_DURATION);
var feedbackAnimation = css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  animation: ", "s ", "s\n    ", " ease-out infinite;\n"], ["\n  animation: ", "s ", "s\n    ", " ease-out infinite;\n"])), TOTAL_ANIMATION_DURATION, ANIMATION_DELAY, animateFeedbackIcon);
var removeAnimation = css({
    "@media (prefers-reduced-motion)": {
        "&": {
            animation: "none"
        }
    }
});
var DefaultButtonIconStyled = styled(IconSocialMedia).attrs({
    "aria-label": "feedback icon"
})({}, feedbackAnimation, removeAnimation);
var ContainerStyled$1 = styled.div({
    "&:hover": (_a = {},
        _a[DefaultButtonIconStyled] = {
            animation: "none"
        },
        _a),
    animation: "none",
    display: "inline-flex",
    pointerEvents: "auto",
    position: "relative"
}, containerEnterAnimation, removeAnimation);
var ButtonWithDismissStyled = styled(ButtonPrimary)(function () {
    return {
        "> div": {
            paddingRight: "56px!important"
        },
        position: "relative"
    };
});
var DismissContainerStyled = styled.div(function (_a) {
    var borderLeftColor = _a.borderLeftColor;
    return ({
        borderLeft: "1px solid ".concat(borderLeftColor),
        cursor: "pointer",
        display: "flex",
        paddingLeft: "10px",
        position: "absolute",
        right: "0",
        top: "10px",
        width: "31px"
    });
});
var Icon = function () { return React__default.createElement(ActionIconClose, { colorToken: "colors/borders/neutral" }); };
/**
 * A call to action button placed to the bottom of the webpage on top of every other element.
 * It can be aligned to the left, center or right position.
 * By default it has a Feedback Icon that animates every 15s interval after an initial 30s delay
 */
var FloatingButton = function (_a) {
    var additionalStyles = _a.additionalStyles, _b = _a.align, align = _b === void 0 ? "center" : _b, id = _a.id, label = _a.label, onClick = _a.onClick, icon = _a.icon, withDismissButton = _a.withDismissButton, onDismissClick = _a.onDismissClick;
    var designContext = useDesignContext();
    var borderLeftColor = designContext.get("colors/text/neutral").toString();
    var buttonProps = useMemo(function () { return ({
        icon: icon !== null && icon !== void 0 ? icon : DefaultButtonIconStyled,
        onClick: onClick,
        size: "medium"
    }); }, [icon, onClick, icon, DefaultButtonIconStyled]);
    var DismissButton = React__default.createElement(TouchableIcon, { Icon: Icon, onClick: onDismissClick });
    return (React__default.createElement(FloatingContainer, { "data-testid": "floating-button", align: align, id: id, additionalStyles: additionalStyles },
        React__default.createElement(ContainerStyled$1, null, withDismissButton ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ButtonWithDismissStyled, __assign({}, buttonProps), label),
            React__default.createElement(DismissContainerStyled, { borderLeftColor: borderLeftColor, "data-testid": "floating-button_dismiss-container" }, DismissButton))) : (React__default.createElement(ButtonPrimary, __assign({}, buttonProps), label)))));
};
FloatingButton.propTypes = {
    additionalStyles: PropTypes.object,
    align: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onDismissClick: PropTypes.func,
    withDismissButton: PropTypes.bool
};
var templateObject_1$a, templateObject_2$5, templateObject_3$4, templateObject_4$2, templateObject_5$2;

var DEFAULT_DELAY_MS = 200;
var useDelayedUnmount = function (isVisible, delayMs) {
    if (delayMs === void 0) { delayMs = DEFAULT_DELAY_MS; }
    var _a = useState(isVisible), isVisibleState = _a[0], setIsVisibleState = _a[1];
    var _b = useState(false), isUnmounting = _b[0], setIsUnmounting = _b[1];
    useEffect(function () {
        if (isVisible) {
            setIsVisibleState(isVisible);
        }
        else {
            setIsUnmounting(true);
            var timeout_1 = setTimeout(function () {
                setIsVisibleState(false);
                setIsUnmounting(false);
            }, delayMs);
            return function () {
                clearTimeout(timeout_1);
            };
        }
    }, [isVisible]);
    return [isVisibleState, isUnmounting];
};

var floatingCardPropTypes = {
    additionalStyles: propTypesExports.object,
    align: propTypesExports.oneOf(["center", "left", "right"]),
    ariaCloseLabel: propTypesExports.string,
    children: propTypesExports.node,
    isVisible: propTypesExports.bool,
    onCloseClick: propTypesExports.func,
    withCloseButton: propTypesExports.bool
};

var floatingCardColors = function (designContext) { return ({
    bodyBackground: designContext.get("colors/backgrounds/default").toString(),
    iconBackground: designContext
        .get("colors/text/neutral-on-background")
        .toString()
}); };
var ANIMATION_DURATION = 200;
var animationTranslate = function (isUnmounting) {
    var translateFromY = isUnmounting ? "0" : "100%";
    var translateToY = isUnmounting ? "100%" : "0";
    return keyframes(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n    transform: translate3d(0, ", ", 0);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translate3d(0, ", ", 0);\n  }\n"], ["\n  0% {\n    opacity: 0;\n    transform: translate3d(0, ", ", 0);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translate3d(0, ", ", 0);\n  }\n"])), translateFromY, translateToY);
};
var enterAnimation = function (isUnmounting) { return css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  animation: ", "ms ", "\n    ease-out;\n  animationfillmode: forwards;\n"], ["\n  animation: ", "ms ", "\n    ease-out;\n  animationfillmode: forwards;\n"])), ANIMATION_DURATION, animationTranslate(isUnmounting)); };
var CardBodyStyled = styled.div(function (_a) {
    var colors = _a.colors;
    return ({
        backgroundColor: colors.bodyBackground,
        borderRadius: useCornerRadius("s"),
        boxShadow: "0px 2px 9px rgba(0, 0, 0, 0.15)",
        boxSizing: "border-box",
        maxWidth: "400px",
        minHeight: "100px",
        padding: "24px",
        pointerEvents: "auto",
        position: "relative",
        width: "100%"
    });
}, function (props) { return enterAnimation(props.isUnmounting); });
var CloseButtonStyled = styled(ButtonRoundQuaternary)(function () {
    return {
        position: "absolute",
        right: "-15px",
        top: "-15px"
    };
});
/**
 * FloatingCard is a Card component that is placed at the bottom of the page.
 * It transitions from the bottom to the top on entry and from top to the bottom on exit.
 * It can be aligned to the center, left or right positions
 */
var FloatingCard = function (_a) {
    var additionalStyles = _a.additionalStyles, _b = _a.align, align = _b === void 0 ? "center" : _b, ariaCloseLabel = _a.ariaCloseLabel, children = _a.children, id = _a.id, isVisible = _a.isVisible, onCloseClick = _a.onCloseClick, withCloseButton = _a.withCloseButton;
    var _c = useDelayedUnmount(isVisible, ANIMATION_DURATION), isVisibleState = _c[0], isUnmounting = _c[1];
    var designContext = useDesignContext();
    var colors = useMemo(function () { return floatingCardColors(designContext); }, [designContext]);
    if (!isVisibleState) {
        return null;
    }
    return (React__default.createElement(FloatingContainer, { align: align, "data-testid": "mpui-floating-card", id: id, additionalStyles: additionalStyles },
        React__default.createElement(CardBodyStyled, { isUnmounting: isUnmounting, colors: colors },
            !!withCloseButton && (React__default.createElement(CloseButtonStyled, { "data-testid": "mpui-floating-card-close-button", "aria-label": ariaCloseLabel, onClick: onCloseClick, size: "small" },
                React__default.createElement(ActionIconClose, { colorToken: "colors/borders/default" }))),
            children)));
};
FloatingCard.propTypes = floatingCardPropTypes;
var templateObject_1$9, templateObject_2$4;

var ColumnContext = React__default.createContext({});

var GridContext = React__default.createContext({});

/**
 * Given a responsive token prefix, returns the value of the token
 * for the current viewport size (can be used for framework and layout tokens)
 */
function useResponsiveTokenValue(tokenName) {
    var _a = useResponsiveContext(), isXLDesktop = _a.isXLDesktop, isDesktop = _a.isDesktop, isTablet = _a.isTablet;
    var tokenValue = isXLDesktop
        ? useGetToken("".concat(tokenName, "/xl")).value()
        : isDesktop
            ? useGetToken("".concat(tokenName, "/l")).value()
            : isTablet
                ? useGetToken("".concat(tokenName, "/m")).value()
                : useGetToken("".concat(tokenName, "/s")).value();
    return tokenValue;
}

/**
 * Get the order of the columns
 */
var getOrder = function (_a, _b) {
    var _c;
    var _d = _a === void 0 ? {} : _a, isDesktop = _d.isDesktop, isTablet = _d.isTablet; _d.isMobile;
    var _e = _b === void 0 ? {} : _b, _f = _e.mobileOrder, mobileOrder = _f === void 0 ? 1 : _f, tabletOrder = _e.tabletOrder, desktopOrder = _e.desktopOrder;
    return isTablet
        ? tabletOrder !== null && tabletOrder !== void 0 ? tabletOrder : mobileOrder
        : isDesktop
            ? (_c = desktopOrder !== null && desktopOrder !== void 0 ? desktopOrder : tabletOrder) !== null && _c !== void 0 ? _c : mobileOrder
            : mobileOrder; // mobile fallback
};
var getFirstValidWidth = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.find(function (width) { return width !== undefined; }) || 0;
};
/**
 * Get responsive column width
 */
var getColumnWidth = function (columnWidths, _a) {
    var isTablet = _a.isTablet, isDesktop = _a.isDesktop, isXLDesktop = _a.isXLDesktop;
    var mobileWidth = columnWidths.mobileWidth, tabletWidth = columnWidths.tabletWidth, desktopWidth = columnWidths.desktopWidth, extraLargeDesktopWidth = columnWidths.extraLargeDesktopWidth;
    if (isTablet) {
        return getFirstValidWidth(tabletWidth, mobileWidth);
    }
    else if (isDesktop) {
        return getFirstValidWidth(desktopWidth, tabletWidth, mobileWidth);
    }
    else if (isXLDesktop) {
        return getFirstValidWidth(extraLargeDesktopWidth, desktopWidth, tabletWidth, mobileWidth);
    }
    else {
        return mobileWidth;
    }
};
/**
 * Logs a warning if the specified column width is larger than the parent's column count
 */
var warnIfColumnTooWide = function (columnWidth, parentColumnCount) {
    if (columnWidth > parentColumnCount) {
        // eslint-disable-next-line no-console
        console.warn("Column has width ".concat(columnWidth, " and are exceeding the ").concat(parentColumnCount, "-column grid system"));
    }
};
/**
 * Get the column gutter width, the space between columns.
 */
var useColumnGutter = function () {
    return useResponsiveTokenValue("layout/grid/gutter");
};

var ColumnStyled = styled.div(function (_a) {
    var alignItems = _a.alignItems, maxWidth = _a.maxWidth, order = _a.order, verticalSpacing = _a.verticalSpacing, _b = _a.disableTransitions, disableTransitions = _b === void 0 ? false : _b;
    var verticalGutter = verticalSpacing
        ? useGetToken(verticalSpacing).value()
        : 0;
    var gutter = useColumnGutter();
    return css(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n      align-items: ", ";\n      box-sizing: border-box;\n      display: flex;\n      flex: 1 0 ", ";\n      flex-direction: column;\n      max-width: ", ";\n      order: ", ";\n      padding-bottom: ", "px;\n      padding-left: ", "px;\n      padding-right: ", "px;\n      transition: ", ";\n    "], ["\n      align-items: ", ";\n      box-sizing: border-box;\n      display: flex;\n      flex: 1 0 ", ";\n      flex-direction: column;\n      max-width: ", ";\n      order: ", ";\n      padding-bottom: ", "px;\n      padding-left: ", "px;\n      padding-right: ", "px;\n      transition: ", ";\n    "])), alignItems, maxWidth, maxWidth, order, verticalGutter, gutter / 2, gutter / 2, !disableTransitions && "max-width .3s");
});
/**
 * A Grid Column
 */
var Column = function (_a) {
    var children = _a.children, _b = _a.alignItems, alignItems = _b === void 0 ? "normal" : _b, desktopOrder = _a.desktopOrder, desktopWidth = _a.desktopWidth, extraLargeDesktopWidth = _a.extraLargeDesktopWidth, tabletOrder = _a.tabletOrder, tabletWidth = _a.tabletWidth, mobileOrder = _a.mobileOrder, _c = _a.mobileWidth, mobileWidth = _c === void 0 ? 12 : _c, verticalSpacing = _a.verticalSpacing;
    var disableTransitions = useContext(GridContext).disableTransitions;
    var inheritedWidth = useContext(ColumnContext).parentColumnCount;
    var responsiveProps = useResponsiveContext();
    var isDesktop = responsiveProps.isDesktop, isTablet = responsiveProps.isTablet, isMobile = responsiveProps.isMobile;
    var columnWidth = getColumnWidth({ desktopWidth: desktopWidth, tabletWidth: tabletWidth, mobileWidth: mobileWidth, extraLargeDesktopWidth: extraLargeDesktopWidth }, responsiveProps);
    var maxWidth = inheritedWidth > 0 ? (columnWidth / inheritedWidth) * 100 + "%" : 0;
    var order = getOrder({ isDesktop: isDesktop, isTablet: isTablet, isMobile: isMobile }, { mobileOrder: mobileOrder, tabletOrder: tabletOrder, desktopOrder: desktopOrder });
    var shouldRender = !!children && columnWidth > 0;
    useEffect(function () { return warnIfColumnTooWide(columnWidth, inheritedWidth); }, [columnWidth, inheritedWidth]);
    if (!shouldRender) {
        return null;
    }
    return (React__default.createElement(ColumnContext.Provider, { value: { parentColumnCount: columnWidth } },
        React__default.createElement(ColumnStyled, { verticalSpacing: verticalSpacing, maxWidth: maxWidth, order: order, alignItems: alignItems, disableTransitions: disableTransitions, "data-testid": disableTransitions ? "grid-column-without-transitions" : "grid-column" }, children)));
};
Column.propTypes = {
    alignItems: PropTypes.oneOf(alignItemsOptions),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    desktopOrder: PropTypes.number,
    desktopWidth: PropTypes.oneOf([0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12]),
    mobileOrder: PropTypes.number,
    mobileWidth: PropTypes.oneOf([0, 4, 6, 8, 12]),
    tabletOrder: PropTypes.number,
    tabletWidth: PropTypes.oneOf([0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12]),
    verticalSpacing: PropTypes.oneOf(spaceTokensNames)
};
var Column$1 = React__default.memo(Column);
var templateObject_1$8;

var GRID_COLUMNS = 12;

/**
 * The Grid container.
 */
var Grid = function (_a) {
    var children = _a.children, _b = _a.disableTransitions, disableTransitions = _b === void 0 ? false : _b;
    return (React__default.createElement(GridContext.Provider, { value: { disableTransitions: disableTransitions } },
        React__default.createElement(ColumnContext.Provider, { value: { parentColumnCount: GRID_COLUMNS } }, children)));
};
Grid.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
};
var Grid$1 = React__default.memo(Grid);

var SectionStyled = styled.div(function (_a) {
    var alignItems = _a.alignItems, justifyContent = _a.justifyContent, verticalSpacing = _a.verticalSpacing;
    var verticalGutter = useGetToken(verticalSpacing).value();
    var columnGutter = useColumnGutter();
    return css(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n      align-items: ", ";\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: ", ";\n      margin-bottom: -", "px;\n      margin-left: -", "px;\n      margin-right: -", "px;\n    "], ["\n      align-items: ", ";\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      justify-content: ", ";\n      margin-bottom: -", "px;\n      margin-left: -", "px;\n      margin-right: -", "px;\n    "])), alignItems, justifyContent, verticalGutter, columnGutter / 2, columnGutter / 2);
});
/**
 * A Grid row - the Column container
 */
var Section = function (_a) {
    var children = _a.children, _b = _a.alignItems, alignItems = _b === void 0 ? "normal" : _b, _c = _a.justifyContent, justifyContent = _c === void 0 ? "normal" : _c, _d = _a.verticalSpacing, verticalSpacing = _d === void 0 ? "space.none" : _d;
    var shouldRender = React__default.Children.count(children) > 0;
    if (!shouldRender) {
        return null;
    }
    return (React__default.createElement(SectionStyled, { alignItems: alignItems, verticalSpacing: verticalSpacing, justifyContent: justifyContent, "data-testid": "grid-section" }, verticalSpacing
        ? appendPropsToChildren(children, { verticalSpacing: verticalSpacing })
        : children));
};
Section.propTypes = {
    alignItems: PropTypes.oneOf(alignItemsOptions),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    justifyContent: PropTypes.oneOf(justifyContentOptions),
    verticalSpacing: PropTypes.oneOf(spaceTokensNames)
};
var Section$1 = React__default.memo(Section);
var templateObject_1$7;

var Layout = {
    Column: Column$1,
    Grid: Grid$1,
    Section: Section$1
};

var Portal = function (_a) {
    var children = _a.children, root = _a.root;
    var container = React.useRef(document.createElement("div"));
    // Portal should not affect children layout
    container.current.style.display = "contents";
    var getRootEl = React.useCallback(function () { return (root ? root : document.body); }, [root]);
    React.useEffect(function () {
        getRootEl().appendChild(container.current);
        return function () {
            getRootEl().removeChild(container.current);
        };
    }, [root]);
    return ReactDOM.createPortal(children, container.current);
};

var ESC$1 = 27;
/**
 * A generic modal / dialog container, to unify the internal layout and look and feel of messages across modals.
 */
var Modal = function (_a) {
    var onClose = _a.onClose, _b = _a.closeOnEscape, closeOnEscape = _b === void 0 ? true : _b, _c = _a.closeOnClickOutside, closeOnClickOutside = _c === void 0 ? true : _c, children = _a.children, title = _a.title, description = _a.description, illustration = _a.illustration, buttonPrimary = _a.buttonPrimary, buttonSecondary = _a.buttonSecondary, _d = _a.buttonLayoutVertical, buttonLayoutVertical = _d === void 0 ? false : _d, _e = _a.id, id = _e === void 0 ? "mp-ui-modal" : _e, _f = _a.usePortal, usePortal = _f === void 0 ? true : _f, _g = _a.useWindowHeight, useWindowHeight = _g === void 0 ? true : _g, _h = _a.closeAriaLabel, closeAriaLabel = _h === void 0 ? "close" : _h, generalError = _a.generalError, props = __rest(_a, ["onClose", "closeOnEscape", "closeOnClickOutside", "children", "title", "description", "illustration", "buttonPrimary", "buttonSecondary", "buttonLayoutVertical", "id", "usePortal", "useWindowHeight", "closeAriaLabel", "generalError"]);
    var escape = useCallback(function (event) {
        if (onClose && event.keyCode === ESC$1) {
            onClose();
        }
    }, [onClose]);
    var footerProps = useMemo(function () {
        var componentArray = [];
        if (buttonSecondary) {
            var ButtonComponent = buttonPrimary ? ButtonTertiary : ButtonSecondary;
            componentArray.push({
                Component: ButtonComponent,
                props: {
                    children: buttonSecondary.text,
                    "data-testid": buttonSecondary["data-testid"],
                    disabled: buttonSecondary.disabled,
                    id: buttonSecondary.id,
                    loading: buttonSecondary.loading,
                    onClick: buttonSecondary.onClick
                }
            });
        }
        if (buttonPrimary) {
            componentArray.push({
                Component: ButtonPrimary,
                props: {
                    children: buttonPrimary.text,
                    "data-testid": buttonPrimary["data-testid"],
                    disabled: buttonPrimary.disabled,
                    id: buttonPrimary.id,
                    loading: buttonPrimary.loading,
                    onClick: buttonPrimary.onClick
                }
            });
        }
        if (buttonLayoutVertical) {
            componentArray.reverse();
        }
        return componentArray;
    }, [buttonLayoutVertical, buttonPrimary, buttonSecondary]);
    var Dialog = (React__default.createElement(DialogUnwrapped, __assign({ id: id, rightIconAriaLabel: closeAriaLabel, onClose: onClose, onBackgroundClick: closeOnClickOutside ? onClose : null, useWindowHeight: useWindowHeight, areButtonsHorizontal: !buttonLayoutVertical, footer: footerProps }, props),
        React__default.createElement(Article$1, { title: title, description: description, illustration: illustration }),
        generalError && (title || description || illustration) && (React__default.createElement(SpacerVertical, { spaceToken: "space.500" })),
        generalError && React__default.createElement(AlertBannerError, { content: generalError }),
        children && (illustration || title || description || generalError) && (React__default.createElement(SpacerVertical, { spaceToken: "space.500" })),
        children));
    useEffect(function () {
        if (onClose && closeOnEscape) {
            window.addEventListener("keydown", escape);
        }
        return function () {
            if (onClose && closeOnEscape) {
                window.removeEventListener("keydown", escape);
            }
        };
    }, [escape, closeOnEscape, onClose]);
    if (usePortal) {
        return React__default.createElement(Portal, null, Dialog);
    }
    else {
        return Dialog;
    }
};
Modal.propTypes = {
    buttonLayoutVertical: PropTypes.bool,
    buttonPrimary: PropTypes.exact({
        "data-testid": PropTypes.string,
        disabled: PropTypes.bool,
        id: PropTypes.string,
        loading: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired
    }),
    buttonSecondary: PropTypes.exact({
        "data-testid": PropTypes.string,
        disabled: PropTypes.bool,
        id: PropTypes.string,
        loading: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired
    }),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    closeAriaLabel: PropTypes.string,
    closeOnClickOutside: PropTypes.bool,
    closeOnEscape: PropTypes.bool,
    description: PropTypes.string,
    generalError: PropTypes.string,
    illustration: PropTypes.string,
    onClose: PropTypes.func,
    title: PropTypes.string,
    large: PropTypes.bool,
    usePortal: PropTypes.bool,
    useWindowHeight: PropTypes.bool
};
var index$3 = React__default.memo(Modal);

var useLockBodyScroll = function () {
    useLayoutEffect(function () {
        var originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = "hidden";
        return function () {
            document.body.style.overflow = originalStyle;
        };
    }, []);
};

var modalColors = function (designContext) { return ({
    modalBackground: designContext.get("colors/backgrounds/default").toString(),
    overlayDesktop: toRgba(designContext.get("colors/backgrounds/inverse", {
        interactiveState: "hovered"
    }), 0.5)
}); };
var StyledSidebarOverlay = styled("div")(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  opacity: ", ";\n  transition: ", ";\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: ", ";\n"], ["\n  opacity: ", ";\n  transition: ", ";\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: ", ";\n"])), function (_a) {
    var isUnMounting = _a.isUnMounting;
    return (isUnMounting ? 0 : 1);
}, function (_a) {
    var animationDuration = _a.animationDuration;
    return "opacity ".concat(animationDuration, "ms ease-in-out");
}, function (_a) {
    var colors = _a.colors;
    return colors.overlayDesktop;
}, zIndex.overlay + 1);
var getSidebarAnimation = function (isUnMounting, fromRight) {
    var fromOpacity = isUnMounting ? 1 : 0;
    var toOpacity = isUnMounting ? 0 : 1;
    var fromX = choose(fromRight, isUnMounting ? "0" : "100%", true, isUnMounting ? "0" : "-100%");
    var toX = choose(fromRight, isUnMounting ? "100%" : "0", true, isUnMounting ? "-100%" : "0");
    return keyframes(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n    0% {\n      opacity: ", ";\n      transform: translate3d(", ", 0, 0);\n    }\n    100% {\n      opacity: ", ";\n      transform: translate3d(", ", 0, 0);\n    }\n  "], ["\n    0% {\n      opacity: ", ";\n      transform: translate3d(", ", 0, 0);\n    }\n    100% {\n      opacity: ", ";\n      transform: translate3d(", ", 0, 0);\n    }\n  "])), fromOpacity, fromX, toOpacity, toX);
};
var StyledSidebarBase = styled("div")(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  animation-duration: ", ";\n  animation-fill-mode: forwards;\n  animation-timing-function: ease-out;\n\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: space-between;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: fixed;\n  width: 100%;\n  max-width: ", ";\n  z-index: ", ";\n  top: 0;\n"], ["\n  animation-duration: ", ";\n  animation-fill-mode: forwards;\n  animation-timing-function: ease-out;\n\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: space-between;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: fixed;\n  width: 100%;\n  max-width: ", ";\n  z-index: ", ";\n  top: 0;\n"])), function (_a) {
    var animationDuration = _a.animationDuration;
    return "".concat(animationDuration, "ms");
}, function (_a) {
    var colors = _a.colors;
    return colors.modalBackground;
}, function (_a) {
    var maxWidth = _a.maxWidth, isFullScreen = _a.isFullScreen;
    return isFullScreen ? "100%" : maxWidth;
}, zIndex.sidebar + 1);
var StyledSidebarLeft = styled(StyledSidebarBase)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  left: 0px;\n  box-shadow: rgb(0 0 0 / 25%) 0px 9px 25px 0px;\n  animation-name: ", ";\n"], ["\n  left: 0px;\n  box-shadow: rgb(0 0 0 / 25%) 0px 9px 25px 0px;\n  animation-name: ", ";\n"])), function (_a) {
    var isUnMounting = _a.isUnMounting;
    return getSidebarAnimation(isUnMounting, false);
});
var StyledSidebarRight = styled(StyledSidebarBase)(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  right: 0px;\n  box-shadow: rgb(0 0 0 / 25%) 0px 9px 25px 0px;\n  animation-name: ", ";\n"], ["\n  right: 0px;\n  box-shadow: rgb(0 0 0 / 25%) 0px 9px 25px 0px;\n  animation-name: ", ";\n"])), function (_a) {
    var isUnMounting = _a.isUnMounting;
    return getSidebarAnimation(isUnMounting, true);
});
var StyledContentContainer = styled("div")(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  overflow-y: ", ";\n  margin-bottom: auto;\n  padding: 0 20px 20px 20px;\n"], ["\n  overflow-y: ", ";\n  margin-bottom: auto;\n  padding: 0 20px 20px 20px;\n"])), function (_a) {
    var withScroll = _a.withScroll;
    return (withScroll ? "auto" : "visible");
});
var StyledSidebarHeader = styled.div(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  padding: 20px;\n"], ["\n  padding: 20px;\n"])));
var FlexRow = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"])));
var StyledCloseButton = styled(FlexRow)(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  width: 20px;\n  margin-left: auto;\n"], ["\n  width: 20px;\n  margin-left: auto;\n"])));
var StyledBottomButtons = styled(FlexRow)(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  padding: 20px;\n  box-sizing: border-box;\n"], ["\n  padding: 20px;\n  box-sizing: border-box;\n"])));
var StyledSidebarButton = styled.div(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n  flex-flow: column;\n"], ["\n  display: flex;\n  flex-grow: 1;\n  flex-flow: column;\n"])));
var templateObject_1$6, templateObject_2$3, templateObject_3$3, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11$1;

var SidebarOverlay = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    useLockBodyScroll();
    var designContext = useDesignContext();
    var colors = modalColors(designContext);
    return (React__default.createElement(StyledSidebarOverlay, __assign({ colors: colors, onClick: onClick, "data-testid": "mpui-sidebar-overlay" }, props)));
};
SidebarOverlay.propTypes = {
    onClick: PropTypes.func.isRequired
};

var ESC = "Escape";
var UNMOUNT_ANIMATION_DURATION = 250;
var SidebarButton = function (_a) {
    var ButtonComponent = _a.ButtonComponent, text = _a.text, rest = __rest(_a, ["ButtonComponent", "text"]);
    return (React__default.createElement(ButtonComponent, __assign({ ariaLabel: text }, rest), text));
};
/**
 * A generic Sidebar that slides in from the side as a modal, with overlay.
 *
 * Note that <b>focus is trapped within the modal</b> in order to be accessible.
 * This means that Tab and Shift+Tab will cycle through the modal's
 * focusable nodes without returning to the main document beneath,
 * using [FocusTrap](https://github.com/focus-trap/focus-trap-react).
 *
 */
var ModalSidebar = function (_a) {
    var _b = _a.id, id = _b === void 0 ? "mp-ui-sidebar" : _b, _c = _a.maxWidth, maxWidth = _c === void 0 ? "375px" : _c, _d = _a.leftAligned, leftAligned = _d === void 0 ? false : _d, _e = _a.closeOnEscape, closeOnEscape = _e === void 0 ? true : _e, _f = _a.closeAriaLabel, closeAriaLabel = _f === void 0 ? "Close dialog" : _f, shouldBeShown = _a.isVisible, children = _a.children, onClose = _a.onClose, onOpen = _a.onOpen, title = _a.title, buttonPrimary = _a.buttonPrimary, buttonSecondary = _a.buttonSecondary, _g = _a.usePortal, usePortal = _g === void 0 ? true : _g;
    var isMobile = useResponsiveContext().isMobile;
    var _h = useDelayedUnmount(shouldBeShown, UNMOUNT_ANIMATION_DURATION), isVisible = _h[0], isUnmounting = _h[1];
    var designContext = useDesignContext();
    var colors = useMemo(function () { return modalColors(designContext); }, [designContext]);
    useEffect(function () {
        if (onOpen && isVisible) {
            var timeout_1 = setTimeout(function () {
                onOpen();
            }, UNMOUNT_ANIMATION_DURATION);
            return function () {
                clearTimeout(timeout_1);
            };
        }
    }, [isVisible]);
    var onEscapeKey = useCallback(function (event) {
        if (onClose && event.key === ESC) {
            onClose();
        }
    }, [onClose]);
    useEffect(function () {
        if (closeOnEscape) {
            if (isVisible) {
                window.addEventListener("keydown", onEscapeKey);
            }
            else {
                window.removeEventListener("keydown", onEscapeKey);
            }
        }
        return function () {
            window.removeEventListener("keydown", onEscapeKey);
        };
    }, [isVisible, closeOnEscape, onEscapeKey]);
    if (!isVisible) {
        return null;
    }
    var titleId = "".concat(id, "-title");
    var cssMaxWidth = getCSSWidth(maxWidth);
    var SidebarComponent = leftAligned ? StyledSidebarLeft : StyledSidebarRight;
    var WrapperComponent = usePortal ? Portal : React__default.Fragment;
    return (React__default.createElement(WrapperComponent, null,
        !isMobile && (React__default.createElement(SidebarOverlay, { onClick: onClose, isUnMounting: isUnmounting, "data-testid": "mpui-sidebar-overlay", animationDuration: UNMOUNT_ANIMATION_DURATION })),
        React__default.createElement(FocusTrap, { focusTrapOptions: { clickOutsideDeactivates: true } },
            React__default.createElement(SidebarComponent, { colors: colors, id: id, role: "dialog", "aria-labelledby": titleId, "data-testid": "mpui-sidebar", isFullScreen: isMobile, maxWidth: cssMaxWidth, isUnMounting: isUnmounting, animationDuration: UNMOUNT_ANIMATION_DURATION },
                React__default.createElement(StyledSidebarHeader, null,
                    React__default.createElement(FlexRow, null,
                        React__default.createElement(TitleSecondary, { id: titleId, correctFootprint: true }, title),
                        React__default.createElement(StyledCloseButton, null,
                            React__default.createElement(TouchableIcon, { Icon: IconClose, ariaLabel: closeAriaLabel, "data-testid": "mpui-sidebar-close-button", onClick: onClose, onPress: onClose })))),
                React__default.createElement(StyledContentContainer, { withScroll: !isMobile },
                    React__default.createElement(SpacerVertical, { spaceToken: "space.150" }),
                    children),
                (buttonPrimary || buttonSecondary) && (React__default.createElement(StyledBottomButtons, null,
                    buttonSecondary && (React__default.createElement(StyledSidebarButton, { "data-testid": "mpui-sidebar-button-secondary" },
                        React__default.createElement(SidebarButton, __assign({ ButtonComponent: ButtonSecondary }, buttonSecondary)))),
                    buttonPrimary && buttonSecondary && (React__default.createElement(SpacerHorizontal, { spaceToken: "space.200" })),
                    buttonPrimary && (React__default.createElement(StyledSidebarButton, { "data-testid": "mpui-sidebar-button-primary" },
                        React__default.createElement(SidebarButton, __assign({ ButtonComponent: ButtonPrimary }, buttonPrimary))))))))));
};
var SidebarButtonPropType = PropTypes.shape({
    disabled: PropTypes.bool,
    id: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
});
ModalSidebar.propTypes = {
    buttonPrimary: SidebarButtonPropType,
    buttonSecondary: SidebarButtonPropType,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    closeAriaLabel: PropTypes.string,
    closeOnEscape: PropTypes.bool,
    id: PropTypes.string,
    isVisible: PropTypes.bool.isRequired,
    leftAligned: PropTypes.bool,
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    title: PropTypes.string
};
var index$2 = React__default.memo(ModalSidebar);

/**
 * This component provides you with the necessary contexts for our components to work.
 * This is redundant if you are using the Framework, as this already provides it.
 *
 * **If you are not using the Framework, you should wrap your application with this provider.**
 *
 * Currently, only the `ResponsiveContextProvider` is included, but we will include all the necessary providers
 * in this component, so you only need to use this provider to ensure full compatibility with all features.
 *
 */
var MPUIContextProvider = function (_a) {
    var children = _a.children, breakpoints = _a.breakpoints;
    return (React__default.createElement(ResponsiveContextProvider, { breakpoints: breakpoints },
        React__default.createElement("div", null, children)));
};

var styles$1 = {
    paginationContainer: {
        display: "flex",
        justifyContent: "flex-end"
    }
};
var Pagination = function (_a) {
    var _b = _a.hideLabel, hideLabel = _b === void 0 ? false : _b, _c = _a.hideTotal, hideTotal = _c === void 0 ? false : _c, _d = _a.id, id = _d === void 0 ? "pagination" : _d, _e = _a.ofLabel, ofLabel = _e === void 0 ? "of" : _e, _f = _a.onChange, onChange = _f === void 0 ? function () { return null; } : _f, current = _a.current, _g = _a.size, size = _g === void 0 ? 10 : _g, total = _a.total;
    if (!Number.isInteger(current) ||
        !Number.isInteger(total) ||
        !Number.isInteger(size)) {
        // eslint-disable-next-line no-console
        console.warn("Invalid prop values for pagination. Not rendering anything.", { current: current, total: total, size: size });
        return null;
    }
    var lastPage = Math.ceil(total / size);
    var currentPage = Math.max(1, Math.min(current, lastPage));
    var currentPageStart = (currentPage - 1) * size + 1;
    var currentPageEnd = Math.min(currentPage * size, total);
    var handleGoToPrevious = function () {
        onChange(current - 1);
    };
    var handleGoToNext = function () {
        onChange(current + 1);
    };
    return (React__default.createElement("div", { style: styles$1.paginationContainer, id: id, "data-testid": "mpui_pagination" },
        !hideLabel && total > 0 && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ParagraphSecondary, { "data-testid": "mpui_pagination_results" }, "".concat(currentPageStart, "\u2013").concat(currentPageEnd, " ").concat(ofLabel, " ").concat(hideTotal ? "" : total)),
            React__default.createElement(SpacerHorizontal, { spaceToken: "space.150" }))),
        React__default.createElement(ButtonRoundQuaternary, { "data-testid": "mpui_pagination_previous", size: "small", disabled: currentPage <= 1 || total === 0, onPress: handleGoToPrevious },
            React__default.createElement(ActionIconArrowLeft, null)),
        React__default.createElement(SpacerHorizontal, { spaceToken: "space.150" }),
        React__default.createElement(ButtonRoundQuaternary, { "data-testid": "mpui_pagination_next", size: "small", disabled: currentPage === lastPage || total === 0, onPress: handleGoToNext },
            React__default.createElement(ActionIconArrowRight, null))));
};
Pagination.propTypes = {
    current: PropTypes.number.isRequired,
    hideLabel: PropTypes.bool,
    hideTotal: PropTypes.bool,
    ofLabel: PropTypes.string,
    onChange: PropTypes.func,
    size: PropTypes.number,
    total: PropTypes.number.isRequired
};

/*! Copyright Twitter Inc. and other contributors. Licensed under MIT */
var twemoji=function(){var twemoji={base:"https://twemoji.maxcdn.com/v/14.0.2/",ext:".png",size:"72x72",className:"emoji",convert:{fromCodePoint:fromCodePoint,toCodePoint:toCodePoint},onerror:function onerror(){if(this.parentNode){this.parentNode.replaceChild(createText(this.alt,false),this);}},parse:parse,replace:replace,test:test},escaper={"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},re=/(?:\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83d\udc68\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc68\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc68\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc68\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffc-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffd-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb\udffc\udffe\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffd\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc68\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83d\udc69\ud83c[\udffb-\udfff]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc68\ud83c[\udffb-\udffe]|\ud83d\udc69\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83d\udc69\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udffb\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffc-\udfff]|\ud83e\uddd1\ud83c\udffb\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffd-\udfff]|\ud83e\uddd1\ud83c\udffc\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\uddd1\ud83c\udffd\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffd\udfff]|\ud83e\uddd1\ud83c\udffe\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83e\uddd1\ud83c\udfff\u200d\u2764\ufe0f\u200d\ud83e\uddd1\ud83c[\udffb-\udffe]|\ud83e\uddd1\ud83c\udfff\u200d\ud83e\udd1d\u200d\ud83e\uddd1\ud83c[\udffb-\udfff]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d[\udc68\udc69]|\ud83e\udef1\ud83c\udffb\u200d\ud83e\udef2\ud83c[\udffc-\udfff]|\ud83e\udef1\ud83c\udffc\u200d\ud83e\udef2\ud83c[\udffb\udffd-\udfff]|\ud83e\udef1\ud83c\udffd\u200d\ud83e\udef2\ud83c[\udffb\udffc\udffe\udfff]|\ud83e\udef1\ud83c\udffe\u200d\ud83e\udef2\ud83c[\udffb-\udffd\udfff]|\ud83e\udef1\ud83c\udfff\u200d\ud83e\udef2\ud83c[\udffb-\udffe]|\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68|\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d[\udc68\udc69]|\ud83e\uddd1\u200d\ud83e\udd1d\u200d\ud83e\uddd1|\ud83d\udc6b\ud83c[\udffb-\udfff]|\ud83d\udc6c\ud83c[\udffb-\udfff]|\ud83d\udc6d\ud83c[\udffb-\udfff]|\ud83d\udc8f\ud83c[\udffb-\udfff]|\ud83d\udc91\ud83c[\udffb-\udfff]|\ud83e\udd1d\ud83c[\udffb-\udfff]|\ud83d[\udc6b-\udc6d\udc8f\udc91]|\ud83e\udd1d)|(?:\ud83d[\udc68\udc69]|\ud83e\uddd1)(?:\ud83c[\udffb-\udfff])?\u200d(?:\u2695\ufe0f|\u2696\ufe0f|\u2708\ufe0f|\ud83c[\udf3e\udf73\udf7c\udf84\udf93\udfa4\udfa8\udfeb\udfed]|\ud83d[\udcbb\udcbc\udd27\udd2c\ude80\ude92]|\ud83e[\uddaf-\uddb3\uddbc\uddbd])|(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75]|\u26f9)((?:\ud83c[\udffb-\udfff]|\ufe0f)\u200d[\u2640\u2642]\ufe0f)|(?:\ud83c[\udfc3\udfc4\udfca]|\ud83d[\udc6e\udc70\udc71\udc73\udc77\udc81\udc82\udc86\udc87\ude45-\ude47\ude4b\ude4d\ude4e\udea3\udeb4-\udeb6]|\ud83e[\udd26\udd35\udd37-\udd39\udd3d\udd3e\uddb8\uddb9\uddcd-\uddcf\uddd4\uddd6-\udddd])(?:\ud83c[\udffb-\udfff])?\u200d[\u2640\u2642]\ufe0f|(?:\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc68\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc68\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc66\u200d\ud83d\udc66|\ud83d\udc69\u200d\ud83d\udc67\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83c\udff3\ufe0f\u200d\u26a7\ufe0f|\ud83c\udff3\ufe0f\u200d\ud83c\udf08|\ud83d\ude36\u200d\ud83c\udf2b\ufe0f|\u2764\ufe0f\u200d\ud83d\udd25|\u2764\ufe0f\u200d\ud83e\ude79|\ud83c\udff4\u200d\u2620\ufe0f|\ud83d\udc15\u200d\ud83e\uddba|\ud83d\udc3b\u200d\u2744\ufe0f|\ud83d\udc41\u200d\ud83d\udde8|\ud83d\udc68\u200d\ud83d[\udc66\udc67]|\ud83d\udc69\u200d\ud83d[\udc66\udc67]|\ud83d\udc6f\u200d\u2640\ufe0f|\ud83d\udc6f\u200d\u2642\ufe0f|\ud83d\ude2e\u200d\ud83d\udca8|\ud83d\ude35\u200d\ud83d\udcab|\ud83e\udd3c\u200d\u2640\ufe0f|\ud83e\udd3c\u200d\u2642\ufe0f|\ud83e\uddde\u200d\u2640\ufe0f|\ud83e\uddde\u200d\u2642\ufe0f|\ud83e\udddf\u200d\u2640\ufe0f|\ud83e\udddf\u200d\u2642\ufe0f|\ud83d\udc08\u200d\u2b1b)|[#*0-9]\ufe0f?\u20e3|(?:[©®\u2122\u265f]\ufe0f)|(?:\ud83c[\udc04\udd70\udd71\udd7e\udd7f\ude02\ude1a\ude2f\ude37\udf21\udf24-\udf2c\udf36\udf7d\udf96\udf97\udf99-\udf9b\udf9e\udf9f\udfcd\udfce\udfd4-\udfdf\udff3\udff5\udff7]|\ud83d[\udc3f\udc41\udcfd\udd49\udd4a\udd6f\udd70\udd73\udd76-\udd79\udd87\udd8a-\udd8d\udda5\udda8\uddb1\uddb2\uddbc\uddc2-\uddc4\uddd1-\uddd3\udddc-\uddde\udde1\udde3\udde8\uddef\uddf3\uddfa\udecb\udecd-\udecf\udee0-\udee5\udee9\udef0\udef3]|[\u203c\u2049\u2139\u2194-\u2199\u21a9\u21aa\u231a\u231b\u2328\u23cf\u23ed-\u23ef\u23f1\u23f2\u23f8-\u23fa\u24c2\u25aa\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u2604\u260e\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262a\u262e\u262f\u2638-\u263a\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267b\u267f\u2692-\u2697\u2699\u269b\u269c\u26a0\u26a1\u26a7\u26aa\u26ab\u26b0\u26b1\u26bd\u26be\u26c4\u26c5\u26c8\u26cf\u26d1\u26d3\u26d4\u26e9\u26ea\u26f0-\u26f5\u26f8\u26fa\u26fd\u2702\u2708\u2709\u270f\u2712\u2714\u2716\u271d\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u2764\u27a1\u2934\u2935\u2b05-\u2b07\u2b1b\u2b1c\u2b50\u2b55\u3030\u303d\u3297\u3299])(?:\ufe0f|(?!\ufe0e))|(?:(?:\ud83c[\udfcb\udfcc]|\ud83d[\udd74\udd75\udd90]|[\u261d\u26f7\u26f9\u270c\u270d])(?:\ufe0f|(?!\ufe0e))|(?:\ud83c[\udf85\udfc2-\udfc4\udfc7\udfca]|\ud83d[\udc42\udc43\udc46-\udc50\udc66-\udc69\udc6e\udc70-\udc78\udc7c\udc81-\udc83\udc85-\udc87\udcaa\udd7a\udd95\udd96\ude45-\ude47\ude4b-\ude4f\udea3\udeb4-\udeb6\udec0\udecc]|\ud83e[\udd0c\udd0f\udd18-\udd1c\udd1e\udd1f\udd26\udd30-\udd39\udd3d\udd3e\udd77\uddb5\uddb6\uddb8\uddb9\uddbb\uddcd-\uddcf\uddd1-\udddd\udec3-\udec5\udef0-\udef6]|[\u270a\u270b]))(?:\ud83c[\udffb-\udfff])?|(?:\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc65\udb40\udc6e\udb40\udc67\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc73\udb40\udc63\udb40\udc74\udb40\udc7f|\ud83c\udff4\udb40\udc67\udb40\udc62\udb40\udc77\udb40\udc6c\udb40\udc73\udb40\udc7f|\ud83c\udde6\ud83c[\udde8-\uddec\uddee\uddf1\uddf2\uddf4\uddf6-\uddfa\uddfc\uddfd\uddff]|\ud83c\udde7\ud83c[\udde6\udde7\udde9-\uddef\uddf1-\uddf4\uddf6-\uddf9\uddfb\uddfc\uddfe\uddff]|\ud83c\udde8\ud83c[\udde6\udde8\udde9\uddeb-\uddee\uddf0-\uddf5\uddf7\uddfa-\uddff]|\ud83c\udde9\ud83c[\uddea\uddec\uddef\uddf0\uddf2\uddf4\uddff]|\ud83c\uddea\ud83c[\udde6\udde8\uddea\uddec\udded\uddf7-\uddfa]|\ud83c\uddeb\ud83c[\uddee-\uddf0\uddf2\uddf4\uddf7]|\ud83c\uddec\ud83c[\udde6\udde7\udde9-\uddee\uddf1-\uddf3\uddf5-\uddfa\uddfc\uddfe]|\ud83c\udded\ud83c[\uddf0\uddf2\uddf3\uddf7\uddf9\uddfa]|\ud83c\uddee\ud83c[\udde8-\uddea\uddf1-\uddf4\uddf6-\uddf9]|\ud83c\uddef\ud83c[\uddea\uddf2\uddf4\uddf5]|\ud83c\uddf0\ud83c[\uddea\uddec-\uddee\uddf2\uddf3\uddf5\uddf7\uddfc\uddfe\uddff]|\ud83c\uddf1\ud83c[\udde6-\udde8\uddee\uddf0\uddf7-\uddfb\uddfe]|\ud83c\uddf2\ud83c[\udde6\udde8-\udded\uddf0-\uddff]|\ud83c\uddf3\ud83c[\udde6\udde8\uddea-\uddec\uddee\uddf1\uddf4\uddf5\uddf7\uddfa\uddff]|\ud83c\uddf4\ud83c\uddf2|\ud83c\uddf5\ud83c[\udde6\uddea-\udded\uddf0-\uddf3\uddf7-\uddf9\uddfc\uddfe]|\ud83c\uddf6\ud83c\udde6|\ud83c\uddf7\ud83c[\uddea\uddf4\uddf8\uddfa\uddfc]|\ud83c\uddf8\ud83c[\udde6-\uddea\uddec-\uddf4\uddf7-\uddf9\uddfb\uddfd-\uddff]|\ud83c\uddf9\ud83c[\udde6\udde8\udde9\uddeb-\udded\uddef-\uddf4\uddf7\uddf9\uddfb\uddfc\uddff]|\ud83c\uddfa\ud83c[\udde6\uddec\uddf2\uddf3\uddf8\uddfe\uddff]|\ud83c\uddfb\ud83c[\udde6\udde8\uddea\uddec\uddee\uddf3\uddfa]|\ud83c\uddfc\ud83c[\uddeb\uddf8]|\ud83c\uddfd\ud83c\uddf0|\ud83c\uddfe\ud83c[\uddea\uddf9]|\ud83c\uddff\ud83c[\udde6\uddf2\uddfc]|\ud83c[\udccf\udd8e\udd91-\udd9a\udde6-\uddff\ude01\ude32-\ude36\ude38-\ude3a\ude50\ude51\udf00-\udf20\udf2d-\udf35\udf37-\udf7c\udf7e-\udf84\udf86-\udf93\udfa0-\udfc1\udfc5\udfc6\udfc8\udfc9\udfcf-\udfd3\udfe0-\udff0\udff4\udff8-\udfff]|\ud83d[\udc00-\udc3e\udc40\udc44\udc45\udc51-\udc65\udc6a\udc6f\udc79-\udc7b\udc7d-\udc80\udc84\udc88-\udc8e\udc90\udc92-\udca9\udcab-\udcfc\udcff-\udd3d\udd4b-\udd4e\udd50-\udd67\udda4\uddfb-\ude44\ude48-\ude4a\ude80-\udea2\udea4-\udeb3\udeb7-\udebf\udec1-\udec5\uded0-\uded2\uded5-\uded7\udedd-\udedf\udeeb\udeec\udef4-\udefc\udfe0-\udfeb\udff0]|\ud83e[\udd0d\udd0e\udd10-\udd17\udd20-\udd25\udd27-\udd2f\udd3a\udd3c\udd3f-\udd45\udd47-\udd76\udd78-\uddb4\uddb7\uddba\uddbc-\uddcc\uddd0\uddde-\uddff\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec2\uded0-\uded9\udee0-\udee7]|[\u23e9-\u23ec\u23f0\u23f3\u267e\u26ce\u2705\u2728\u274c\u274e\u2753-\u2755\u2795-\u2797\u27b0\u27bf\ue50a])|\ufe0f/g,UFE0Fg=/\uFE0F/g,U200D=String.fromCharCode(8205),rescaper=/[&<>'"]/g,shouldntBeParsed=/^(?:iframe|noframes|noscript|script|select|style|textarea)$/,fromCharCode=String.fromCharCode;return twemoji;function createText(text,clean){return document.createTextNode(clean?text.replace(UFE0Fg,""):text)}function escapeHTML(s){return s.replace(rescaper,replacer)}function defaultImageSrcGenerator(icon,options){return "".concat(options.base,options.size,"/",icon,options.ext)}function grabAllTextNodes(node,allText){var childNodes=node.childNodes,length=childNodes.length,subnode,nodeType;while(length--){subnode=childNodes[length];nodeType=subnode.nodeType;if(nodeType===3){allText.push(subnode);}else if(nodeType===1&&!("ownerSVGElement"in subnode)&&!shouldntBeParsed.test(subnode.nodeName.toLowerCase())){grabAllTextNodes(subnode,allText);}}return allText}function grabTheRightIcon(rawText){return toCodePoint(rawText.indexOf(U200D)<0?rawText.replace(UFE0Fg,""):rawText)}function parseNode(node,options){var allText=grabAllTextNodes(node,[]),length=allText.length,attrib,attrname,modified,fragment,subnode,text,match,i,index,img,rawText,iconId,src;while(length--){modified=false;fragment=document.createDocumentFragment();subnode=allText[length];text=subnode.nodeValue;i=0;while(match=re.exec(text)){index=match.index;if(index!==i){fragment.appendChild(createText(text.slice(i,index),true));}rawText=match[0];iconId=grabTheRightIcon(rawText);i=index+rawText.length;src=options.callback(iconId,options);if(iconId&&src){img=new Image;img.onerror=options.onerror;img.setAttribute("draggable","false");attrib=options.attributes(rawText,iconId);for(attrname in attrib){if(attrib.hasOwnProperty(attrname)&&attrname.indexOf("on")!==0&&!img.hasAttribute(attrname)){img.setAttribute(attrname,attrib[attrname]);}}img.className=options.className;img.alt=rawText;img.src=src;modified=true;fragment.appendChild(img);}if(!img)fragment.appendChild(createText(rawText,false));img=null;}if(modified){if(i<text.length){fragment.appendChild(createText(text.slice(i),true));}subnode.parentNode.replaceChild(fragment,subnode);}}return node}function parseString(str,options){return replace(str,function(rawText){var ret=rawText,iconId=grabTheRightIcon(rawText),src=options.callback(iconId,options),attrib,attrname;if(iconId&&src){ret="<img ".concat('class="',options.className,'" ','draggable="false" ','alt="',rawText,'"',' src="',src,'"');attrib=options.attributes(rawText,iconId);for(attrname in attrib){if(attrib.hasOwnProperty(attrname)&&attrname.indexOf("on")!==0&&ret.indexOf(" "+attrname+"=")===-1){ret=ret.concat(" ",attrname,'="',escapeHTML(attrib[attrname]),'"');}}ret=ret.concat("/>");}return ret})}function replacer(m){return escaper[m]}function returnNull(){return null}function toSizeSquaredAsset(value){return typeof value==="number"?value+"x"+value:value}function fromCodePoint(codepoint){var code=typeof codepoint==="string"?parseInt(codepoint,16):codepoint;if(code<65536){return fromCharCode(code)}code-=65536;return fromCharCode(55296+(code>>10),56320+(code&1023))}function parse(what,how){if(!how||typeof how==="function"){how={callback:how};}return (typeof what==="string"?parseString:parseNode)(what,{callback:how.callback||defaultImageSrcGenerator,attributes:typeof how.attributes==="function"?how.attributes:returnNull,base:typeof how.base==="string"?how.base:twemoji.base,ext:how.ext||twemoji.ext,size:how.folder||toSizeSquaredAsset(how.size||twemoji.size),className:how.className||twemoji.className,onerror:how.onerror||twemoji.onerror})}function replace(text,callback){return String(text).replace(re,callback)}function test(text){re.lastIndex=0;var result=re.test(text);re.lastIndex=0;return result}function toCodePoint(unicodeSurrogates,sep){var r=[],c=0,p=0,i=0;while(i<unicodeSurrogates.length){c=unicodeSurrogates.charCodeAt(i++);if(p){r.push((65536+(p-55296<<10)+(c-56320)).toString(16));p=0;}else if(55296<=c&&c<=56319){p=c;}else {r.push(c.toString(16));}}return r.join(sep||"-")}}();

var EmojiContainerStyled = styled.span(function (_a) {
    var size = _a.size;
    return ({
        "& .emoji": {
            height: "1em",
            width: "1em"
        },
        display: "inline-flex",
        fontSize: size !== null && size !== void 0 ? size : "inherit"
    });
});
/**
 * Wrapper for converting unicode emoji text to image.
 * this component rely on [twemoji](https://twemoji.twitter.com/) package
 */
var PrettyEmoji = function (_a) {
    var emoji = _a.emoji, size = _a.size, id = _a.id;
    var emojiContainerRef = useRef();
    useEffect(function () {
        var _a;
        if (emoji && (emojiContainerRef === null || emojiContainerRef === void 0 ? void 0 : emojiContainerRef.current)) {
            /**
             * Using this base instead of the default maxcdn which has been shut down
             * https://github.com/twitter/twemoji/issues/580
             *
             */
            var twemojiBase = (_a = twemoji === null || twemoji === void 0 ? void 0 : twemoji.base) === null || _a === void 0 ? void 0 : _a.replace("twemoji.maxcdn.com/v", "cdnjs.cloudflare.com/ajax/libs/twemoji");
            twemoji.parse(emojiContainerRef.current, {
                ext: ".svg",
                folder: "svg",
                base: twemojiBase
            });
        }
    }, [emoji, emojiContainerRef.current]);
    return (React__default.createElement(EmojiContainerStyled, { size: size, id: id, "data-testid": "mpui-emoji", ref: emojiContainerRef }, emoji));
};
PrettyEmoji.propTypes = {
    emoji: PropTypes.string.isRequired,
    id: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

var TypographyWithClassName = function (_a) {
    var className = _a.className, UNSAFE_props = _a.UNSAFE_props, otherProps = __rest(_a, ["className", "UNSAFE_props"]);
    return (React__default.createElement(Typography, __assign({}, otherProps, { UNSAFE_props: __assign({ className: className }, UNSAFE_props) })));
};
var pricingTableColors = function (designContext) { return ({
    bgSuccessColor: toRgba(designContext.get("colors/backgrounds/success-inline"), 0.2),
    divider: designContext.get("colors/borders/subtle-inline").toString(),
    textNeutralColor: designContext.get("colors/text/neutral").toString()
}); };
var GrayTitleStyled = styled(TypographyWithClassName).attrs({
    accessibilityPreset: "heading 3",
    textToken: "text-style/headings/titles/bold/grande"
})(function (_a) {
    var colors = _a.colors;
    return ({
        color: "".concat(colors.textNeutralColor, " !important"),
        marginBottom: "-10px !important",
        marginTop: "-5px !important",
        paddingBottom: "3px !important",
        paddingTop: "2px !important"
    });
});
var StrikeThroughTitle = styled(TypographyWithClassName).attrs({
    accessibilityPreset: "heading 2",
    textToken: "text-style/headings/titles/bold/tertiary"
})(function (_a) {
    var colors = _a.colors;
    return ({
        color: "".concat(colors.textNeutralColor, " !important"),
        letterSpacing: "-0.2px !important",
        marginBottom: "-10px !important",
        marginTop: "-5px !important",
        paddingBottom: "4px !important",
        paddingTop: "1px !important",
        textDecoration: "line-through"
    });
});
var CtaButton = function (_a) {
    var id = _a.id, name = _a.name, onClick = _a.onClick;
    var handleOnClick = function () { return onClick(id); };
    return (React__default.createElement(ButtonPrimary, { icon: IconChevronRight, iconAlignment: "right", onClick: handleOnClick }, name));
};
/**
 * A pricing table that accepts a collection of plans and features and displays them in an attractive way. It has a desktop version and a mobile/tablet version.
 */
var PricingTable = function (_a) {
    var currency = _a.currency, description = _a.description, features = _a.features, footerContent = _a.footerContent, footerLabel = _a.footerLabel, id = _a.id, onClick = _a.onClick, originalPriceDescription = _a.originalPriceDescription, _b = _a.plans, plans = _b === void 0 ? [] : _b, _c = _a.priceLabel, priceLabel = _c === void 0 ? "" : _c, title = _a.title;
    var designContext = useDesignContext();
    var colors = useMemo(function () { return pricingTableColors(designContext); }, [designContext]);
    return (React__default.createElement("div", { id: id },
        React__default.createElement("table", { cellPadding: 15, style: { borderCollapse: "collapse", width: "1150px" } },
            React__default.createElement("colgroup", null,
                React__default.createElement("col", { span: 1, style: { width: "460px" } }),
                plans.map(function (plan) { return (React__default.createElement("col", { key: plan.id, span: 1, style: { width: "".concat((1150 - 460) / plans.length, "px") } })); })),
            React__default.createElement("thead", null,
                React__default.createElement("tr", { style: { borderBottom: "1px solid ".concat(colors.divider) } },
                    React__default.createElement("th", null,
                        React__default.createElement(TitleSecondary, { correctFootprint: true }, title)),
                    plans.map(function (plan) { return (React__default.createElement("th", { key: plan.id },
                        React__default.createElement(TitleSecondary, { correctFootprint: true }, plan.name))); }))),
            React__default.createElement("tbody", null,
                originalPriceDescription && (React__default.createElement("tr", null,
                    React__default.createElement("th", null,
                        React__default.createElement(GrayTitleStyled, { colors: colors }, originalPriceDescription)),
                    plans.map(function (plan) { return (React__default.createElement("th", { key: plan.id },
                        React__default.createElement(StrikeThroughTitle, { colors: colors }, "".concat(plan.originalPrices[currency]).concat(priceLabel)))); }))),
                React__default.createElement("tr", null,
                    React__default.createElement("th", null,
                        React__default.createElement(TitleTertiary, { correctFootprint: true }, description)),
                    plans.map(function (plan) { return (React__default.createElement("th", { key: plan.id },
                        React__default.createElement(TitlePrimary, { small: true, correctFootprint: true }, "".concat(plan.prices[currency]).concat(priceLabel)))); })),
                features.map(function (feature, featureIndex) { return (React__default.createElement("tr", { style: { height: "60px" }, key: feature.id },
                    React__default.createElement("td", { style: {
                            borderTop: "1px solid ".concat(colors.divider)
                        } },
                        React__default.createElement(TitleTertiary, null, feature.content)),
                    plans.map(function (plan) { return (React__default.createElement("td", { key: plan.id, style: {
                            backgroundColor: feature.plans[plan.id] && colors.bgSuccessColor,
                            borderRight: "0px",
                            borderTop: "1px solid",
                            borderTopColor: feature.plans[plan.id] && featureIndex !== 0
                                ? "#C9EAD6"
                                : colors.divider,
                            textAlign: "left"
                        } }, feature.plans[plan.id] ? (React__default.createElement(Flex, { spacing: "space.50", style: { alignItems: "center" } },
                        React__default.createElement(IconCheckmark, { colorToken: "colors/borders/success" }),
                        feature.planContent && feature.planContent[plan.id])) : (React__default.createElement(IconClose, { colorToken: "colors/borders/default", colorTokenArgs: { interactiveState: "disabled" } })))); }))); })),
            React__default.createElement("tfoot", null,
                footerContent && (React__default.createElement("tr", null,
                    React__default.createElement("td", { colSpan: 100, style: {
                            borderBottom: "2px solid ".concat(colors.divider)
                        } }, footerContent.map(function (content, i) { return (React__default.createElement("div", { key: i }, content)); })))),
                React__default.createElement("tr", { style: {
                        height: "110px"
                    } },
                    React__default.createElement("td", null,
                        React__default.createElement(TitleSecondary, null, footerLabel)),
                    plans.map(function (plan) { return (React__default.createElement("td", { key: plan.id },
                        React__default.createElement(Flex, { column: true },
                            React__default.createElement(CtaButton, { id: plan.id, name: plan.name, onClick: onClick })))); }))))));
};
PricingTable.propTypes = {
    currency: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    features: PropTypes.array.isRequired,
    footerContent: PropTypes.array,
    footerLabel: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    originalPriceDescription: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    plans: PropTypes.array.isRequired,
    priceLabel: PropTypes.string,
    title: PropTypes.string
};
var index$1 = React__default.memo(PricingTable);

var searchFieldColors = function (designContext) { return ({
    containerBgColor: designContext
        .get("colors/backgrounds/subtle-inline")
        .toString(),
    disabledBgColor: designContext
        .get("colors/backgrounds/subtle-inline", {
        interactiveState: "disabled"
    })
        .toString(),
    activeBgColor: designContext
        .get("colors/backgrounds/subtle-inline", {
        interactiveState: "pressed"
    })
        .toString(),
    borderSeparatorColor: designContext
        .get("colors/borders/subtle-floating")
        .toString()
}); };
var ContainerStyled = styled.div(function (_a) {
    var colors = _a.colors, disabled = _a.disabled;
    return ({
        alignItems: "center",
        background: colors.containerBgColor,
        borderRadius: useCornerRadius("round"),
        display: "flex",
        flex: 1,
        flexGrow: 1,
        minWidth: "250px",
        transition: "opacity 0.3s ease 0.3s",
        width: "100%",
        "&:active": {
            background: !disabled && colors.activeBgColor
        }
    });
});
var SearchContainerStyled = styled.div(function (_a) {
    var isValueEmpty = _a.isValueEmpty, colors = _a.colors; _a.disabled;
    return ({
        alignItems: "center",
        borderLeft: isValueEmpty
            ? "none"
            : "1px solid ".concat(colors.borderSeparatorColor),
        display: "flex",
        background: colors.containerBgColor,
        height: "20px"
    });
});
var ClearButtonStyled = styled.button(function (_a) {
    var colors = _a.colors, isValueEmpty = _a.isValueEmpty, disabled = _a.disabled;
    return ({
        background: disabled ? colors.disabledBgColor : colors.containerBgColor,
        border: "none",
        borderRadius: useCornerRadius("round"),
        cursor: "pointer",
        height: "20px",
        marginRight: "10px",
        opacity: isValueEmpty ? 0 : 1,
        outlineWidth: 0,
        padding: 0,
        position: "relative",
        transition: "opacity 0.2s ease 0s",
        visibility: isValueEmpty ? "hidden" : "visible",
        width: "20px",
        "&:active, &:hover": {
            background: colors.activeBgColor
        }
    });
});
var SearchWrapperStyled = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"
    /** A search field.
     * Default behaviour is search-as-you-type, but it is also possible to search on button click, disabling the search as you type functionality.
     * It also triggers the search on Enter and has a Clear Text functionality when input is not empty.
     */
])));
/** A search field.
 * Default behaviour is search-as-you-type, but it is also possible to search on button click, disabling the search as you type functionality.
 * It also triggers the search on Enter and has a Clear Text functionality when input is not empty.
 */
var SearchField = function (_a) {
    var _b, _c;
    var _d = _a.buttonLabel, buttonLabel = _d === void 0 ? "Search" : _d, disabled = _a.disabled, _e = _a.debounceDelay, debounceDelay = _e === void 0 ? 200 : _e, focused = _a.focused, id = _a.id, _f = _a.label, label = _f === void 0 ? "Search" : _f, onButtonClick = _a.onButtonClick, onChange = _a.onChange, onEnterTrigger = _a.onEnter, onClear = _a.onClear, value = _a.value, withButton = _a.withButton;
    var searchBoxRef = useRef();
    var _g = useState(""), searchTerm = _g[0], setSearchTerm = _g[1];
    var fieldId = ((_b = id === null || id === void 0 ? void 0 : id.trim()) === null || _b === void 0 ? void 0 : _b.length) ? id : "mpui_search-field";
    var testIdPrefix = ((_c = id === null || id === void 0 ? void 0 : id.trim()) === null || _c === void 0 ? void 0 : _c.length) ? id : "mpui_search";
    var isValueEmpty = function () { return !searchTerm || !searchTerm.length; };
    var triggerOnChange = function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(searchTerm);
        // Position the cursor at the end of the query
        var searchLength = searchBoxRef.current.value.length;
        searchBoxRef.current.focus();
        searchBoxRef.current.setSelectionRange(searchLength, searchLength);
    };
    var onEnter = function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            triggerOnChange();
            onEnterTrigger === null || onEnterTrigger === void 0 ? void 0 : onEnterTrigger(searchTerm);
        }
    };
    var handleOnClick = function () {
        onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(searchTerm);
        triggerOnChange();
    };
    var resetInput = function () {
        onChange === null || onChange === void 0 ? void 0 : onChange("");
        setSearchTerm("");
        searchBoxRef.current.focus();
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    var selectText = function (e) {
        e.target.select();
    };
    useEffect(function () {
        if (!searchBoxRef.current) {
            searchBoxRef.current = document.getElementById(fieldId);
        }
    }, [fieldId]);
    useEffect(function () {
        if (searchBoxRef.current) {
            searchBoxRef.current.autocomplete = "off";
            searchBoxRef.current.addEventListener("focus", selectText);
            searchBoxRef.current.addEventListener("keyup", onEnter);
        }
        return function () {
            if (searchBoxRef.current) {
                searchBoxRef.current.removeEventListener("focus", selectText);
                searchBoxRef.current.removeEventListener("keyup", onEnter);
            }
        };
    }, [searchBoxRef.current, onEnter, selectText]);
    useEffect(function () {
        if (searchBoxRef.current) {
            if (focused) {
                searchBoxRef.current.focus();
            }
            if (!withButton) {
                var typingObservable$ = fromEvent(searchBoxRef.current, "input").pipe(debounceTime(debounceDelay), map(function (e) { return e.target.value; }), distinctUntilChanged());
                var typingSubscription1_1 = typingObservable$.subscribe(onChange);
                return function () {
                    typingSubscription1_1.unsubscribe();
                };
            }
        }
    }, []);
    var designContext = useDesignContext();
    var colors = useMemo(function () { return searchFieldColors(designContext); }, [designContext]);
    useEffect(function () {
        if (value !== undefined && searchTerm !== value) {
            setSearchTerm(value);
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }
    }, [value, onChange]);
    return (React__default.createElement(ContainerStyled, { colors: colors, disabled: disabled, isValueEmpty: isValueEmpty() },
        React__default.createElement(SearchWrapperStyled, null,
            React__default.createElement("style", { type: "text/css", dangerouslySetInnerHTML: {
                    __html: "input[id=".concat(id, "]::-ms-clear {display: none}")
                } }),
            React__default.createElement(FieldSimple, { "data-testid": "".concat(testIdPrefix, "-field"), disabled: disabled, id: fieldId, label: label, onChange: setSearchTerm, size: "medium", value: searchTerm, withIcon: true })),
        React__default.createElement(ClearButtonStyled, { disabled: disabled, "data-testid": "".concat(testIdPrefix, "-field-clear"), onClick: resetInput, colors: colors, isValueEmpty: isValueEmpty() },
            React__default.createElement(ActionIconClose, { colorToken: "colors/text/neutral" })),
        withButton && (React__default.createElement(SearchContainerStyled, { colors: colors, disabled: disabled, isValueEmpty: isValueEmpty() },
            React__default.createElement(SpacerHorizontal, { spaceToken: "space.150" }),
            React__default.createElement(ButtonPrimary, { "data-testid": "".concat(testIdPrefix, "-field_search"), disabled: isValueEmpty(), size: "small", onClick: handleOnClick }, buttonLabel),
            React__default.createElement(SpacerHorizontal, { spaceToken: "space.unit" })))));
};
SearchField.propTypes = {
    buttonLabel: PropTypes.string,
    debounceDelay: PropTypes.number,
    disabled: PropTypes.bool,
    focused: PropTypes.bool,
    id: PropTypes.string,
    label: PropTypes.string,
    onButtonClick: PropTypes.func,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    value: PropTypes.string,
    withButton: PropTypes.bool
};
var templateObject_1$5;

var styles = {
    firefoxClickSupport: {
        bottom: 0,
        left: 0,
        position: "absolute",
        right: 0,
        top: 0
    },
    triggerContainerArrow: function (_a) {
        var borderless = _a.borderless;
        return ({
            position: "absolute",
            right: borderless ? 0 : "16px",
            top: "20px",
            zIndex: 1
        });
    }
};
var isInternalTrigger = function (triggerType) {
    return triggerType === SelectorTriggerBorderless ||
        triggerType === SelectorTriggerDefault;
};
var SelectorTriggerDefault = function (_a) {
    var disabled = _a.disabled, label = _a.label, loading = _a.loading, value = _a.value;
    // Note: this fixes behaviour in Safari & Firefox where you can see a cursor inside the trigger
    var triggerRef = useRef(null);
    useEffect(function () {
        var _a;
        var inputElement = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
        if (inputElement) {
            inputElement.style.cursor = "pointer";
            inputElement.disabled = "true";
        }
    }, [triggerRef]);
    return (React__default.createElement("div", { "data-testid": "mpui_selector_trigger", ref: triggerRef },
        React__default.createElement(Field$2, { disabled: disabled, label: label, loading: loading, value: value }),
        React__default.createElement("div", { style: styles.firefoxClickSupport }),
        React__default.createElement("div", { style: styles.triggerContainerArrow({ borderless: false }) }, !loading && (React__default.createElement(ActionIconChevronBottom, { colorToken: "colors/text/neutral" })))));
};
var SelectorTriggerBorderless = function (_a) {
    var disabled = _a.disabled, label = _a.label, loading = _a.loading, value = _a.value;
    // Note: this fixes behaviour in Safari & Firefox where you can see a cursor inside the trigger
    var triggerRef = useRef(null);
    useEffect(function () {
        var _a;
        var inputElement = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
        if (inputElement) {
            inputElement.style.cursor = "pointer";
            inputElement.disabled = "true";
        }
    }, [triggerRef]);
    return (React__default.createElement("div", { "data-testid": "mpui_selector_trigger-borderless", ref: triggerRef },
        React__default.createElement(Field$2, { disabled: disabled, label: label, loading: loading, value: value, isUnderlined: true }),
        React__default.createElement("div", { style: styles.firefoxClickSupport }),
        React__default.createElement("div", { style: styles.triggerContainerArrow({ borderless: true }) }, !loading && (React__default.createElement(ActionIconChevronBottom, { colorToken: "colors/text/neutral" })))));
};

/** Internal base component for single selector, to be able to reuse the functionality */
var BaseSingleSelector = function (selectorProps) {
    var borderless = selectorProps.borderless, closeLabel = selectorProps.closeLabel, children = selectorProps.children, disabled = selectorProps.disabled, disabledLabel = selectorProps.disabledLabel, isFullWidthTrigger = selectorProps.isFullWidthTrigger, id = selectorProps.id, openOverlayOnMount = selectorProps.openOverlayOnMount, label = selectorProps.label, loading = selectorProps.loading, maxHeight = selectorProps.maxHeight, maxWidth = selectorProps.maxWidth, onClose = selectorProps.onClose, onChange = selectorProps.onChange, onOpen = selectorProps.onOpen, options = selectorProps.options, value = selectorProps.value, optionSettings = selectorProps.optionSettings;
    var _a = useState(value), selectedOption = _a[0], setSelectedOption = _a[1];
    var didMountSelectedOption = useRef(false);
    var _b = useState(disabled), isDisabled = _b[0], setIsDisabled = _b[1];
    var _c = useState(""), displayValue = _c[0], setDisplayValue = _c[1];
    var _d = useState(openOverlayOnMount), isOpen = _d[0], setIsOpen = _d[1];
    var handleClose = function () {
        onClose(selectedOption);
        setIsOpen(false);
    };
    var handleOpen = function () {
        onOpen();
        setIsOpen(true);
    };
    var handleSelectedOption = function (selectedValue) {
        setSelectedOption(selectedValue);
        setIsOpen(false);
    };
    var updateDisplayValue = function () {
        var _a;
        if (isDisabled && disabledLabel) {
            setDisplayValue(disabledLabel);
        }
        else {
            if (selectedOption) {
                setDisplayValue((_a = options.find(function (option) { return option.value === selectedOption; })) === null || _a === void 0 ? void 0 : _a.label);
            }
        }
    };
    useEffect(function () {
        setIsDisabled(!!disabled || (!loading && options.length === 0));
        updateDisplayValue();
    }, [options, disabled]);
    useEffect(function () {
        if (value !== undefined) {
            setSelectedOption(value);
        }
        // Force reset the display value
        if (value === null) {
            setDisplayValue("");
        }
    }, [value]);
    useEffect(function () {
        if (didMountSelectedOption.current) {
            onChange(selectedOption);
        }
        else {
            didMountSelectedOption.current = true;
        }
        updateDisplayValue();
    }, [selectedOption]);
    var triggerProps = {
        disabled: isDisabled,
        label: label,
        loading: loading,
        value: displayValue
    };
    var _e = useState(null), customSelectorTrigger = _e[0], setCustomSelectorTrigger = _e[1];
    useEffect(function () {
        var CustomTrigger = React__default.Children.count(children) > 0 && React__default.Children.only(children);
        if (React__default.isValidElement(CustomTrigger)) {
            setCustomSelectorTrigger(React__default.cloneElement(CustomTrigger, __assign(__assign({}, triggerProps), { 
                // @ts-ignore: for some reason
                children: CustomTrigger.props.children || displayValue || label })));
        }
    }, [displayValue, children]);
    var optionsContent = useMemo(function () {
        var OptionsComponent = optionSettings.component, withValue = optionSettings.withValue;
        var props = __assign({ "data-testid": "".concat(id, "_option"), onSelect: handleSelectedOption, options: options }, (withValue && { value: selectedOption }));
        return React__default.createElement(OptionsComponent, __assign({}, props));
    }, [id, options, selectedOption, optionSettings, handleSelectedOption]);
    return (React__default.createElement(Overlay, { id: id, trigger: customSelectorTrigger ||
            (borderless && React__default.createElement(SelectorTriggerBorderless, __assign({}, triggerProps))) || (React__default.createElement(SelectorTriggerDefault, __assign({}, triggerProps))), isOpen: isOpen, disabled: isDisabled || loading, onOpen: handleOpen, onClose: handleClose, closeLabel: closeLabel, isFullWidthTrigger: isFullWidthTrigger ||
            !customSelectorTrigger ||
            isInternalTrigger(customSelectorTrigger.type), maxHeight: maxHeight, maxWidth: maxWidth, role: "combobox", "aria-label": label, "aria-haspopup": "listbox" }, optionsContent));
};
var BasePropTypes = {
    borderless: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    closeLabel: PropTypes.string,
    disabled: PropTypes.bool,
    disabledLabel: PropTypes.string,
    emptyStateLabel: PropTypes.string,
    id: PropTypes.string,
    isFullWidthTrigger: PropTypes.bool,
    label: PropTypes.string,
    loading: PropTypes.bool,
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    openOverlayOnMount: PropTypes.bool,
    options: PropTypes.array,
    value: PropTypes.string
};

/**
 * A variant of the basic Selector.<br />
 * There is no concept of "selected" value, and instead of radio buttons the options have a different set of features.
 */
var DirectSelector = function (selectorProps) {
    return (React__default.createElement(BaseSingleSelector, __assign({}, selectorProps, { optionSettings: {
            component: SelectorActionsheet,
            withValue: false
        } })));
};
DirectSelector.propTypes = BasePropTypes;
DirectSelector.defaultProps = {
    closeLabel: "Done",
    disabledLabel: "",
    id: "mpui_direct_selector",
    onChange: function () { return null; },
    onClose: function () { return null; },
    onOpen: function () { return null; },
    options: []
};

/** A mobile friendly Selector component with multiple selection, search and select all options functionalities in a non native overlay */
var MultiSelector = function (_a) {
    var borderless = _a.borderless, children = _a.children, _b = _a.closeLabel, closeLabel = _b === void 0 ? "Done" : _b, _c = _a.closeWithSelectionLabel, closeWithSelectionLabel = _c === void 0 ? "Apply # selection(s)" : _c, _d = _a.deselectAllOptionLabel, deselectAllOptionLabel = _d === void 0 ? "Clear Selection" : _d, disabled = _a.disabled, disabledLabel = _a.disabledLabel, _e = _a.emptyStateLabel, emptyStateLabel = _e === void 0 ? "No options found" : _e, isFullWidthTrigger = _a.isFullWidthTrigger, _f = _a.id, id = _f === void 0 ? "mpui_multiselector" : _f, values = _a.values, _g = _a.openOverlayOnMount, openOverlayOnMount = _g === void 0 ? false : _g, label = _a.label, loading = _a.loading, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth, _h = _a.onClose, onClose = _h === void 0 ? function () { return null; } : _h, _j = _a.onChange, onChange = _j === void 0 ? function () { return null; } : _j, _k = _a.options, options = _k === void 0 ? [] : _k, searchLabel = _a.searchLabel, _l = _a.selectAllOptionLabel, selectAllOptionLabel = _l === void 0 ? "Select all" : _l, _m = _a.selectedLabel, selectedLabel = _m === void 0 ? "# options selected" : _m, _o = _a.selectedAllLabel, selectedAllLabel = _o === void 0 ? "All options selected" : _o, withSearch = _a.withSearch, withSelectAll = _a.withSelectAll;
    var interactiveOptions = options.filter(function (option) { return !option.disabled; });
    var _p = useState(disabled), isDisabled = _p[0], setIsDisabled = _p[1];
    var _q = useState(""), displayValue = _q[0], setDisplayValue = _q[1];
    var _r = useState(closeLabel), closeButtonText = _r[0], setCloseButtonText = _r[1];
    var getDisabledCheckedOptions = function () {
        return options
            .filter(function (option) { return option.disabled && (values === null || values === void 0 ? void 0 : values.includes(option.value)); })
            .map(function (option) { return option.value; });
    };
    var _s = useState(values || []), selectedOptions = _s[0], setSelectedOptions = _s[1];
    var _t = useState(getDisabledCheckedOptions()), disabledCheckedOptions = _t[0], setDisabledCheckedOptions = _t[1];
    var _u = useState(interactiveOptions.length + disabledCheckedOptions.length ===
        selectedOptions.length), allOptionsSelected = _u[0], setAllOptionsSelected = _u[1];
    var _v = useState(""), query = _v[0], setQuery = _v[1];
    var didMountOptions = useRef(false);
    var selectorRef = useRef(null);
    var designContext = useDesignContext();
    var handleSelectAll = function () {
        handleMultiSelectOption(allOptionsSelected ? [] : interactiveOptions.map(function (option) { return option.value; }));
    };
    var handleMultiSelectOption = function (selectedValues) {
        setSelectedOptions(disabledCheckedOptions.every(function (option) { return selectedValues.includes(option); })
            ? selectedValues
            : selectedValues.concat(disabledCheckedOptions));
    };
    var updateDisplayValue = function () {
        if (isDisabled && disabledLabel) {
            setDisplayValue(disabledLabel);
        }
        else {
            if (selectedOptions.length ===
                interactiveOptions.length + disabledCheckedOptions.length &&
                options.length > 0) {
                if (options.length === 1) {
                    setDisplayValue(selectedOptions[0]);
                }
                else {
                    setDisplayValue(selectedAllLabel);
                }
            }
            else if (selectedOptions.length >= 3) {
                var formattedSelectedLabel = selectedLabel.replace(/#/gi, selectedOptions.length.toString());
                setDisplayValue(formattedSelectedLabel);
            }
            else {
                var selectedOptionsLabels = options
                    .filter(function (option) { return selectedOptions.includes(option.value); })
                    .map(function (option) { return option.label; });
                setDisplayValue(selectedOptionsLabels.join(", "));
            }
        }
        if (!selectedOptions.length) {
            setCloseButtonText(closeLabel);
        }
        else {
            setCloseButtonText(closeWithSelectionLabel.replace("#", "" + selectedOptions.length));
        }
    };
    useEffect(function () {
        if (values !== undefined) {
            setDisabledCheckedOptions(getDisabledCheckedOptions());
            setSelectedOptions(values);
        }
    }, [values]);
    useEffect(function () {
        setIsDisabled(!!disabled || (!loading && options.length === 0));
        updateDisplayValue();
    }, [options, disabled]);
    // Note: this fixes the bug of checkboxes closing the overlay
    useEffect(function () {
        var _a;
        var svgElements = (_a = selectorRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("svg");
        if (svgElements) {
            svgElements.forEach(function (element) {
                element.style.pointerEvents = "none";
            });
        }
        // eslint-disable-next-line no-sparse-arrays
    }, [, selectedOptions]);
    useEffect(function () {
        if (didMountOptions.current) {
            if (selectedOptions) {
                onChange(selectedOptions);
                setAllOptionsSelected(selectedOptions.length ===
                    interactiveOptions.length + disabledCheckedOptions.length);
            }
        }
        else {
            didMountOptions.current = true;
        }
        updateDisplayValue();
        // eslint-disable-next-line no-sparse-arrays
    }, [, selectedOptions]);
    var handleClose = function () {
        onClose(selectedOptions);
    };
    var filteredOptions = options.filter(function (option) {
        return [option.description, option.label, option.value]
            .filter(Boolean)
            .join("|") // Join with '|' to avoid false positives when using .includes()
            .toLowerCase()
            .includes(query.toLowerCase());
    });
    var triggerProps = {
        disabled: isDisabled,
        label: label,
        loading: loading,
        value: displayValue
    };
    var _w = useState(null), customSelectorTrigger = _w[0], setCustomSelectorTrigger = _w[1];
    useEffect(function () {
        var CustomTrigger = React__default.Children.count(children) > 0 && React__default.Children.only(children);
        if (React__default.isValidElement(CustomTrigger)) {
            setCustomSelectorTrigger(React__default.cloneElement(CustomTrigger, __assign(__assign({}, triggerProps), { 
                // @ts-ignore: for some reason
                children: CustomTrigger.props.children || displayValue || label })));
        }
    }, [displayValue, children]);
    var selectorProps = {
        "data-testid": "".concat(id, "_option"),
        onSelect: handleMultiSelectOption,
        options: options,
        values: selectedOptions
    };
    return (React__default.createElement(Overlay, { id: id, trigger: customSelectorTrigger ||
            (borderless && React__default.createElement(SelectorTriggerBorderless, __assign({}, triggerProps))) || (React__default.createElement(SelectorTriggerDefault, __assign({}, triggerProps))), isOpen: openOverlayOnMount, disabled: isDisabled || loading, onClose: handleClose, closeLabel: closeButtonText, isFullWidthTrigger: isFullWidthTrigger ||
            !customSelectorTrigger ||
            isInternalTrigger(customSelectorTrigger.type), maxHeight: maxHeight, maxWidth: maxWidth, role: "combobox", "aria-label": label, "aria-haspopup": "listbox", "aria-multiselectable": "true" },
        React__default.createElement(React__default.Fragment, null,
            withSearch && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { style: { padding: "15px 0" } },
                    React__default.createElement(SearchField, { id: "".concat(id, "_search"), value: query, label: searchLabel, onChange: setQuery, debounceDelay: 200 })),
                React__default.createElement(Separator, null))),
            !query && withSelectAll && (React__default.createElement("div", { style: {
                    borderBottom: "1px solid ".concat(designContext
                        .get("colors/backgrounds/subtle-inline")
                        .toString())
                } },
                React__default.createElement(SpacerVertical, { spaceToken: "space.300" }),
                React__default.createElement(Link, { onPress: handleSelectAll },
                    React__default.createElement(Strong, null, allOptionsSelected
                        ? deselectAllOptionLabel
                        : "".concat(selectAllOptionLabel, " (").concat(interactiveOptions.length + disabledCheckedOptions.length, ")"))),
                React__default.createElement(SpacerVertical, { spaceToken: "space.300" }))),
            React__default.createElement("div", { ref: selectorRef }, withSearch ? (filteredOptions.length > 0 ? (React__default.createElement(SelectorOptionsMulti, __assign({}, selectorProps, { options: filteredOptions }))) : (React__default.createElement("div", { style: { padding: "15px 0" } },
                React__default.createElement(Typography, { textToken: "text-style/text/labels/body/medium" }, emptyStateLabel)))) : (React__default.createElement(SelectorOptionsMulti, __assign({}, selectorProps)))))));
};
MultiSelector.propTypes = {
    borderless: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    closeLabel: PropTypes.string,
    closeWithSelectionLabel: PropTypes.string,
    deselectAllOptionLabel: PropTypes.string,
    disabled: PropTypes.bool,
    disabledLabel: PropTypes.string,
    emptyStateLabel: PropTypes.string,
    id: PropTypes.string,
    isFullWidthTrigger: PropTypes.bool,
    label: PropTypes.string,
    loading: PropTypes.bool,
    maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    openOverlayOnMount: PropTypes.bool,
    options: PropTypes.array,
    searchLabel: PropTypes.string,
    selectAllOptionLabel: PropTypes.string,
    selectedAllLabel: PropTypes.string,
    selectedLabel: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string),
    withSearch: PropTypes.bool,
    withSelectAll: PropTypes.bool
};

/** A mobile friendly Selector component with single selection in a non native overlay */
var Selector = function (selectorProps) {
    return (React__default.createElement(BaseSingleSelector, __assign({}, selectorProps, { optionSettings: {
            component: SelectorOptions,
            withValue: true
        } })));
};
Selector.defaultProps = {
    closeLabel: "Done",
    disabledLabel: "",
    id: "mpui_selector",
    onChange: function () { return null; },
    onClose: function () { return null; },
    onOpen: function () { return null; },
    options: []
};
Selector.propTypes = BasePropTypes;

function useWidth(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.liveMeasure, liveMeasure = _c === void 0 ? true : _c;
    var _d = useState(0), width = _d[0], setWidth = _d[1];
    var _e = useState(null), node = _e[0], setNode = _e[1];
    var ref = useCallback(function (currentNode) { return setNode(currentNode); }, []);
    useLayoutEffect(function () {
        if (node) {
            var measure = function () { return setWidth(node.getBoundingClientRect().width); };
            measure();
            if (liveMeasure) {
                var resizeObservable = fromEvent(window, "resize").pipe(auditTime(100));
                var resizeSubscription_1 = resizeObservable.subscribe(measure);
                return function () { return resizeSubscription_1.unsubscribe(); };
            }
        }
    }, [node]);
    return [ref, width];
}

var fonts = function () { return css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  font-family: ", ";\n"], ["\n  font-family: ", ";\n"])), function (_a) {
    var useMonoFont = _a.useMonoFont;
    return useMonoFont && "Klarna Text Mono";
}); };
var colorMappings = function (designContext) { return ({
    backgroundAccent: designContext.get("colors/borders/accent").toString(),
    backgroundAccentHovered: designContext
        .get("colors/borders/accent", { interactiveState: "hovered" })
        .toString(),
    backgroundDefault: designContext.get("colors/backgrounds/inverse").toString(),
    backgroundDisabled: designContext
        .get("colors/backgrounds/inverse", { interactiveState: "disabled" })
        .toString(),
    backgroundDisabledWithBorder: designContext
        .get("colors/borders/subtle-inline")
        .toString(),
    backgroundErrorWithBorder: designContext
        .get("colors/backgrounds/error-inline")
        .toString(),
    backgroundInverse: designContext.get("colors/backgrounds/default").toString(),
    backgroundInverseHovered: designContext
        .get("colors/backgrounds/default", { interactiveState: "hovered" })
        .toString(),
    backgroundSubtleInline: designContext
        .get("colors/backgrounds/subtle-inline")
        .toString(),
    backgroundWarningWithBorder: designContext
        .get("colors/backgrounds/warning-inline")
        .toString(),
    borderAccent: designContext.get("colors/borders/accent").toString(),
    borderDefault: designContext.get("colors/borders/default").toString(),
    borderDisabled: designContext
        .get("colors/borders/default", { interactiveState: "disabled" })
        .toString(),
    borderError: designContext.get("colors/borders/error").toString(),
    borderNeutral: designContext.get("colors/borders/neutral").toString(),
    borderNeutralPressed: designContext
        .get("colors/borders/neutral", { interactiveState: "pressed" })
        .toString(),
    borderSubtleFloating: designContext
        .get("colors/borders/subtle-floating")
        .toString(),
    borderWarning: designContext.get("colors/borders/warning").toString(),
    iconNeutral: designContext.get("colors/borders/neutral").toString(),
    textDefault: designContext.get("colors/text/default").toString(),
    textDisabled: designContext
        .get("colors/text/default", { interactiveState: "disabled" })
        .toString()
}); };
var StyledTableWrapper = styled.div(function () { return css(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n    width: 100%;\n    overflow-x: scroll;\n    scroll-behavior: smooth;\n\n    &::-webkit-scrollbar {\n      -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n      height: 11px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border-radius: ", ";\n      border: 2px solid white;\n      background-color: rgba(0, 0, 0, 0.5);\n    }\n  "], ["\n    width: 100%;\n    overflow-x: scroll;\n    scroll-behavior: smooth;\n\n    &::-webkit-scrollbar {\n      -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n      height: 11px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border-radius: ", ";\n      border: 2px solid white;\n      background-color: rgba(0, 0, 0, 0.5);\n    }\n  "])), useCornerRadius("s")); });
var StyledTable = styled.table(function (_a) {
    var disableHoverEffect = _a.disableHoverEffect, isInline = _a.isInline, colors = _a.colors;
    var height = useGetToken("space.600").value();
    var horizontalPadding = useGetToken("space.200").value();
    var verticalPadding = useGetToken("space.300").value();
    return css(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n    width: 100%;\n    min-width: 0px;\n    position: relative;\n    table-layout: fixed;\n    border-collapse: separate;\n    border-spacing: 0;\n    border: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n    padding: 0px;\n    color: ", ";\n    ", "\n\n    &&& {\n      tr {\n        min-height: ", "px;\n      }\n\n      tr td,\n      tr th {\n        padding: ", "px ", "px;\n        font-weight: 400;\n        text-align: left;\n        vertical-align: middle;\n        box-sizing: border-box;\n        border-top: 1px solid ", ";\n        padding-left: ", ";\n        padding-right: ", ";\n      }\n\n      tr:first-child th {\n        padding-left: ", ";\n        border-top-width: 0;\n      }\n\n      thead tr {\n        background-color: ", ";\n      }\n\n      tbody tr:hover {\n        background-color: ", ";\n      }\n    }\n  "], ["\n    width: 100%;\n    min-width: 0px;\n    position: relative;\n    table-layout: fixed;\n    border-collapse: separate;\n    border-spacing: 0;\n    border: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n    padding: 0px;\n    color: ", ";\n    ", "\n\n    &&& {\n      tr {\n        min-height: ", "px;\n      }\n\n      tr td,\n      tr th {\n        padding: ", "px ", "px;\n        font-weight: 400;\n        text-align: left;\n        vertical-align: middle;\n        box-sizing: border-box;\n        border-top: 1px solid ", ";\n        padding-left: ", ";\n        padding-right: ", ";\n      }\n\n      tr:first-child th {\n        padding-left: ", ";\n        border-top-width: 0;\n      }\n\n      thead tr {\n        background-color: ", ";\n      }\n\n      tbody tr:hover {\n        background-color: ", ";\n      }\n    }\n  "])), !isInline && "1px solid ".concat(colors.borderSubtleFloating), !isInline && useCornerRadius("m"), colors.textDefault, fonts, height, verticalPadding, horizontalPadding, colors.borderSubtleFloating, isInline && "0", isInline && "0", !isInline && "".concat(horizontalPadding, "px"), !isInline && colors.backgroundSubtleInline, !disableHoverEffect &&
        colors.backgroundInverseHovered);
});
var StyledTableWithStickyColumn = styled(StyledTable)(function (_a) {
    var isInline = _a.isInline, colors = _a.colors;
    var horizontalPadding = useGetToken("space.200").value();
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    &&& {\n      // Needed for inline mode\n      tbody td:nth-child(2),\n      thead th:nth-child(2) {\n        padding-left: ", "px;\n      }\n\n      // The sticky part\n      tbody td:first-child,\n      thead th:first-child {\n        top: 0;\n        left: 0;\n        z-index: 1;\n        position: sticky;\n        box-shadow: rgb(0 0 0 / 25%) 0px 3px 15px 0px;\n      }\n      thead th {\n        background-color: ", ";\n      }\n      tbody td {\n        background-color: white;\n      }\n    }\n  "], ["\n    &&& {\n      // Needed for inline mode\n      tbody td:nth-child(2),\n      thead th:nth-child(2) {\n        padding-left: ", "px;\n      }\n\n      // The sticky part\n      tbody td:first-child,\n      thead th:first-child {\n        top: 0;\n        left: 0;\n        z-index: 1;\n        position: sticky;\n        box-shadow: rgb(0 0 0 / 25%) 0px 3px 15px 0px;\n      }\n      thead th {\n        background-color: ", ";\n      }\n      tbody td {\n        background-color: white;\n      }\n    }\n  "])), horizontalPadding, isInline ? "white" : colors.backgroundSubtleInline);
});
var StyledTableHeaderContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: ", ";\n"])), function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent;
});
var TouchableIconWrapper = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  button svg {\n    transform: scale(0.8);\n  }\n"], ["\n  display: flex;\n  button svg {\n    transform: scale(0.8);\n  }\n"])));
var StyledPaginationContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: ", ";\n  opacity: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  transition-property: height, opacity;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n"], ["\n  height: ", ";\n  opacity: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  transition-property: height, opacity;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in-out;\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? "40px" : "0px");
}, function (_a) {
    var visible = _a.visible;
    return (visible ? "1" : "0");
});
var StyledPaginationDot = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  background-color: ", ";\n  height: 10px;\n  width: 5px;\n  margin-left: ", ";\n  transition: background-color 0.2s ease-in-out;\n"], ["\n  background-color: ", ";\n  height: 10px;\n  width: 5px;\n  margin-left: ", ";\n  transition: background-color 0.2s ease-in-out;\n"])), function (_a) {
    var colors = _a.colors, isActive = _a.isActive, isSticky = _a.isSticky;
    return choose(isActive, colors.iconNeutral, isSticky, colors.backgroundDefault, true, colors.backgroundSubtleInline);
}, function (_a) {
    var index = _a.index;
    return index > 0 && "5px";
});
var StyledTableAvatar = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: top;\n"], ["\n  display: inline-block;\n  vertical-align: top;\n"])));
var StyledTableCheckbox = styled.div(function (_a) {
    var colors = _a.colors, isDisabled = _a.isDisabled, isChecked = _a.isChecked, isFocused = _a.isFocused, isHovered = _a.isHovered, isIndeterminate = _a.isIndeterminate;
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: inline-flex;\n    vertical-align: top;\n    align-items: flex-start;\n    position: relative;\n    border-radius: ", ";\n\n    label {\n      box-sizing: border-box;\n      cursor: pointer;\n      border-radius: ", ";\n      border-style: solid;\n      border-width: 1px;\n      height: 20px;\n      width: 20px;\n      pointer-events: none;\n      transition-duration: 0.2s;\n      transition-property: background-color, box-shadow;\n      transition-timing-function: ease-in-out;\n      background-color: ", ";\n      border-color: ", ";\n      box-shadow: ", ";\n    }\n    label svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    /* Inclusively hide the actual Checkbox\n  * https://www.sarasoueidan.com/blog/inclusively-hiding-and-styling-checkboxes-and-radio-buttons/\n  */\n    input[type=\"checkbox\"] {\n      cursor: pointer;\n      position: absolute;\n      margin: 0;\n      top: 0;\n      left: 0;\n      height: 20px;\n      width: 20px;\n      /* some screen-readers skip fully invisible elements */\n      opacity: 0.00001;\n      pointer-events: all;\n    }\n  "], ["\n    display: inline-flex;\n    vertical-align: top;\n    align-items: flex-start;\n    position: relative;\n    border-radius: ", ";\n\n    label {\n      box-sizing: border-box;\n      cursor: pointer;\n      border-radius: ", ";\n      border-style: solid;\n      border-width: 1px;\n      height: 20px;\n      width: 20px;\n      pointer-events: none;\n      transition-duration: 0.2s;\n      transition-property: background-color, box-shadow;\n      transition-timing-function: ease-in-out;\n      background-color: ", ";\n      border-color: ", ";\n      box-shadow: ", ";\n    }\n    label svg {\n      position: absolute;\n      top: 0;\n      left: 0;\n    }\n\n    /* Inclusively hide the actual Checkbox\n  * https://www.sarasoueidan.com/blog/inclusively-hiding-and-styling-checkboxes-and-radio-buttons/\n  */\n    input[type=\"checkbox\"] {\n      cursor: pointer;\n      position: absolute;\n      margin: 0;\n      top: 0;\n      left: 0;\n      height: 20px;\n      width: 20px;\n      /* some screen-readers skip fully invisible elements */\n      opacity: 0.00001;\n      pointer-events: all;\n    }\n  "])), useCornerRadius("s"), useCornerRadius("s"), choose(isDisabled, colors.backgroundDisabled, isChecked || isIndeterminate, choose(isHovered, colors.backgroundAccentHovered, true, colors.backgroundAccent), isHovered, colors.backgroundInverseHovered, true, colors.backgroundInverse), choose(isDisabled, colors.borderDisabled, isChecked || isIndeterminate, colors.borderAccent, true, colors.borderNeutral), isFocused
        ? "0 0 0 2px #fff, 0 0 0 4px ".concat(isChecked || isIndeterminate
            ? colors.borderAccent
            : colors.borderNeutral)
        : "none");
});
var getInputColor = function (_a) {
    var colors = _a.colors, isDisabled = _a.isDisabled, isEmpty = _a.isEmpty;
    return choose(isDisabled || isEmpty, colors.textDisabled, true, colors.textDefault);
};
var getInputBackgroundColor = function (_a) {
    var colors = _a.colors, isDisabled = _a.isDisabled, isFocused = _a.isFocused, hasError = _a.hasError, hasWarning = _a.hasWarning;
    return choose(isDisabled, colors.backgroundDisabledWithBorder, isFocused, colors.backgroundInverse, hasError, colors.backgroundErrorWithBorder, hasWarning, colors.backgroundWarningWithBorder, true, colors.backgroundInverse);
};
var getInputBorderColor = function (_a) {
    var colors = _a.colors, isDisabled = _a.isDisabled, isFocused = _a.isFocused, hasError = _a.hasError, hasWarning = _a.hasWarning;
    return choose(isDisabled, colors.borderDisabled, isFocused, colors.borderDefault, hasError, colors.borderError, hasWarning, colors.borderWarning, true, colors.borderNeutral);
};
var StyledTableField = styled.div(function (props) { return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 100%;\n    height: 30px;\n    box-sizing: border-box;\n    display: inline-flex;\n    vertical-align: top;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n\n    position: relative;\n    border-width: 1px;\n    border-radius: ", ";\n    border-style: solid;\n\n    border-color: ", ";\n    background-color: ", ";\n\n    input {\n      background-color: transparent;\n      border-width: 0;\n      outline: none;\n      width: 100%;\n      line-height: 20px;\n      padding: 0px 10px;\n      text-align: ", ";\n      color: ", ";\n      -webkit-text-fill-color: ", ";\n      ", "\n    }\n  "], ["\n    width: 100%;\n    height: 30px;\n    box-sizing: border-box;\n    display: inline-flex;\n    vertical-align: top;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n\n    position: relative;\n    border-width: 1px;\n    border-radius: ", ";\n    border-style: solid;\n\n    border-color: ", ";\n    background-color: ", ";\n\n    input {\n      background-color: transparent;\n      border-width: 0;\n      outline: none;\n      width: 100%;\n      line-height: 20px;\n      padding: 0px 10px;\n      text-align: ", ";\n      color: ", ";\n      -webkit-text-fill-color: ", ";\n      ", "\n    }\n  "])), useCornerRadius("xs"), getInputBorderColor(props), getInputBackgroundColor(props), props.align, getInputColor(props), getInputColor(props), fonts); });
var StyledTableIcon = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n\n  svg {\n    margin-right: 10px;\n    transform: scale(0.8);\n  }\n"], ["\n  height: ", ";\n  width: ", ";\n\n  svg {\n    margin-right: 10px;\n    transform: scale(0.8);\n  }\n"])), function (_a) {
    var small = _a.small;
    return (small ? "12px" : "20px");
}, function (_a) {
    var small = _a.small;
    return (small ? "12px" : undefined);
});
var StyledTableInteractiveText = styled.button(function (_a) {
    var colors = _a.colors, isFocused = _a.isFocused, extraWidth = _a.extraWidth;
    return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    background-color: transparent;\n    appearance: none;\n    display: inline-flex;\n    vertical-align: top;\n    align-items: center;\n    border: none;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    max-width: calc(100% - ", "px);\n    min-height: 20px;\n    border-radius: ", ";\n\n    outline-style: none;\n    outline-color: transparent;\n    outline-width: 0;\n\n    svg {\n      min-width: 20px;\n    }\n\n    box-shadow: ", ";\n  "], ["\n    background-color: transparent;\n    appearance: none;\n    display: inline-flex;\n    vertical-align: top;\n    align-items: center;\n    border: none;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    max-width: calc(100% - ", "px);\n    min-height: 20px;\n    border-radius: ", ";\n\n    outline-style: none;\n    outline-color: transparent;\n    outline-width: 0;\n\n    svg {\n      min-width: 20px;\n    }\n\n    box-shadow: ", ";\n  "])), extraWidth, useCornerRadius("s"), isFocused
        ? "0 0 0 4px ".concat(colors.backgroundSubtleInline, ", 0 0 0 7px ").concat(colors.borderNeutralPressed)
        : "none");
});
var StyledTableDropdown = styled.div(function (props) { return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    width: 100%;\n    height: 30px;\n    padding: 0px 10px;\n    box-sizing: border-box;\n    display: inline-flex;\n    vertical-align: top;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    pointer-events: none;\n    position: relative;\n    border-width: 1px;\n    border-radius: ", ";\n    border-style: solid;\n\n    border-color: ", ";\n    background-color: ", ";\n\n    p {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    select {\n      opacity: 0.00001;\n      pointer-events: all;\n      cursor: ", ";\n      background-color: transparent;\n      position: absolute;\n      outline: none;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 30px;\n      line-height: 30px;\n\n      option {\n        ", "\n      }\n    }\n  "], ["\n    width: 100%;\n    height: 30px;\n    padding: 0px 10px;\n    box-sizing: border-box;\n    display: inline-flex;\n    vertical-align: top;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    pointer-events: none;\n    position: relative;\n    border-width: 1px;\n    border-radius: ", ";\n    border-style: solid;\n\n    border-color: ", ";\n    background-color: ", ";\n\n    p {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    select {\n      opacity: 0.00001;\n      pointer-events: all;\n      cursor: ", ";\n      background-color: transparent;\n      position: absolute;\n      outline: none;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 30px;\n      line-height: 30px;\n\n      option {\n        ", "\n      }\n    }\n  "])), useCornerRadius("xs"), getInputBorderColor(props), getInputBackgroundColor(props), props.isLoading || props.isDisabled ? "default" : "pointer", fonts); });
var templateObject_1$4, templateObject_2$2, templateObject_3$2, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;

/**
 * Get correct flex alignment (justify-content) value based on TextAlignment API
 */
var getJustifyContentAlignment = function (align) {
    switch (align) {
        case "center":
            return "center";
        case "right":
            return "flex-end";
        default:
            return "flex-start";
    }
};
/**
 * Calculates the actual width of a column that doesn't have a defined width.
 */
var calculateUndefinedColumnWidth = function (columnState, minWidth) {
    var undefinedWidth;
    var columnCount = columnState.length;
    var columnsWithDefinedWidths = columnState.filter(function (column) { return column.width; });
    var definedWidths = columnState.reduce(function (sum, _a) {
        var _b = _a.width, width = _b === void 0 ? 0 : _b;
        return sum + width;
    }, 0);
    // Return 0 if there are no columns, or if all columns have defined widths
    if (columnCount === 0 || columnsWithDefinedWidths.length === columnCount) {
        return 0;
    }
    if (columnsWithDefinedWidths.length > 0) {
        var undefinedColumnCount = columnCount - columnsWithDefinedWidths.length;
        undefinedWidth = (minWidth - definedWidths) / undefinedColumnCount;
    }
    else {
        undefinedWidth = minWidth / columnCount;
    }
    return Math.floor(undefinedWidth);
};
/**
 * Calculate the coordinates all column edges on the x-axis.
 * This is neeeded to be able to scroll to each one in a predictable manner.
 */
var calculateColumnCoordinates = function (columnState, minWidth) {
    var coordinates = [];
    var undefinedWidth = calculateUndefinedColumnWidth(columnState, minWidth);
    var setWidth = function (column) { return column.width || Math.floor(undefinedWidth); };
    // Iterate and give each column their coordinates
    columnState.map(setWidth).reduce(function (combinedWidth, columnWidth, index) {
        var newCombinedWidth = combinedWidth + columnWidth;
        coordinates[index] = {
            leftX: combinedWidth,
            rightX: newCombinedWidth,
            width: columnWidth
        };
        return newCombinedWidth;
    }, 0);
    return coordinates;
};
var useTableColors = function () {
    var designContext = useDesignContext();
    var colors = useMemo(function () { return colorMappings(designContext); }, [designContext]);
    return colors;
};

/**
 * Simple pagination button that shows an icon in enabled/disabled state
 */
var PaginationButton = function (_a) {
    var Icon = _a.Icon, isDisabled = _a.isDisabled, onClick = _a.onClick;
    return isDisabled ? (React__default.createElement(Icon, { colorToken: "colors/text/accent-on-background", colorTokenArgs: { interactiveState: "disabled" } })) : (React__default.createElement(TouchableIcon, { grey: true, Icon: Icon, onClick: onClick }));
};
/**
 * The column pagination displays a visual marker for each column in the table,
 * highlighting the ones that are currently in view.
 *
 * There are also directional buttons that makes the table scroll to the
 * next/previous column's left edge, according to the current scroll position.
 */
var ColumnPagination = function (_a) {
    var _b;
    var columnState = _a.columnState, minWidth = _a.minWidth, viewportWidth = _a.viewportWidth, withStickyColumn = _a.withStickyColumn, scrollRef = _a.scrollRef;
    if (!minWidth) {
        // eslint-disable-next-line no-console
        console.warn("Must provide a minWidth for column pagination to work");
        return null;
    }
    var _c = useState(0), scrollValue = _c[0], setScrollValue = _c[1];
    var showPagination = viewportWidth < minWidth;
    var isScrolledToZero = scrollValue === 0;
    var isScrolledToMax = viewportWidth + scrollValue === ((_b = scrollRef.current) === null || _b === void 0 ? void 0 : _b.scrollWidth);
    var colors = useTableColors();
    var setCurrentScrollValue = useCallback(function () {
        var _a;
        var currentScrollValue = (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollLeft;
        setScrollValue(currentScrollValue || 0);
    }, []);
    useEffect(function () {
        setCurrentScrollValue();
        var scrollSubscription = fromEvent(scrollRef.current, "scroll")
            .pipe(auditTime(200))
            .subscribe(setCurrentScrollValue);
        return function () {
            scrollSubscription.unsubscribe();
        };
    }, []);
    var columnCoordinates = useMemo(function () {
        var _a;
        var coords = calculateColumnCoordinates(columnState, minWidth);
        if (withStickyColumn) {
            // If we have a sticky column, coordinates gets shifted
            var stickyWidth_1 = (_a = coords[0]) === null || _a === void 0 ? void 0 : _a.width;
            return coords.map(function (col, index) { return (__assign(__assign({}, col), (index > 0 && {
                leftX: col.leftX - stickyWidth_1,
                rightX: col.rightX - stickyWidth_1
            }))); });
        }
        return coords;
    }, [columnState, minWidth, withStickyColumn]);
    var isColumnInView = function (columnIndex) {
        // What ratio of a column needs to be visble to count as active?
        var visibilityThreshold = 0.7; // 70%
        var height = 20; // Arbitrary number to calculate area
        var column = columnCoordinates[columnIndex];
        var viewPort = {
            leftX: scrollValue,
            rightX: scrollValue + viewportWidth
        };
        var xOverlap = Math.max(0, Math.min(viewPort.rightX, column.rightX) -
            Math.max(viewPort.leftX, column.leftX));
        var columnArea = column.width * height;
        var columnVisibilityRatio = (xOverlap * height) / columnArea;
        return columnVisibilityRatio >= visibilityThreshold;
    };
    var scrollTo = function (xPosition) {
        scrollRef.current.scrollTo(xPosition, 0);
    };
    var onClickPrevious = function () {
        var prevCol = __spreadArray([], columnCoordinates, true).reverse()
            .find(function (col) { return col.leftX < scrollValue; });
        scrollTo(prevCol.leftX);
    };
    var onClickNext = function () {
        var nextCol = columnCoordinates.find(function (col) { return col.leftX > scrollValue; });
        scrollTo(nextCol.leftX);
    };
    return (React__default.createElement(StyledPaginationContainer, { visible: showPagination, "data-testid": "mpui-table-column-pagination" },
        React__default.createElement(PaginationButton, { onClick: onClickPrevious, Icon: ActionIconArrowLeft, isDisabled: isScrolledToZero }),
        React__default.createElement(SpacerHorizontal, { spaceToken: "space.unit" }),
        columnCoordinates.map(function (_, index) { return (React__default.createElement(StyledPaginationDot, { index: index, key: "pagination-dot-".concat(index), isActive: isColumnInView(index), isSticky: withStickyColumn && index === 0, "data-testid": "mpui-table-column-pagination-dot", colors: colors })); }),
        React__default.createElement(SpacerHorizontal, { spaceToken: "space.unit" }),
        React__default.createElement(PaginationButton, { onClick: onClickNext, Icon: ActionIconArrowRight, isDisabled: isScrolledToMax })));
};
var ColumnPagination$1 = React__default.memo(ColumnPagination);

var TableContext = React__default.createContext({});
var useTableContext = function () {
    var context = useContext(TableContext);
    return context;
};
var useColumnState = function (index) {
    var getColumnState = useTableContext().getColumnState;
    return getColumnState(index) || {};
};

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var isEqual = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompare);

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (isEqual(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var LEAVE_DURATION_MS = 150;
var ARROW_OFFSET = 5;
var ARROW_PADDING = ARROW_OFFSET + 4;
var TOOLTIP_OFFSET = 10;
var useTooltip = function (_a) {
    var _b = _a === void 0 ? {} : _a, placement = _b.placement, visibilityOverride = _b.isVisible;
    var leaveTimer = React.useRef();
    var _c = React.useState(null), triggerRef = _c[0], setTriggerRef = _c[1];
    var _d = React.useState(null), popperRef = _d[0], setTooltipRef = _d[1];
    var _e = React.useState(null), arrowRef = _e[0], setArrowRef = _e[1];
    var _f = React.useState(false), visible = _f[0], setVisible = _f[1];
    var popper = usePopper(triggerRef, popperRef, {
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowRef,
                    padding: ARROW_PADDING
                }
            },
            {
                name: "offset",
                options: {
                    offset: [0, TOOLTIP_OFFSET]
                }
            }
        ],
        placement: placement,
        strategy: "absolute"
    });
    var isControlled = visibilityOverride !== undefined;
    var showTooltip = React.useCallback(function () {
        clearTimeout(leaveTimer.current);
        setVisible(true);
    }, []);
    var hideTooltip = React.useCallback(function () {
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(function () { return setVisible(false); }, LEAVE_DURATION_MS);
    }, []);
    React.useEffect(function () {
        if (isControlled) {
            visibilityOverride ? showTooltip() : hideTooltip();
        }
        return function () {
            clearTimeout(leaveTimer.current);
        };
    }, [visibilityOverride, isControlled]);
    var onOpen = React.useCallback(function () {
        if (isControlled) {
            return;
        }
        showTooltip();
    }, [showTooltip, isControlled]);
    var onClose = React.useCallback(function () {
        if (isControlled) {
            return;
        }
        hideTooltip();
    }, [isControlled]);
    var triggerElementProps = {
        onBlur: onClose,
        onFocus: onOpen,
        onMouseLeave: onClose,
        onMouseOver: onOpen,
        ref: setTriggerRef
    };
    var tooltipProps = __assign(__assign({ ref: setTooltipRef, style: __assign(__assign({}, popper.styles.popper), { pointerEvents: visible ? "all" : "none" }) }, popper.attributes.popper), { onMouseLeave: onClose, onMouseOver: onOpen });
    var tooltipArrowProps = {
        ref: setArrowRef,
        style: popper.styles.arrow
    };
    return {
        isVisible: visible,
        popper: popper,
        tooltipArrowProps: tooltipArrowProps,
        tooltipProps: tooltipProps,
        triggerElementProps: triggerElementProps
    };
};

var TOOLTIP_MAX_WIDTH = 350;
var ARROW_SIZE = ARROW_OFFSET * 2;
var TOOLTIP_ANIMATION_DELAY = 200;
var tooltipColors = function (designContext) { return ({
    backgroundColor: designContext.get("colors/backgrounds/inverse").toString()
}); };
var size = css({ width: ARROW_SIZE, height: ARROW_SIZE });
var beforeArrowCss = css(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  &:before {\n    ", "\n    content: ' ';\n    position: absolute;\n    visibility: visible;\n    transform: rotate(45deg);\n    background: inherit;\n  }\n"], ["\n  &:before {\n    ", "\n    content: ' ';\n    position: absolute;\n    visibility: visible;\n    transform: rotate(45deg);\n    background: inherit;\n  }\n"])), size);
var tooltipAnimation = function (_a) {
    var isUnmounting = _a.isUnmounting;
    return keyframes(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n\tfrom {\n\t\topacity: ", ";\n\t}\n\n\tto {\n\t\topacity: ", " ;\n\t}\n"], ["\n\tfrom {\n\t\topacity: ", ";\n\t}\n\n\tto {\n\t\topacity: ", " ;\n\t}\n"])), isUnmounting ? 1 : 0, isUnmounting ? 0 : 1);
};
var tooltipAnimationCss = css(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  animation: ", " ", "ms ease-out;\n"], ["\n  animation: ", " ", "ms ease-out;\n"])), tooltipAnimation, TOOLTIP_ANIMATION_DELAY);
var arrowPlacementCss = function (arrowClassName) {
    var _a;
    return css((_a = {},
        _a["&[data-popper-placement^='bottom'] > ".concat(arrowClassName)] = {
            top: -ARROW_OFFSET
        },
        _a["&[data-popper-placement^='left'] > ".concat(arrowClassName)] = {
            right: -ARROW_OFFSET
        },
        _a["&[data-popper-placement^='top'] > ".concat(arrowClassName)] = {
            bottom: -ARROW_OFFSET
        },
        _a["&[data-popper-placement^='right'] > ".concat(arrowClassName)] = {
            left: -ARROW_OFFSET
        },
        _a));
};
var ToolTipArrowStyled = styled.div({
    background: "inherit",
    position: "absolute",
    visibility: "hidden"
}, size, beforeArrowCss);
var TooltipContentStyled = styled.div({
    overflowWrap: "break-word",
    padding: 10
});
var ActionLinkText = styled.span({
    fontSize: "14px"
});
var TooltipContainerStyled = styled.div(function (_a) {
    var colors = _a.colors;
    return ({
        background: colors.backgroundColor,
        borderRadius: useCornerRadius("xs"),
        display: "inline-flex",
        maxWidth: TOOLTIP_MAX_WIDTH,
        zIndex: zIndex.tooltip
    });
}, tooltipAnimationCss, arrowPlacementCss(ToolTipArrowStyled));
var templateObject_1$3, templateObject_2$1, templateObject_3$1;

var actionPropTypes = {
    icon: PropTypes.func,
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["button", "link"])
};
var propTypes = {
    action: PropTypes.exact(actionPropTypes),
    children: PropTypes.node.isRequired,
    isVisible: PropTypes.bool,
    noWrapper: PropTypes.bool,
    placement: PropTypes.oneOf([
        "auto",
        "auto-start",
        "auto-end",
        "bottom",
        "top",
        "top-start",
        "top-end",
        "bottom-start",
        "bottom-end",
        "right",
        "right-start",
        "right-end",
        "left",
        "left-start",
        "left-end"
    ]),
    tabIndex: PropTypes.number,
    text: PropTypes.string.isRequired
};

/** Tooltip action */
var TooltipAction = function (_a) {
    var text = _a.text, Icon = _a.icon, _b = _a.type, type = _b === void 0 ? "button" : _b, onClick = _a.onClick;
    if (type === "link") {
        return (React.createElement(Flex, { spacing: "space.50", alignItems: "center" },
            Icon && React.createElement(Icon, { colorToken: "colors/borders/inverse" }),
            React.createElement(LinkSecondary, { white: true, inParagraph: true, role: "link", onClick: onClick },
                React.createElement(ActionLinkText, null, text))));
    }
    return (React.createElement(Flex, { column: true, spacing: "space.50", alignItems: "stretch" },
        React.createElement(ButtonQuaternary, { icon: Icon, size: "small", onClick: onClick }, text)));
};
TooltipAction.propTypes = actionPropTypes;

/** Tooltips display information related to an element when the element receives keyboard focus, mouse hovers or tap in touch screen devices  */
var Tooltip = function (_a) {
    var _b = _a.action, action = _b === void 0 ? null : _b, text = _a.text, id = _a.id, visibleControlled = _a.isVisible, children = _a.children, placement = _a.placement, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, _d = _a.noWrapper, noWrapper = _d === void 0 ? false : _d, restProps = __rest(_a, ["action", "text", "id", "isVisible", "children", "placement", "tabIndex", "noWrapper"]);
    if (!children) {
        return null;
    }
    var _e = useTooltip({
        isVisible: visibleControlled,
        placement: placement
    }), isVisible = _e.isVisible, tooltipProps = _e.tooltipProps, tooltipArrowProps = _e.tooltipArrowProps, triggerElementProps = _e.triggerElementProps;
    var _f = useDelayedUnmount(isVisible, TOOLTIP_ANIMATION_DELAY), delayedVisible = _f[0], isUnmounting = _f[1];
    var designContext = useDesignContext();
    var colors = tooltipColors(designContext);
    var $trigger;
    if (!noWrapper ||
        typeof children === "string" ||
        React.Children.count(children) > 1) {
        $trigger = (React.createElement("span", __assign({ "data-testid": "tooltip_trigger_wrapper", tabIndex: tabIndex, "aria-describedby": id }, triggerElementProps), children));
    }
    else {
        $trigger = appendPropsToChildren(children, __assign(__assign({}, triggerElementProps), { "aria-describedby": id, tabIndex: tabIndex }));
    }
    var getID = React.useCallback(function (suffix) { return (id ? "".concat(id, "__").concat(suffix) : undefined); }, [id]);
    var showTooltip = text.trim().length > 0 && delayedVisible;
    return (React.createElement(React.Fragment, null,
        $trigger,
        showTooltip && (React.createElement(Portal, null,
            React.createElement(TooltipContainerStyled, __assign({ "data-testid": "tooltip", isUnmounting: isUnmounting, id: id, colors: colors }, tooltipProps, { style: __assign({}, tooltipProps.style) }, restProps),
                React.createElement(TooltipContentStyled, { "data-testid": "tooltip-content", id: getID("tooltip-content") },
                    React.createElement(React.Fragment, null,
                        React.createElement(ParagraphTertiary, { correctFootprint: true, white: true }, text),
                        action && (React.createElement(React.Fragment, null,
                            React.createElement(SpacerVertical, { spaceToken: "space.200" }),
                            React.createElement(TooltipAction, __assign({}, action)))))),
                React.createElement(ToolTipArrowStyled, __assign({}, tooltipArrowProps)))))));
};
Tooltip.propTypes = propTypes;

var TextAlignmentPropType = PropTypes.oneOf([
    "left",
    "right",
    "center"
]);

var BaseBodyCellPropTypes = {
    align: TextAlignmentPropType,
    id: PropTypes.string,
    title: PropTypes.string,
    tooltip: PropTypes.exact(__assign(__assign({}, propTypes), { children: PropTypes.node }))
};
/**
 * An internal base body cell to use for external cell types
 */
var BaseBodyCell = function (_a) {
    var id = _a.id, index = _a.index, children = _a.children, _b = _a.align, align = _b === void 0 ? "left" : _b, title = _a.title, tooltip = _a.tooltip, rest = __rest(_a, ["id", "index", "children", "align", "title", "tooltip"]);
    var hidden = useColumnState(index).hidden;
    if (hidden) {
        return null;
    }
    var tooltipProps = title ? { text: title } : tooltip;
    var styles = {
        textAlign: align
    };
    return (React__default.createElement("td", __assign({ id: id, style: styles }, rest), tooltipProps ? (React__default.createElement(Tooltip, __assign({}, tooltipProps), children)) : (children)));
};
BaseBodyCell.propTypes = BaseBodyCellPropTypes;
var BaseBodyCell$1 = React__default.memo(BaseBodyCell);

/**
 * Body cell for Avatar content, containing a short text, image or icon.<br />
 * Icons can be clickable if an `onClick` callback is supplied.
 */
var BodyAvatarCell = function (_a) {
    var ariaLabel = _a.ariaLabel, backgroundColor = _a.backgroundColor, character = _a.character, icon = _a.icon, id = _a.id, imgSrc = _a.imgSrc, isDisabled = _a.isDisabled, isSquare = _a.isSquare, _b = _a.size, size = _b === void 0 ? "small" : _b, _c = _a.hasBorder, hasBorder = _c === void 0 ? false : _c, _d = _a.hasIconHoverEffect, hasIconHoverEffect = _d === void 0 ? false : _d, textColor = _a.textColor, onClick = _a.onClick, cellProps = __rest(_a, ["ariaLabel", "backgroundColor", "character", "icon", "id", "imgSrc", "isDisabled", "isSquare", "size", "hasBorder", "hasIconHoverEffect", "textColor", "onClick"]);
    var ids = id
        ? {
            avatar: "".concat(id, "__avatar"),
            cell: "".concat(id, "__cell")
        }
        : {};
    var hasValidContentProps = icon || character || imgSrc;
    if (!hasValidContentProps) {
        // eslint-disable-next-line no-console
        console.warn("Must provide either icon, character or imgSrc to BodyAvatarCell. Not rendering anything.", { icon: icon, character: character, imgSrc: imgSrc });
    }
    var IconComponent = useMemo(function () {
        return icon && onClick && !isDisabled
            ? function () { return (React__default.createElement(TouchableIcon, { id: ids.avatar, grey: hasIconHoverEffect, ariaLabel: ariaLabel, Icon: icon, onClick: onClick })); }
            : icon;
    }, [icon, onClick, isDisabled, ariaLabel]);
    var sizeProps = choose(size === "small", { small: true }, size === "large", { large: true }, true, {});
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: ids.cell }, cellProps), hasValidContentProps && (React__default.createElement(StyledTableAvatar, { "aria-label": ariaLabel, "data-testid": "mpui-table-avatar" },
        React__default.createElement(Avatar, __assign({}, sizeProps, { icon: IconComponent, square: isSquare, source: imgSrc, altText: ariaLabel, disabled: isDisabled, hasBorder: hasBorder, textColor: textColor, backgroundColor: backgroundColor, fallbackCharacter: character }))))));
};
BodyAvatarCell.propTypes = {
    ariaLabel: PropTypes.string,
    backgroundColor: PropTypes.string,
    character: PropTypes.string,
    hasBorder: PropTypes.bool,
    hasIconHoverEffect: PropTypes.bool,
    icon: PropTypes.any,
    imgSrc: PropTypes.string,
    isDisabled: PropTypes.bool,
    isSquare: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    textColor: PropTypes.string
};
var BodyAvatarCell$1 = React__default.memo(BodyAvatarCell);

/**
 * A hook that tells you if your `ref` was focused using the keyboard.
 */
var useKeyboardFocus = function (ref) {
    var isMousePressed = false;
    var _a = useState(false), isKeyboardFocused = _a[0], setKeyboardFocused = _a[1];
    var onMouseUp = useCallback(function () {
        isMousePressed = false;
    }, []);
    var onMouseDown = useCallback(function () {
        isMousePressed = true;
    }, []);
    var onBlur = useCallback(function () { return setKeyboardFocused(false); }, []);
    var onFocus = useCallback(function () { return setKeyboardFocused(!isMousePressed); }, []);
    useEffect(function () {
        var targetElement = ref === null || ref === void 0 ? void 0 : ref.current;
        if (targetElement) {
            targetElement.addEventListener("blur", onBlur);
            targetElement.addEventListener("focus", onFocus);
            targetElement.addEventListener("mouseup", onMouseUp);
            targetElement.addEventListener("mousedown", onMouseDown);
        }
        return function () {
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener("blur", onBlur);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener("focus", onFocus);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener("mouseup", onMouseUp);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener("mousedown", onMouseDown);
        };
    }, [ref]);
    return isKeyboardFocused;
};

var CheckboxPropTypes = {
    id: PropTypes.string,
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isIndeterminate: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};
/**
 * Generic checkbox component
 */
var Checkbox = function (_a) {
    var id = _a.id, isChecked = _a.isChecked, isDisabled = _a.isDisabled, isIndeterminate = _a.isIndeterminate, onChange = _a.onChange;
    var inputRef = useRef(null);
    var isKeyboardFocused = useKeyboardFocus(inputRef);
    var _b = useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var handleMouseEnter = useCallback(function () { return setIsHovered(true); }, []);
    var handleMouseLeave = useCallback(function () { return setIsHovered(false); }, []);
    var colors = useTableColors();
    var onChangeCallback = useCallback(function () {
        if (!isDisabled) {
            onChange(!isChecked);
        }
    }, [isDisabled, isChecked, onChange]);
    var ids = id
        ? {
            input: "".concat(id, "__input"),
            root: "".concat(id, "__root")
        }
        : {};
    return (React__default.createElement(StyledTableCheckbox, { colors: colors, id: ids.root, onMouseEnter: isDisabled ? null : handleMouseEnter, onMouseLeave: isDisabled ? null : handleMouseLeave, isDisabled: isDisabled, isChecked: isChecked, isFocused: isKeyboardFocused, isHovered: isHovered, isIndeterminate: isIndeterminate, "data-testid": "mpui_table_head_checkbox".concat(isIndeterminate ? "-indeterminate" : isChecked ? "-checked" : "") },
        React__default.createElement("label", null,
            React__default.createElement("input", { id: ids.input, ref: inputRef, type: "checkbox", checked: isChecked, disabled: isDisabled, onChange: onChangeCallback }),
            isIndeterminate && (React__default.createElement(ActionIconMinus, { colorToken: "colors/borders/inverse" })),
            isChecked && !isIndeterminate && (React__default.createElement(ActionIconCheckmark, { colorToken: "colors/borders/inverse" })))));
};
Checkbox.propTypes = CheckboxPropTypes;
var Checkbox$1 = React__default.memo(Checkbox);

/**
 * Body cell for a (controlled) checkbox component.
 */
var BodyCheckboxCell = function (_a) {
    var id = _a.id, isChecked = _a.isChecked, isDisabled = _a.isDisabled, isIndeterminate = _a.isIndeterminate, onChange = _a.onChange, cellProps = __rest(_a, ["id", "isChecked", "isDisabled", "isIndeterminate", "onChange"]);
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            checkbox: "".concat(id, "__checkbox")
        }
        : {};
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: ids.cell }, cellProps),
        React__default.createElement(Checkbox$1, { id: ids.checkbox, isChecked: isChecked, isDisabled: isDisabled, isIndeterminate: isIndeterminate, onChange: onChange })));
};
BodyCheckboxCell.propTypes = __assign(__assign({}, BaseBodyCellPropTypes), CheckboxPropTypes);
var BodyCheckboxCell$1 = React__default.memo(BodyCheckboxCell);

/**
 * Body cell for _any_ custom content.
 *
 * **Notes:**<br/>
 * • Only use this for non-supported cell types.<br/>
 * • Props for `id` and `align` will be used on the table cell itself, but _not_ propagate down to your custom components.<br/>
 */
var BodyCustomCell = function (_a) {
    var id = _a.id, children = _a.children, cellProps = __rest(_a, ["id", "children"]);
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: id && "".concat(id, "__cell") }, cellProps), children));
};
BodyCustomCell.propTypes = __assign(__assign({}, BaseBodyCellPropTypes), { children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]) });
var BodyCustomCell$1 = React__default.memo(BodyCustomCell);

var TypographyComp = function (_a) {
    var className = _a.className, UNSAFE_props = _a.UNSAFE_props, props = __rest(_a, ["className", "UNSAFE_props"]);
    return React__default.createElement(Typography, __assign({}, props, { UNSAFE_props: __assign({ className: className }, UNSAFE_props) }));
};
var TypographyStyled = styled(TypographyComp)(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  && {\n    flex-shrink: initial !important;\n    margin: -5px 0 !important;\n  }\n"], ["\n  && {\n    flex-shrink: initial !important;\n    margin: -5px 0 !important;\n  }\n"])));
var alignmentsMappings = {
    left: "start",
    right: "end"
};
/**
 * Generic component for Text content
 */
var Text = function (_a) {
    var _b;
    var id = _a.id, isLight = _a.isLight, isMonoFont = _a.isMonoFont, children = _a.children, _c = _a.align, align = _c === void 0 ? "start" : _c, overflowEllipsis = _a.overflowEllipsis;
    var innerStyle = __assign({}, (isMonoFont ? { fontFamily: "Klarna Text Mono" } : {}));
    var colorToken = isLight ? "colors/text/neutral" : "colors/text/default";
    align = (_b = alignmentsMappings[align]) !== null && _b !== void 0 ? _b : align;
    return (React__default.createElement(TypographyStyled, { accessibilityPreset: "paragraph", id: id, textToken: "text-style/text/labels/default/regular", colorToken: colorToken, numberOfLines: overflowEllipsis ? 1 : undefined, align: align, UNSAFE_props: {
            "data-testid": "table-text"
        } },
        React__default.createElement("span", { style: innerStyle }, children)));
};
var Text$1 = React__default.memo(Text);
var templateObject_1$2;

/**
 * Body cell for *numerical* content, getting a **Mono** font.<br />
 * Value can be number or string, to cater for formatted numbers.
 */
var BodyDigitCell = function (_a) {
    var id = _a.id, value = _a.value, children = _a.children, description = _a.description, _b = _a.align, align = _b === void 0 ? "left" : _b, overflowEllipsis = _a.overflowEllipsis, cellProps = __rest(_a, ["id", "value", "children", "description", "align", "overflowEllipsis"]);
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            desc: "".concat(id, "__desc"),
            digit: "".concat(id, "__text")
        }
        : {};
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: ids.cell }, cellProps),
        React__default.createElement(Text$1, { id: ids.digit, align: align, isMonoFont: true, overflowEllipsis: overflowEllipsis }, children || value),
        description && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(SpacerVertical, { spaceToken: "space.200" }),
            React__default.createElement(Text$1, { id: ids.desc, align: align, isLight: true, overflowEllipsis: overflowEllipsis }, description)))));
};
BodyDigitCell.propTypes = __assign(__assign({}, BaseBodyCellPropTypes), { children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node
    ]), description: PropTypes.string, value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) });
var BodyDigitCell$1 = React__default.memo(BodyDigitCell);

/**
 * Body cell for a dropdown.<br />
 * Can be used as controlled or uncontrolled component.
 */
var BodyDropdownCell = function (_a) {
    var id = _a.id, _b = _a.value, value = _b === void 0 ? "" : _b, _c = _a.options, options = _c === void 0 ? [] : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.isLoading, isLoading = _e === void 0 ? false : _e, _f = _a.hasError, hasError = _f === void 0 ? false : _f, _g = _a.hasWarning, hasWarning = _g === void 0 ? false : _g, onChange = _a.onChange, cellProps = __rest(_a, ["id", "value", "options", "isDisabled", "isLoading", "hasError", "hasWarning", "onChange"]);
    var ref = useRef(null);
    var isKeyboardFocused = useKeyboardFocus(ref);
    var _h = useState(value), selectedValue = _h[0], setSelectedValue = _h[1];
    var _j = useState(false), isHovered = _j[0], setIsHovered = _j[1];
    var handleMouseEnter = useCallback(function () { return setIsHovered(true); }, []);
    var handleMouseLeave = useCallback(function () { return setIsHovered(false); }, []);
    var colors = useTableColors();
    // For controlled component
    useEffect(function () {
        setSelectedValue(value);
    }, [value]);
    var handleChange = useCallback(function (e) {
        var newValue = e.target.value;
        setSelectedValue(newValue);
        onChange(newValue);
    }, [selectedValue, onChange]);
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            select: "".concat(id, "__select")
        }
        : {};
    var isEmpty = options.length === 0;
    var chevronColor = choose(isDisabled || isEmpty, "colors/borders/default", isHovered, "colors/text/neutral", true, "colors/text/neutral");
    var displayText = useMemo(function () {
        var _a;
        var selectedOption = options.find(function (o) { return o.value === selectedValue; });
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || ((_a = options[0]) === null || _a === void 0 ? void 0 : _a.label) || "";
    }, [selectedValue]);
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: ids.cell }, cellProps),
        React__default.createElement(StyledTableDropdown, { colors: colors, isLoading: isLoading, isDisabled: isDisabled || isEmpty, isHovered: isHovered, isFocused: isKeyboardFocused, hasError: hasError, hasWarning: hasWarning, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
            React__default.createElement(Text$1, { isLight: isLoading || isDisabled }, displayText),
            React__default.createElement("div", { style: {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center"
                } },
                hasError && (React__default.createElement(StyledTableIcon, { "data-testid": "icon-error" },
                    React__default.createElement(IconError, { colorToken: "colors/borders/error" }))),
                hasWarning && !hasError && (React__default.createElement(StyledTableIcon, { "data-testid": "icon-warning" },
                    React__default.createElement(IconWarning, { colorToken: "colors/borders/warning" }))),
                isLoading ? (React__default.createElement("div", { style: {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "20px",
                        height: "20px"
                    } },
                    React__default.createElement(StyledTableIcon, { small: true, "data-testid": "icon-loader" },
                        React__default.createElement(Loader, { small: true })))) : (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(ActionIconChevronBottom, { colorToken: chevronColor, colorTokenArgs: {
                            interactiveState: isDisabled || isEmpty
                                ? "disabled"
                                : isHovered
                                    ? "hovered"
                                    : "default"
                        } }),
                    React__default.createElement("select", { ref: ref, id: ids.select, value: selectedValue, disabled: isDisabled || isEmpty, onChange: handleChange }, options.map(function (option) { return (React__default.createElement("option", { key: option.value, value: option.value, hidden: option.isHidden, disabled: option.isDisabled }, option.label)); }))))))));
};
BodyDropdownCell.propTypes = __assign(__assign({}, BaseBodyCellPropTypes), { hasError: PropTypes.bool, hasWarning: PropTypes.bool, isDisabled: PropTypes.bool, isLoading: PropTypes.bool, onChange: PropTypes.func.isRequired, options: PropTypes.arrayOf(PropTypes.exact({
        isDisabled: PropTypes.bool,
        isHidden: PropTypes.bool,
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    })).isRequired, value: PropTypes.string });
var BodyDropdownCell$1 = React__default.memo(BodyDropdownCell);

var InputFieldPropType = PropTypes.oneOf([
    "text",
    "number",
    "password"
]);
var FieldPropTypes = {
    debounceDelay: PropTypes.number,
    hasError: PropTypes.bool,
    hasWarning: PropTypes.bool,
    id: PropTypes.string,
    isDisabled: PropTypes.bool,
    max: PropTypes.number,
    min: PropTypes.number,
    maxLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    type: InputFieldPropType,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
/**
 * Generic field component
 */
var Field = function (_a) {
    var id = _a.id, _b = _a.type, type = _b === void 0 ? "text" : _b, _c = _a.align, align = _c === void 0 ? "left" : _c, value = _a.value, hasError = _a.hasError, hasWarning = _a.hasWarning, isDisabled = _a.isDisabled, _d = _a.debounceDelay, debounceDelay = _d === void 0 ? 200 : _d, placeholder = _a.placeholder, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, minNumericValue = _a.min, maxNumericValue = _a.max, maxTextLength = _a.maxLength;
    var inputRef = useRef(null);
    var didMount = useRef(false);
    var colors = useTableColors();
    var getInputValue = React__default.useCallback(function (inputValue) {
        if (type === "number") {
            if (minNumericValue !== undefined &&
                Number(inputValue) < minNumericValue) {
                inputValue = minNumericValue;
            }
            if (maxNumericValue !== undefined &&
                Number(inputValue) > maxNumericValue) {
                inputValue = maxNumericValue;
            }
        }
        return inputValue;
    }, [minNumericValue, maxNumericValue]);
    var _e = useState(getInputValue(value)), valueState = _e[0], setValueState = _e[1];
    var _f = useState(false), isFocused = _f[0], setIsFocused = _f[1];
    var handleOnBlur = useCallback(function (e) {
        setIsFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, []);
    var handleOnFocus = useCallback(function (e) {
        setIsFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    }, []);
    // Change of value prop
    useEffect(function () {
        if (didMount.current && !isEmpty(value)) {
            onChange(value);
            setValueState(getInputValue(value));
        }
        didMount.current = true;
    }, [value, isEmpty, getInputValue]);
    // onChange debounce
    useEffect(function () {
        var typingObservable$ = fromEvent(inputRef.current, "input").pipe(debounceTime(debounceDelay), map(function (e) { return getInputValue(e.target.value); }), distinctUntilChanged());
        var typingSubscription = typingObservable$.subscribe(onChange);
        return function () {
            typingSubscription.unsubscribe();
        };
    }, [getInputValue, onChange]);
    var onChangeHandler = useCallback(function (e) {
        var newValue = e.target.value;
        setValueState(getInputValue(newValue));
    }, [setValueState, getInputValue]);
    var ids = id
        ? {
            input: "".concat(id, "__input"),
            root: "".concat(id, "__root")
        }
        : {};
    var min = type === "number" ? minNumericValue : undefined;
    var max = type === "number" ? maxNumericValue : undefined;
    var maxLength = type === "text" ? maxTextLength : undefined;
    return (React__default.createElement(StyledTableField, { id: ids.root, align: align, isDisabled: isDisabled, isEmpty: isEmpty(valueState), isFocused: isFocused, hasError: hasError, hasWarning: hasWarning, useMonoFont: type === "number", colors: colors },
        React__default.createElement("input", { type: type, id: ids.input, ref: inputRef, autoComplete: "off", value: valueState, disabled: isDisabled, placeholder: placeholder, onChange: onChangeHandler, onBlur: handleOnBlur, onFocus: handleOnFocus, onKeyDown: onKeyDown, "data-testid": "mpui-table-field", maxLength: maxLength, min: min, max: max }),
        React__default.createElement(StyledTableIcon, null,
            hasError && (React__default.createElement(IconError, { colorToken: "colors/text/error", "data-testid": "icon-error" })),
            hasWarning && !hasError && (React__default.createElement(IconWarning, { colorToken: "colors/text/warning", "data-testid": "icon-warning" })))));
};
Field.propTypes = FieldPropTypes;
var Field$1 = React__default.memo(Field);

/**
 * Body cell for an input field.
 */
var BodyFieldCell = function (_a) {
    var id = _a.id, align = _a.align, type = _a.type, value = _a.value, isDisabled = _a.isDisabled, hasError = _a.hasError, hasWarning = _a.hasWarning, _b = _a.debounceDelay, debounceDelay = _b === void 0 ? 200 : _b, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, placeholder = _a.placeholder, maxLength = _a.maxLength, min = _a.min, max = _a.max, cellProps = __rest(_a, ["id", "align", "type", "value", "isDisabled", "hasError", "hasWarning", "debounceDelay", "onBlur", "onChange", "onFocus", "onKeyDown", "placeholder", "maxLength", "min", "max"]);
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            field: "".concat(id, "__field")
        }
        : {};
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: ids.cell }, cellProps),
        React__default.createElement(Field$1, { id: ids.field, type: type, value: value, align: align, isDisabled: isDisabled, hasError: hasError, hasWarning: hasWarning, debounceDelay: debounceDelay, placeholder: placeholder, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, maxLength: maxLength, min: min, max: max })));
};
BodyFieldCell.propTypes = __assign(__assign({}, BaseBodyCellPropTypes), FieldPropTypes);
var BodyFieldCell$1 = React__default.memo(BodyFieldCell);

var getBubbleLabelByType = function (type) {
    switch (type) {
        case "alt":
            return InformationBlockLabelAlt;
        case "alt-overlay":
            return InformationBlockLabelAltOverlay;
        case "success":
            return InformationBlockLabelSuccess;
        case "error":
            return InformationBlockLabelError;
        case "warning":
            return InformationBlockLabelWarning;
        default:
            return InformationBlockLabelDefault;
    }
};
/**
 * Body cell for label.
 */
var BodyLabelCell = function (_a) {
    var id = _a.id, value = _a.value, children = _a.children, _b = _a.type, type = _b === void 0 ? "default" : _b, cellProps = __rest(_a, ["id", "value", "children", "type"]);
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            label: "".concat(id, "__label")
        }
        : {};
    var labelContent = children || value;
    var LabelComponent = useMemo(function () { return getBubbleLabelByType(type); }, [type]);
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: ids.cell }, cellProps), labelContent && (React__default.createElement("div", { style: { display: "inline-block" } },
        React__default.createElement(LabelComponent, { id: ids.label }, labelContent)))));
};
BodyLabelCell.propTypes = {
    children: PropTypes.any,
    type: PropTypes.oneOf([
        "default",
        "alt",
        "alt-overlay",
        "success",
        "error",
        "warning"
    ]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
var BodyLabelCell$1 = React__default.memo(BodyLabelCell);

/**
 * A table body roll containing cells
 */
var BodyRow = function (_a) {
    var id = _a.id, children = _a.children;
    var indexedCells = useMemo(function () {
        return React__default.Children.map(children, function (child, index) {
            return child ? (React__default.cloneElement(child, {
                index: index
            })) : (React__default.createElement(React__default.Fragment, null));
        });
    }, [children]);
    return React__default.createElement("tr", { id: id }, indexedCells);
};
BodyRow.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    id: PropTypes.string
};
var BodyRow$1 = React__default.memo(BodyRow);

/**
 * Body cell for text and/or description content
 */
var BodyTextCell = function (_a) {
    var id = _a.id, text = _a.text, children = _a.children, description = _a.description, _b = _a.align, align = _b === void 0 ? "left" : _b, overflowEllipsis = _a.overflowEllipsis, cellProps = __rest(_a, ["id", "text", "children", "description", "align", "overflowEllipsis"]);
    var index = cellProps.index;
    useColumnState(index).width;
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            desc: "".concat(id, "__desc"),
            text: "".concat(id, "__text")
        }
        : {};
    var textContent = children || text;
    return (React__default.createElement(BaseBodyCell$1, __assign({ id: ids.cell }, cellProps),
        textContent && (React__default.createElement(Text, { id: ids.text, align: align, overflowEllipsis: overflowEllipsis }, textContent)),
        textContent && description && React__default.createElement(SpacerVertical, { spaceToken: "space.200" }),
        description && (React__default.createElement(Text, { id: ids.desc, align: align, isLight: true, overflowEllipsis: overflowEllipsis }, description))));
};
BodyTextCell.propTypes = __assign(__assign({}, BaseBodyCellPropTypes), { children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node
    ]), description: PropTypes.string, overflowEllipsis: PropTypes.bool, text: PropTypes.string });
var BodyTextCell$1 = React__default.memo(BodyTextCell);

var BaseHeaderCellPropTypes = {
    align: TextAlignmentPropType,
    hide: PropTypes.bool,
    id: PropTypes.string,
    title: PropTypes.string,
    tooltip: PropTypes.exact(__assign(__assign({}, propTypes), { children: PropTypes.node, icon: PropTypes.elementType })),
    width: PropTypes.number
};
/**
 * An internal base header cell to use for external cell types
 */
var BaseHeaderCell = function (_a) {
    var children = _a.children, id = _a.id, index = _a.index, width = _a.width, _b = _a.align, align = _b === void 0 ? "left" : _b; _a.hide; var title = _a.title, tooltip = _a.tooltip, rest = __rest(_a, ["children", "id", "index", "width", "align", "hide", "title", "tooltip"]);
    var hidden = useColumnState(index).hidden;
    var colors = useTableColors();
    if (hidden) {
        return null;
    }
    var tooltipProps = title ? { text: title } : tooltip;
    var flexAlignment = getJustifyContentAlignment(align);
    return (React__default.createElement("th", __assign({ id: id, style: { width: width, textAlign: align } }, rest), tooltipProps ? (React__default.createElement(StyledTableHeaderContent, { colors: colors, justifyContent: flexAlignment },
        children,
        React__default.createElement(SpacerHorizontal, { spaceToken: "space.unit" }),
        React__default.createElement(Tooltip, __assign({ tabIndex: -1 }, tooltipProps),
            React__default.createElement(TouchableIconWrapper, null,
                React__default.createElement(TouchableIcon, { isSmall: true, Icon: tooltipProps.icon || IconInformation }))))) : (React__default.createElement(React__default.Fragment, null, children))));
};
BaseHeaderCell.propTypes = BaseHeaderCellPropTypes;
var BaseHeaderCell$1 = React__default.memo(BaseHeaderCell);

/**
 * Header cell for a (controlled) checkbox component.
 */
var HeaderCheckboxCell = function (_a) {
    var id = _a.id, isChecked = _a.isChecked, isDisabled = _a.isDisabled, isIndeterminate = _a.isIndeterminate, onChange = _a.onChange, cellProps = __rest(_a, ["id", "isChecked", "isDisabled", "isIndeterminate", "onChange"]);
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            checkbox: "".concat(id, "__checkbox")
        }
        : {};
    return (React__default.createElement(BaseHeaderCell$1, __assign({ id: ids.cell }, cellProps),
        React__default.createElement(Checkbox$1, { id: ids.checkbox, isChecked: isChecked, isDisabled: isDisabled, isIndeterminate: isIndeterminate, onChange: onChange })));
};
HeaderCheckboxCell.propTypes = __assign(__assign({}, BaseHeaderCellPropTypes), CheckboxPropTypes);
var HeaderCheckboxCell$1 = React__default.memo(HeaderCheckboxCell);

/**
 * Header cell for interactive text.
 */
var HeaderInteractiveTextCell = function (_a) {
    var id = _a.id, text = _a.text, children = _a.children, chevron = _a.chevron, _b = _a.onClick, onClick = _b === void 0 ? function () { return null; } : _b, _c = _a.align, align = _c === void 0 ? "left" : _c, overflowEllipsis = _a.overflowEllipsis, cellProps = __rest(_a, ["id", "text", "children", "chevron", "onClick", "align", "overflowEllipsis"]);
    var ref = useRef(null);
    var isKeyboardFocused = useKeyboardFocus(ref);
    var _d = useState(false), isHovered = _d[0], setIsHovered = _d[1];
    var handleMouseEnter = useCallback(function () { return setIsHovered(true); }, []);
    var handleMouseLeave = useCallback(function () { return setIsHovered(false); }, []);
    var colors = useTableColors();
    var chevronColor = isHovered ? "colors/text/neutral" : "colors/text/default";
    var ids = id
        ? {
            button: "".concat(id, "__button"),
            cell: "".concat(id, "__cell"),
            text: "".concat(id, "__text")
        }
        : {};
    var buttonText = (children || text);
    var hasTooltip = cellProps.title || cellProps.tooltip;
    return (React__default.createElement(BaseHeaderCell$1, __assign({ id: ids.cell, align: align }, cellProps),
        React__default.createElement(StyledTableInteractiveText, { colors: colors, ref: ref, id: ids.button, onClick: onClick, title: buttonText, extraWidth: hasTooltip ? 20 : 0, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, isFocused: isKeyboardFocused },
            React__default.createElement(Text, { id: ids.text, align: align, isLight: isHovered, overflowEllipsis: overflowEllipsis }, buttonText),
            chevron === "up" && (React__default.createElement(ActionIconChevronTop, { colorToken: chevronColor, "data-testid": "chevron-up" })),
            chevron === "down" && (React__default.createElement(ActionIconChevronBottom, { colorToken: chevronColor, "data-testid": "chevron-down" })))));
};
HeaderInteractiveTextCell.propTypes = __assign(__assign({}, BaseHeaderCellPropTypes), { chevron: PropTypes.oneOf(["up", "down"]), children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node
    ]), onClick: PropTypes.func, overflowEllipsis: PropTypes.bool, text: PropTypes.string });
var HeaderInteractiveTextCell$1 = React__default.memo(HeaderInteractiveTextCell);

/** Default defaults for all columns */
var getDefaultState = function (length) {
    return repeat({ hidden: false, width: undefined }, length);
};
var HeaderRow = function (_a) {
    var children = _a.children, id = _a.id;
    var _b = useState(false), isContextDirty = _b[0], setIsContextDirty = _b[1];
    var _c = useState(getDefaultState(React__default.Children.count(children))), internalColumnState = _c[0], setInternalColumnState = _c[1];
    var setColumnState = useTableContext().setColumnState;
    var currentColumnState = [];
    var indexedCells = useMemo(function () {
        return React__default.Children.map(children, function (child, index) {
            currentColumnState[index] = {
                hidden: !!(child === null || child === void 0 ? void 0 : child.props.hide),
                width: child === null || child === void 0 ? void 0 : child.props.width
            };
            return child ? React__default.cloneElement(child, { index: index }) : React__default.createElement(React__default.Fragment, null);
        });
    }, [children]);
    if (!isEmpty(currentColumnState)) {
        setInternalColumnState(currentColumnState);
        setIsContextDirty(true);
    }
    useEffect(function () {
        if (isContextDirty) {
            setColumnState(internalColumnState);
            setIsContextDirty(false);
        }
    }, [internalColumnState]);
    return (React__default.createElement("thead", null,
        React__default.createElement("tr", { id: id }, indexedCells)));
};
HeaderRow.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    id: PropTypes.string
};
var HeaderRow$1 = React__default.memo(HeaderRow);

/**
 * Header cell for regular text
 */
var HeaderTextCell = function (_a) {
    var id = _a.id, text = _a.text, children = _a.children, _b = _a.align, align = _b === void 0 ? "left" : _b, overflowEllipsis = _a.overflowEllipsis, cellProps = __rest(_a, ["id", "text", "children", "align", "overflowEllipsis"]);
    var ids = id
        ? {
            cell: "".concat(id, "__cell"),
            text: "".concat(id, "__text")
        }
        : {};
    return (React__default.createElement(BaseHeaderCell$1, __assign({ id: ids.cell, align: align }, cellProps),
        React__default.createElement(Text, { id: ids.text, align: align, overflowEllipsis: overflowEllipsis }, children || text)));
};
HeaderTextCell.propTypes = __assign(__assign({}, BaseHeaderCellPropTypes), { children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node
    ]), text: PropTypes.string });
var HeaderTextCell$1 = React__default.memo(HeaderTextCell);

/**
 * The tbody element
 */
var TableBody = function (_a) {
    var children = _a.children, id = _a.id;
    return React__default.createElement("tbody", { id: id }, children);
};
TableBody.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    id: PropTypes.string
};
var TableBody$1 = React__default.memo(TableBody);

/**
 * A responsive table built from the ground up.
 */
var Table = function (_a) {
    var id = _a.id, children = _a.children, isInline = _a.isInline, minWidth = _a.minWidth, _b = _a.withStickyColumn, withStickyColumn = _b === void 0 ? false : _b, _c = _a.withScrollPagination, withScrollPagination = _c === void 0 ? false : _c, _d = _a.disableHoverEffect, disableHoverEffect = _d === void 0 ? false : _d;
    var scrollRef = useRef(null);
    var _e = useWidth(), widthDivRef = _e[0], viewportWidth = _e[1];
    var _f = useState([]), columnState = _f[0], setColumnState = _f[1];
    var colors = useTableColors();
    var getColumnState = useCallback(function (index) {
        return columnState[index] || {};
    }, [columnState]);
    var tableContextValue = useMemo(function () { return ({
        getColumnState: getColumnState,
        isInline: isInline,
        setColumnState: setColumnState
    }); }, [isInline, getColumnState, setColumnState]);
    var useWidthDiv = withStickyColumn || withScrollPagination;
    var hasScrollableContent = viewportWidth < minWidth;
    var showStickyColumn = withStickyColumn && hasScrollableContent;
    var TableComponent = showStickyColumn
        ? StyledTableWithStickyColumn
        : StyledTable;
    return (React__default.createElement("div", { style: { position: "relative" } },
        withScrollPagination && (React__default.createElement(ColumnPagination$1, { minWidth: minWidth, scrollRef: scrollRef, columnState: columnState, viewportWidth: viewportWidth, withStickyColumn: withStickyColumn })),
        React__default.createElement(StyledTableWrapper, { ref: scrollRef },
            React__default.createElement(Typography, { textToken: "text-style/text/paragraphs/default/regular" },
                React__default.createElement("div", { style: { minWidth: minWidth ? "".concat(minWidth, "px") : "100%" } },
                    React__default.createElement(TableComponent, { id: id, isInline: isInline, disableHoverEffect: disableHoverEffect, colors: colors },
                        React__default.createElement(TableContext.Provider, { value: tableContextValue }, children))))),
        useWidthDiv && (React__default.createElement("div", { ref: widthDivRef, style: { height: 0 }, "data-testid": "mpui-table-width-checker" }))));
};
Table.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    disableHoverEffect: PropTypes.bool,
    id: PropTypes.string,
    isInline: PropTypes.bool,
    minWidth: PropTypes.number,
    withScrollPagination: PropTypes.bool,
    withStickyColumn: PropTypes.bool
};
var index = React__default.memo(Table);

var commonTagStyles = function () { return css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-color: ", ";\n  border-style: solid;\n  border-width: 1px;\n  cursor: pointer;\n  display: flex;\n  float: left;\n  position: relative;\n  transition:\n    background-color 0.2s ease 0s,\n    border-color 0.2s ease 0s;\n  user-select: none;\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-color: ", ";\n  border-style: solid;\n  border-width: 1px;\n  cursor: pointer;\n  display: flex;\n  float: left;\n  position: relative;\n  transition:\n    background-color 0.2s ease 0s,\n    border-color 0.2s ease 0s;\n  user-select: none;\n  &:hover {\n    background: ", ";\n  }\n"])), function (_a) {
    var isActive = _a.isActive, colors = _a.colors;
    return isActive ? colors.bgActive : colors.bgDefault;
}, function (_a) {
    var colors = _a.colors;
    return colors.border;
}, function (_a) {
    var isActive = _a.isActive, colors = _a.colors;
    return isActive ? colors.bgActiveHovered : colors.bgDefaultHovered;
}); };
var StyledTagWithText = styled.div(function () { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: ", ";\n    min-height: 40px;\n    padding: 6px 15px;\n    ", "\n  "], ["\n    border-radius: ", ";\n    min-height: 40px;\n    padding: 6px 15px;\n    ", "\n  "])), useCornerRadius("round"), commonTagStyles); });
var StyledTagOnlyEmoji = styled.div(function () { return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-radius: ", ";\n    justify-content: center;\n    min-height: 50px;\n    width: 50px;\n    ", "\n  "], ["\n    border-radius: ", ";\n    justify-content: center;\n    min-height: 50px;\n    width: 50px;\n    ", "\n  "])), useCornerRadius("round"), commonTagStyles); });
/** A simple tag component with support for custom emojis and an active state */
var Tag = function (_a) {
    var emoji = _a.emoji, id = _a.id, isActive = _a.isActive, label = _a.label, onClick = _a.onClick, showOnlyEmoji = _a.showOnlyEmoji, value = _a.value;
    var designContext = useDesignContext();
    var tagColors = {
        border: designContext.get("colors/borders/neutral").toString(),
        bgActive: designContext.get("colors/backgrounds/inverse").toString(),
        bgActiveHovered: designContext
            .get("colors/backgrounds/inverse", { interactiveState: "hovered" })
            .toString(),
        bgDefault: designContext.get("colors/backgrounds/default").toString(),
        bgDefaultHovered: designContext
            .get("colors/backgrounds/default", { interactiveState: "hovered" })
            .toString()
    };
    return (React__default.createElement(React__default.Fragment, null, showOnlyEmoji ? (React__default.createElement(Tooltip, { text: label || value.toString() },
        React__default.createElement(StyledTagOnlyEmoji, { "data-active": isActive, "data-value": value, colors: tagColors, id: id, isActive: isActive, onClick: onClick }, emoji && React__default.createElement(PrettyEmoji, { emoji: emoji, size: 30 })))) : (React__default.createElement(StyledTagWithText, { "data-active": isActive, "data-value": value, colors: tagColors, id: id, isActive: isActive, onClick: onClick },
        emoji && React__default.createElement(PrettyEmoji, { emoji: emoji }),
        emoji && React__default.createElement(SpacerHorizontal, { spaceToken: "space.200" }),
        React__default.createElement(Typography, { colorToken: isActive ? "colors/text/inverse" : "colors/text/default" }, label || value)))));
};
Tag.propTypes = {
    emoji: PropTypes.string,
    id: PropTypes.string,
    isActive: PropTypes.bool,
    label: PropTypes.string,
    onClick: PropTypes.func,
    showOnlyEmoji: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
var templateObject_1$1, templateObject_2, templateObject_3;

/** A tag selector, that shows options with emoji support and handles logic for selecting and deselecting options. It accepts an onChange function. */
var TagMultiSelector = function (_a) {
    var id = _a.id, onChange = _a.onChange, options = _a.options, values = _a.values, showOnlyEmoji = _a.showOnlyEmoji;
    var _b = useState(values || []), selectedValues = _b[0], setSelectedValues = _b[1];
    var _c = useState([]), tagOptions = _c[0], setTagOptions = _c[1];
    var didMount = useRef(false);
    useEffect(function () {
        if (onChange && didMount.current) {
            onChange(selectedValues);
        }
        setTagOptions(tagOptions.map(function (option) { return (__assign(__assign({}, option), { isActive: selectedValues.includes(option.value) })); }));
    }, [selectedValues]);
    useEffect(function () {
        if (didMount.current) {
            setSelectedValues(values || []);
        }
        if (options) {
            setTagOptions(options.map(function (option) { return (__assign(__assign({}, option), { isActive: selectedValues.includes(option.value) })); }));
        }
        didMount.current = true;
    }, [values, options]);
    var toggleTag = function (value) { return function () {
        var currentValues = __spreadArray([], selectedValues, true);
        if (currentValues.includes(value)) {
            var tagIndex = currentValues.indexOf(value);
            currentValues.splice(tagIndex, 1);
            setSelectedValues(currentValues);
        }
        else {
            currentValues.push(value);
            setSelectedValues(currentValues);
        }
    }; };
    return (React__default.createElement(Flex, { spacing: "space.100", id: id }, tagOptions.map(function (_a, i) {
        var emoji = _a.emoji, tagId = _a.id, label = _a.label, value = _a.value;
        return (React__default.createElement(Tag, { emoji: emoji, id: tagId, isActive: selectedValues.includes(value), key: i, label: label, onClick: toggleTag(value), showOnlyEmoji: showOnlyEmoji, value: value }));
    })));
};
TagMultiSelector.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    showOnlyEmoji: PropTypes.bool
};

/** A tag selector, that shows options with emoji support and handles logic for selecting and deselecting options. Only one option can be selected. It accepts an onChange function. */
var TagSelector = function (_a) {
    var id = _a.id, onChange = _a.onChange, options = _a.options, showOnlyEmoji = _a.showOnlyEmoji, value = _a.value;
    var _b = useState(value || ""), selectedValue = _b[0], setSelectedValue = _b[1];
    var _c = useState([]), tagOptions = _c[0], setTagOptions = _c[1];
    var didMount = useRef(false);
    useEffect(function () {
        if (onChange && didMount.current) {
            onChange(selectedValue);
        }
    }, [selectedValue, onChange]);
    useEffect(function () {
        if (didMount.current) {
            setSelectedValue(value || "");
        }
        if (options) {
            setTagOptions(options.map(function (option) { return (__assign(__assign({}, option), { isActive: selectedValue === option.value })); }));
        }
        didMount.current = true;
    }, [value, options]);
    var toggleTag = function (newValue) { return function () {
        if (selectedValue === newValue) {
            setSelectedValue("");
            value = "";
        }
        else {
            setSelectedValue(newValue);
            value = newValue;
        }
    }; };
    var isMobile = useResponsiveContext().isMobile;
    return (React__default.createElement(Flex, { spacing: showOnlyEmoji && !isMobile ? "space.200" : "space.50", id: id }, tagOptions.map(function (_a, i) {
        var emoji = _a.emoji, tagId = _a.id, label = _a.label, tagValue = _a.value;
        return (React__default.createElement(Tag, { emoji: emoji, id: tagId, isActive: tagValue === selectedValue, key: i, label: label, onClick: toggleTag(tagValue), showOnlyEmoji: showOnlyEmoji, value: tagValue }));
    })));
};
TagSelector.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    showOnlyEmoji: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var StyledTextAreaContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   {\n    position: relative;\n  }\n"], ["\n   {\n    position: relative;\n  }\n"])));
var StyledTextArea = styled.textarea(function (_a) {
    var fixedWidth = _a.fixedWidth, fixedHeight = _a.fixedHeight, hasError = _a.hasError, hasWarning = _a.hasWarning, background = _a.background, outline = _a.outline;
    return ({
        backgroundColor: hasError
            ? background.error
            : hasWarning
                ? background.warning
                : background.default,
        borderColor: background.neutral,
        borderRadius: useCornerRadius("s"),
        boxSizing: "border-box",
        fontSize: "16px",
        height: fixedHeight,
        maxHeight: fixedHeight,
        maxWidth: "100%",
        minHeight: fixedHeight,
        minWidth: fixedWidth,
        outlineColor: hasError
            ? outline.error
            : hasWarning
                ? outline.warning
                : outline.default,
        padding: "30px 15px 12px",
        resize: !fixedHeight && !fixedWidth
            ? "both"
            : fixedHeight && fixedWidth
                ? "none"
                : fixedHeight
                    ? "horizontal"
                    : "vertical",
        width: fixedWidth,
        zIndex: 1
    });
});
var StyledTextAreaLabel = styled.label(function (_a) {
    var hasContent = _a.hasContent;
    return ({
        backgroundColor: "transparent",
        left: "15px",
        position: "absolute",
        top: hasContent ? "12px" : "20px",
        zIndex: 0
    });
});
/** A TextArea component with Klarna's look and feel. It has error and warning states,
 * a maximum length reached warning state. It can also have fixed width and height.
 * It is resizable vertically, and not resizable when fixed height is passed.
 */
var TextArea = function (_a) {
    var id = _a.id, errorLabel = _a.errorLabel, hasError = _a.hasError, hasWarning = _a.hasWarning, height = _a.height, label = _a.label, maxLength = _a.maxLength, maxLengthWarningLabel = _a.maxLengthWarningLabel, onChange = _a.onChange, onBlur = _a.onBlur, value = _a.value, warningLabel = _a.warningLabel, width = _a.width;
    var _b = useState(value || ""), textAreaValue = _b[0], setTextAreaValue = _b[1];
    var _c = useState(label || ""), textAreaLabel = _c[0], setTextAreaLabel = _c[1];
    var _d = useState(false), hasMaxLengthWarning = _d[0], setHasMaxLengthWarning = _d[1];
    var designContext = useDesignContext();
    useEffect(function () {
        if (value) {
            setTextAreaValue(value.substring(0, maxLength || value.length));
        }
    }, [value]);
    useEffect(function () {
        if (hasError) {
            if (errorLabel) {
                setTextAreaLabel(errorLabel);
            }
        }
        else {
            if (hasWarning) {
                if (warningLabel) {
                    setTextAreaLabel(warningLabel);
                }
            }
            else {
                if (hasMaxLengthWarning) {
                    if (maxLengthWarningLabel) {
                        setTextAreaLabel(maxLengthWarningLabel);
                    }
                }
                else {
                    setTextAreaLabel(label);
                }
            }
        }
    }, [
        errorLabel,
        warningLabel,
        label,
        maxLengthWarningLabel,
        hasWarning,
        hasError,
        hasMaxLengthWarning
    ]);
    useEffect(function () {
        setHasMaxLengthWarning(maxLength && textAreaValue.length >= maxLength);
        if (onChange) {
            onChange(textAreaValue);
        }
    }, [textAreaValue]);
    var handleTextareaChange = function (e) {
        setTextAreaValue(e.target.value);
    };
    var handleBlur = function (e) {
        onBlur(e.target.value);
    };
    var labelProps = {
        correctFootprint: true,
        error: hasError,
        light: true,
        warning: hasWarning
    };
    var textAreaColor = React__default.useMemo(function () { return ({
        background: {
            default: designContext.get("colors/backgrounds/default").toString(),
            error: designContext.get("colors/backgrounds/error-inline").toString(),
            neutral: designContext.get("colors/backgrounds/neutral").toString(),
            warning: designContext
                .get("colors/backgrounds/warning-inline")
                .toString()
        },
        outline: {
            default: designContext.get("colors/borders/default").toString(),
            error: designContext.get("colors/borders/error").toString(),
            neutral: designContext.get("colors/borders/neutral").toString(),
            warning: designContext.get("colors/borders/warning").toString()
        }
    }); }, []);
    return (React__default.createElement(StyledTextAreaContainer, { id: id },
        React__default.createElement(StyledTextAreaLabel, { htmlFor: "".concat(id ? id + "-textarea" : "mpux-textarea"), hasContent: textAreaValue.length > 0 },
            React__default.createElement(Flex, { alignItems: "center", spacing: "space.50" },
                (hasWarning || hasMaxLengthWarning) && !hasError && (React__default.createElement(IconWarningStyled, { colorToken: "colors/borders/warning", "data-testid": "textarea-icon-warning" })),
                hasError && (React__default.createElement(IconErrorStyled$1, { colorToken: "colors/borders/error", "data-testid": "textarea-icon-error" })),
                textAreaValue.length > 0 ? (React__default.createElement(ParagraphTertiary, __assign({}, labelProps), textAreaLabel)) : (React__default.createElement(ParagraphSecondary, __assign({}, labelProps), textAreaLabel)))),
        React__default.createElement(Typography, { textToken: "text-style/text/paragraphs/default/regular" },
            React__default.createElement(StyledTextArea, __assign({ hasError: hasError, hasWarning: hasWarning || hasMaxLengthWarning, id: "".concat(id ? id + "-textarea" : "mpux-textarea"), maxLength: maxLength, fixedHeight: height, fixedWidth: width, value: textAreaValue, onChange: handleTextareaChange, onBlur: handleBlur }, textAreaColor)))));
};
TextArea.propTypes = {
    errorLabel: PropTypes.string,
    hasError: PropTypes.bool,
    hasWarning: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    id: PropTypes.string,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    maxLengthWarningLabel: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.string,
    warningLabel: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var templateObject_1;

/** A hook that uses the page visibility API to detect whether the current tab is active. */
var useTabVisibility = function () {
    var _a = useState(!document.hidden), isVisible = _a[0], setIsVisible = _a[1];
    var onVisibilityChange = function () { return setIsVisible(!document.hidden); };
    useEffect(function () {
        document.addEventListener("visibilitychange", onVisibilityChange, false);
        return function () {
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);
    return isVisible;
};

/**
 * Temporary solution until we review the usage of this demo component
 * in https://jira.int.klarna.net/jira/browse/MPUX-1215
 */
var DemoComponents = {
    ResponsiveContextProviderDemo: ResponsiveContextProviderDemo
};

export { ActivityIndicator, Article$1 as Article, AutoSuggest, index$5 as BlackCurtain, BodyAvatarCell$1 as BodyAvatarCell, BodyCheckboxCell$1 as BodyCheckboxCell, BodyCustomCell$1 as BodyCustomCell, BodyDigitCell$1 as BodyDigitCell, BodyDropdownCell$1 as BodyDropdownCell, BodyFieldCell$1 as BodyFieldCell, BodyLabelCell$1 as BodyLabelCell, BodyRow$1 as BodyRow, BodyTextCell$1 as BodyTextCell, Card, Chip, ChipInput, index$4 as Countdown, DemoComponents, DirectSelector, Divider, Flex, FloatingButton, FloatingCard, HeaderCheckboxCell$1 as HeaderCheckboxCell, HeaderInteractiveTextCell$1 as HeaderInteractiveTextCell, HeaderRow$1 as HeaderRow, HeaderTextCell$1 as HeaderTextCell, Layout, MPUIContextProvider, index$3 as Modal, index$2 as ModalSidebar, MultiSelector, Pagination, Portal, PrettyEmoji, index$1 as PricingTable, ResponsiveContextConsumer, ResponsiveContextProvider, SearchField, Selector, index as Table, TableBody$1 as TableBody, TagMultiSelector, TagSelector, TextArea, Themes, Tooltip, UIThemeProvider, index$7 as constants, useDesignContext, useGetToken, useInterval, useResponsiveContext, useResponsiveTokenValue, useTabVisibility, useThemeBreakpoints, useUIThemeContext, useWidth, index$6 as utils };
//# sourceMappingURL=index.js.map
